/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + chunkId + ".min.js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "web:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript && document.currentScript.tagName.toUpperCase() === 'SCRIPT')
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					var i = scripts.length - 1;
/******/ 					while (i > -1 && (!scriptUrl || !/^http(s?):/.test(scriptUrl))) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			104: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// UNUSED EXPORTS: GadgetDevHarness, sendErrorPrompt, shouldShowDeveloperError

;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/AnyClient.js
const $modelRelationships = Symbol.for("gadget/modelRelationships");
/**
 * Checks if the given object is an instance of any Gadget app's generated JS client object
 */
const isGadgetClient = (client) => {
    return client && "connection" in client && client.connection && "endpoint" in client.connection;
};
//# sourceMappingURL=AnyClient.js.map
;// ../../node_modules/.pnpm/@0no-co+graphql.web@1.0.4_graphql@16.8.1/node_modules/@0no-co/graphql.web/dist/graphql.web.mjs
var graphql_web_e = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};

var graphql_web_r = {
  QUERY: "query",
  MUTATION: "mutation",
  SUBSCRIPTION: "subscription"
};

class GraphQLError extends Error {
  constructor(e, r, i, n, a, t, o) {
    super(e);
    this.name = "GraphQLError";
    this.message = e;
    if (a) {
      this.path = a;
    }
    if (r) {
      this.nodes = Array.isArray(r) ? r : [ r ];
    }
    if (i) {
      this.source = i;
    }
    if (n) {
      this.positions = n;
    }
    if (t) {
      this.originalError = t;
    }
    var l = o;
    if (!l && t) {
      var u = t.extensions;
      if (u && "object" == typeof u) {
        l = u;
      }
    }
    this.extensions = l || {};
  }
  toJSON() {
    return {
      ...this,
      message: this.message
    };
  }
  toString() {
    return this.message;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
}

var i;

var graphql_web_n;

function error(e) {
  return new GraphQLError(`Syntax Error: Unexpected token at ${graphql_web_n} in ${e}`);
}

function advance(e) {
  e.lastIndex = graphql_web_n;
  if (e.test(i)) {
    return i.slice(graphql_web_n, graphql_web_n = e.lastIndex);
  }
}

var graphql_web_a = / +(?=[^\s])/y;

function blockString(e) {
  var r = e.split("\n");
  var i = "";
  var n = 0;
  var t = 0;
  var o = r.length - 1;
  for (var l = 0; l < r.length; l++) {
    graphql_web_a.lastIndex = 0;
    if (graphql_web_a.test(r[l])) {
      if (l && (!n || graphql_web_a.lastIndex < n)) {
        n = graphql_web_a.lastIndex;
      }
      t = t || l;
      o = l;
    }
  }
  for (var u = t; u <= o; u++) {
    if (u !== t) {
      i += "\n";
    }
    i += r[u].slice(n).replace(/\\"""/g, '"""');
  }
  return i;
}

function ignored() {
  for (var e = 0 | i.charCodeAt(graphql_web_n++); 9 === e || 10 === e || 13 === e || 32 === e || 35 === e || 44 === e || 65279 === e; e = 0 | i.charCodeAt(graphql_web_n++)) {
    if (35 === e) {
      while (10 !== (e = i.charCodeAt(graphql_web_n++)) && 13 !== e) {}
    }
  }
  graphql_web_n--;
}

var graphql_web_t = /[_A-Za-z]\w*/y;

function graphql_web_name() {
  var e;
  if (e = advance(graphql_web_t)) {
    return {
      kind: "Name",
      value: e
    };
  }
}

var o = /(?:null|true|false)/y;

var l = /\$[_A-Za-z]\w*/y;

var u = /-?\d+/y;

var v = /(?:\.\d+)?[eE][+-]?\d+|\.\d+/y;

var d = /\\/g;

var s = /"""(?:"""|(?:[\s\S]*?[^\\])""")/y;

var c = /"(?:"|[^\r\n]*?[^\\]")/y;

function value(e) {
  var r;
  var a;
  if (a = advance(o)) {
    r = "null" === a ? {
      kind: "NullValue"
    } : {
      kind: "BooleanValue",
      value: "true" === a
    };
  } else if (!e && (a = advance(l))) {
    r = {
      kind: "Variable",
      name: {
        kind: "Name",
        value: a.slice(1)
      }
    };
  } else if (a = advance(u)) {
    var f = a;
    if (a = advance(v)) {
      r = {
        kind: "FloatValue",
        value: f + a
      };
    } else {
      r = {
        kind: "IntValue",
        value: f
      };
    }
  } else if (a = advance(graphql_web_t)) {
    r = {
      kind: "EnumValue",
      value: a
    };
  } else if (a = advance(s)) {
    r = {
      kind: "StringValue",
      value: blockString(a.slice(3, -3)),
      block: !0
    };
  } else if (a = advance(c)) {
    r = {
      kind: "StringValue",
      value: d.test(a) ? JSON.parse(a) : a.slice(1, -1),
      block: !1
    };
  } else if (r = function list(e) {
    var r;
    if (91 === i.charCodeAt(graphql_web_n)) {
      graphql_web_n++;
      ignored();
      var a = [];
      while (r = value(e)) {
        a.push(r);
      }
      if (93 !== i.charCodeAt(graphql_web_n++)) {
        throw error("ListValue");
      }
      ignored();
      return {
        kind: "ListValue",
        values: a
      };
    }
  }(e) || function object(e) {
    if (123 === i.charCodeAt(graphql_web_n)) {
      graphql_web_n++;
      ignored();
      var r = [];
      var a;
      while (a = graphql_web_name()) {
        ignored();
        if (58 !== i.charCodeAt(graphql_web_n++)) {
          throw error("ObjectField");
        }
        ignored();
        var t = value(e);
        if (!t) {
          throw error("ObjectField");
        }
        r.push({
          kind: "ObjectField",
          name: a,
          value: t
        });
      }
      if (125 !== i.charCodeAt(graphql_web_n++)) {
        throw error("ObjectValue");
      }
      ignored();
      return {
        kind: "ObjectValue",
        fields: r
      };
    }
  }(e)) {
    return r;
  }
  ignored();
  return r;
}

function arguments_(e) {
  var r = [];
  ignored();
  if (40 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    var a;
    while (a = graphql_web_name()) {
      ignored();
      if (58 !== i.charCodeAt(graphql_web_n++)) {
        throw error("Argument");
      }
      ignored();
      var t = value(e);
      if (!t) {
        throw error("Argument");
      }
      r.push({
        kind: "Argument",
        name: a,
        value: t
      });
    }
    if (!r.length || 41 !== i.charCodeAt(graphql_web_n++)) {
      throw error("Argument");
    }
    ignored();
  }
  return r;
}

function directives(e) {
  var r = [];
  ignored();
  while (64 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    var a = graphql_web_name();
    if (!a) {
      throw error("Directive");
    }
    ignored();
    r.push({
      kind: "Directive",
      name: a,
      arguments: arguments_(e)
    });
  }
  return r;
}

function field() {
  var e = graphql_web_name();
  if (e) {
    ignored();
    var r;
    if (58 === i.charCodeAt(graphql_web_n)) {
      graphql_web_n++;
      ignored();
      r = e;
      if (!(e = graphql_web_name())) {
        throw error("Field");
      }
      ignored();
    }
    return {
      kind: "Field",
      alias: r,
      name: e,
      arguments: arguments_(!1),
      directives: directives(!1),
      selectionSet: selectionSet()
    };
  }
}

function type() {
  var e;
  ignored();
  if (91 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    var r = type();
    if (!r || 93 !== i.charCodeAt(graphql_web_n++)) {
      throw error("ListType");
    }
    e = {
      kind: "ListType",
      type: r
    };
  } else if (e = graphql_web_name()) {
    e = {
      kind: "NamedType",
      name: e
    };
  } else {
    throw error("NamedType");
  }
  ignored();
  if (33 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    return {
      kind: "NonNullType",
      type: e
    };
  } else {
    return e;
  }
}

var f = /on/y;

function typeCondition() {
  if (advance(f)) {
    ignored();
    var e = graphql_web_name();
    if (!e) {
      throw error("NamedType");
    }
    ignored();
    return {
      kind: "NamedType",
      name: e
    };
  }
}

var p = /\.\.\./y;

function fragmentSpread() {
  if (advance(p)) {
    ignored();
    var e = graphql_web_n;
    var r;
    if ((r = graphql_web_name()) && "on" !== r.value) {
      return {
        kind: "FragmentSpread",
        name: r,
        directives: directives(!1)
      };
    } else {
      graphql_web_n = e;
      var i = typeCondition();
      var a = directives(!1);
      var t = selectionSet();
      if (!t) {
        throw error("InlineFragment");
      }
      return {
        kind: "InlineFragment",
        typeCondition: i,
        directives: a,
        selectionSet: t
      };
    }
  }
}

function selectionSet() {
  var e;
  ignored();
  if (123 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    var r = [];
    while (e = fragmentSpread() || field()) {
      r.push(e);
    }
    if (!r.length || 125 !== i.charCodeAt(graphql_web_n++)) {
      throw error("SelectionSet");
    }
    ignored();
    return {
      kind: "SelectionSet",
      selections: r
    };
  }
}

var graphql_web_m = /fragment/y;

function fragmentDefinition() {
  if (advance(graphql_web_m)) {
    ignored();
    var e = graphql_web_name();
    if (!e) {
      throw error("FragmentDefinition");
    }
    ignored();
    var r = typeCondition();
    if (!r) {
      throw error("FragmentDefinition");
    }
    var i = directives(!1);
    var n = selectionSet();
    if (!n) {
      throw error("FragmentDefinition");
    }
    return {
      kind: "FragmentDefinition",
      name: e,
      typeCondition: r,
      directives: i,
      selectionSet: n
    };
  }
}

var g = /(?:query|mutation|subscription)/y;

function operationDefinition() {
  var e;
  var r;
  var a = [];
  var t = [];
  if (e = advance(g)) {
    ignored();
    r = graphql_web_name();
    a = function variableDefinitions() {
      var e;
      var r = [];
      ignored();
      if (40 === i.charCodeAt(graphql_web_n)) {
        graphql_web_n++;
        ignored();
        while (e = advance(l)) {
          ignored();
          if (58 !== i.charCodeAt(graphql_web_n++)) {
            throw error("VariableDefinition");
          }
          var a = type();
          var t = void 0;
          if (61 === i.charCodeAt(graphql_web_n)) {
            graphql_web_n++;
            ignored();
            if (!(t = value(!0))) {
              throw error("VariableDefinition");
            }
          }
          ignored();
          r.push({
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: e.slice(1)
              }
            },
            type: a,
            defaultValue: t,
            directives: directives(!0)
          });
        }
        if (41 !== i.charCodeAt(graphql_web_n++)) {
          throw error("VariableDefinition");
        }
        ignored();
      }
      return r;
    }();
    t = directives(!1);
  }
  var o = selectionSet();
  if (o) {
    return {
      kind: "OperationDefinition",
      operation: e || "query",
      name: r,
      variableDefinitions: a,
      directives: t,
      selectionSet: o
    };
  }
}

function parse(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  graphql_web_n = 0;
  return function document() {
    var e;
    ignored();
    var r = [];
    while (e = fragmentDefinition() || operationDefinition()) {
      r.push(e);
    }
    return {
      kind: "Document",
      definitions: r
    };
  }();
}

function parseValue(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  graphql_web_n = 0;
  ignored();
  var a = value(!1);
  if (!a) {
    throw error("ValueNode");
  }
  return a;
}

function parseType(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  graphql_web_n = 0;
  return type();
}

var h = {};

function visit(e, r) {
  var i = [];
  var n = [];
  try {
    var a = function traverse(e, a, t) {
      var o = !1;
      var l = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
      var u = l && l.call(r, e, a, t, n, i);
      if (!1 === u) {
        return e;
      } else if (null === u) {
        return null;
      } else if (u === h) {
        throw h;
      } else if (u && "string" == typeof u.kind) {
        o = u !== e;
        e = u;
      }
      if (t) {
        i.push(t);
      }
      var v;
      var d = {
        ...e
      };
      for (var s in e) {
        n.push(s);
        var c = e[s];
        if (Array.isArray(c)) {
          var f = [];
          for (var p = 0; p < c.length; p++) {
            if (null != c[p] && "string" == typeof c[p].kind) {
              i.push(e);
              n.push(p);
              v = traverse(c[p], p, c);
              n.pop();
              i.pop();
              if (null == v) {
                o = !0;
              } else {
                o = o || v !== c[p];
                f.push(v);
              }
            }
          }
          c = f;
        } else if (null != c && "string" == typeof c.kind) {
          if (void 0 !== (v = traverse(c, s, e))) {
            o = o || c !== v;
            c = v;
          }
        }
        n.pop();
        if (o) {
          d[s] = c;
        }
      }
      if (t) {
        i.pop();
      }
      var m = r[e.kind] && r[e.kind].leave || r.leave;
      var g = m && m.call(r, e, a, t, n, i);
      if (g === h) {
        throw h;
      } else if (void 0 !== g) {
        return g;
      } else if (void 0 !== u) {
        return o ? d : u;
      } else {
        return o ? d : e;
      }
    }(e);
    return void 0 !== a && !1 !== a ? a : e;
  } catch (r) {
    if (r !== h) {
      throw r;
    }
    return e;
  }
}

function printString(e) {
  return JSON.stringify(e);
}

function printBlockString(e) {
  return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}

var hasItems = e => !(!e || !e.length);

var graphql_web_y = {
  OperationDefinition(e) {
    if ("query" === e.operation && !e.name && !hasItems(e.variableDefinitions) && !hasItems(e.directives)) {
      return graphql_web_y.SelectionSet(e.selectionSet);
    }
    var r = e.operation;
    if (e.name) {
      r += " " + e.name.value;
    }
    if (hasItems(e.variableDefinitions)) {
      if (!e.name) {
        r += " ";
      }
      r += "(" + e.variableDefinitions.map(graphql_web_y.VariableDefinition).join(", ") + ")";
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(graphql_web_y.Directive).join(" ");
    }
    return r + " " + graphql_web_y.SelectionSet(e.selectionSet);
  },
  VariableDefinition(e) {
    var r = graphql_web_y.Variable(e.variable) + ": " + print(e.type);
    if (e.defaultValue) {
      r += " = " + print(e.defaultValue);
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(graphql_web_y.Directive).join(" ");
    }
    return r;
  },
  Field(e) {
    var r = (e.alias ? e.alias.value + ": " : "") + e.name.value;
    if (hasItems(e.arguments)) {
      var i = e.arguments.map(graphql_web_y.Argument);
      var n = r + "(" + i.join(", ") + ")";
      r = n.length > 80 ? r + "(\n  " + i.join("\n").replace(/\n/g, "\n  ") + "\n)" : n;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(graphql_web_y.Directive).join(" ");
    }
    return e.selectionSet ? r + " " + graphql_web_y.SelectionSet(e.selectionSet) : r;
  },
  StringValue: e => e.block ? printBlockString(e.value) : printString(e.value),
  BooleanValue: e => "" + e.value,
  NullValue: e => "null",
  IntValue: e => e.value,
  FloatValue: e => e.value,
  EnumValue: e => e.value,
  Name: e => e.value,
  Variable: e => "$" + e.name.value,
  ListValue: e => "[" + e.values.map(print).join(", ") + "]",
  ObjectValue: e => "{" + e.fields.map(graphql_web_y.ObjectField).join(", ") + "}",
  ObjectField: e => e.name.value + ": " + print(e.value),
  Document: e => hasItems(e.definitions) ? e.definitions.map(print).join("\n\n") : "",
  SelectionSet: e => "{\n  " + e.selections.map(print).join("\n").replace(/\n/g, "\n  ") + "\n}",
  Argument: e => e.name.value + ": " + print(e.value),
  FragmentSpread(e) {
    var r = "..." + e.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(graphql_web_y.Directive).join(" ");
    }
    return r;
  },
  InlineFragment(e) {
    var r = "...";
    if (e.typeCondition) {
      r += " on " + e.typeCondition.name.value;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(graphql_web_y.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  FragmentDefinition(e) {
    var r = "fragment " + e.name.value;
    r += " on " + e.typeCondition.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(graphql_web_y.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  Directive(e) {
    var r = "@" + e.name.value;
    if (hasItems(e.arguments)) {
      r += "(" + e.arguments.map(graphql_web_y.Argument).join(", ") + ")";
    }
    return r;
  },
  NamedType: e => e.name.value,
  ListType: e => "[" + print(e.type) + "]",
  NonNullType: e => print(e.type) + "!"
};

function print(e) {
  return graphql_web_y[e.kind] ? graphql_web_y[e.kind](e) : "";
}

function valueFromASTUntyped(e, r) {
  switch (e.kind) {
   case "NullValue":
    return null;

   case "IntValue":
    return parseInt(e.value, 10);

   case "FloatValue":
    return parseFloat(e.value);

   case "StringValue":
   case "EnumValue":
   case "BooleanValue":
    return e.value;

   case "ListValue":
    var i = [];
    for (var n = 0, a = e.values; n < a.length; n += 1) {
      i.push(valueFromASTUntyped(a[n], r));
    }
    return i;

   case "ObjectValue":
    var t = Object.create(null);
    for (var o = 0, l = e.fields; o < l.length; o += 1) {
      var u = l[o];
      t[u.name.value] = valueFromASTUntyped(u.value, r);
    }
    return t;

   case "Variable":
    return r && r[e.name.value];
  }
}

function valueFromTypeNode(e, r, i) {
  if ("Variable" === e.kind) {
    return i ? valueFromTypeNode(i[e.name.value], r, i) : void 0;
  } else if ("NonNullType" === r.kind) {
    return "NullValue" !== e.kind ? valueFromTypeNode(e, r, i) : void 0;
  } else if ("NullValue" === e.kind) {
    return null;
  } else if ("ListType" === r.kind) {
    if ("ListValue" === e.kind) {
      var n = [];
      for (var a = 0, t = e.values; a < t.length; a += 1) {
        var o = valueFromTypeNode(t[a], r.type, i);
        if (void 0 === o) {
          return;
        } else {
          n.push(o);
        }
      }
      return n;
    }
  } else if ("NamedType" === r.kind) {
    switch (r.name.value) {
     case "Int":
     case "Float":
     case "String":
     case "Bool":
      return r.name.value + "Value" === e.kind ? valueFromASTUntyped(e, i) : void 0;

     default:
      return valueFromASTUntyped(e, i);
    }
  }
}


//# sourceMappingURL=graphql.web.mjs.map

;// ../../node_modules/.pnpm/wonka@6.3.2/node_modules/wonka/dist/wonka.mjs
var teardownPlaceholder = () => {};

var wonka_e = teardownPlaceholder;

function start(e) {
  return {
    tag: 0,
    0: e
  };
}

function push(e) {
  return {
    tag: 1,
    0: e
  };
}

var identity = e => e;

function buffer(r) {
  return t => i => {
    var a = [];
    var f = wonka_e;
    var n = wonka_e;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        n(1);
        if (a.length) {
          i(push(a));
        }
        i(0);
      } else if (0 === e.tag) {
        f = e[0];
        r((e => {
          if (l) {} else if (0 === e) {
            l = !0;
            f(1);
            if (a.length) {
              i(push(a));
            }
            i(0);
          } else if (0 === e.tag) {
            n = e[0];
          } else if (a.length) {
            var r = push(a);
            a = [];
            i(r);
          }
        }));
      } else {
        a.push(e[0]);
        if (!s) {
          s = !0;
          f(0);
          n(0);
        } else {
          s = !1;
        }
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        f(1);
        n(1);
      } else if (!l && !s) {
        s = !0;
        f(0);
        n(0);
      }
    })));
  };
}

function concatMap(r) {
  return t => i => {
    var a = [];
    var f = wonka_e;
    var n = wonka_e;
    var s = !1;
    var l = !1;
    var u = !1;
    var o = !1;
    function applyInnerSource(e) {
      u = !0;
      e((e => {
        if (0 === e) {
          if (u) {
            u = !1;
            if (a.length) {
              applyInnerSource(r(a.shift()));
            } else if (o) {
              i(0);
            } else if (!s) {
              s = !0;
              f(0);
            }
          }
        } else if (0 === e.tag) {
          l = !1;
          (n = e[0])(0);
        } else if (u) {
          i(e);
          if (l) {
            l = !1;
          } else {
            n(0);
          }
        }
      }));
    }
    t((e => {
      if (o) {} else if (0 === e) {
        o = !0;
        if (!u && !a.length) {
          i(0);
        }
      } else if (0 === e.tag) {
        f = e[0];
      } else {
        s = !1;
        if (u) {
          a.push(e[0]);
        } else {
          applyInnerSource(r(e[0]));
        }
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!o) {
          o = !0;
          f(1);
        }
        if (u) {
          u = !1;
          n(1);
        }
      } else {
        if (!o && !s) {
          s = !0;
          f(0);
        }
        if (u && !l) {
          l = !0;
          n(0);
        }
      }
    })));
  };
}

function concatAll(e) {
  return concatMap(identity)(e);
}

function concat(e) {
  return concatAll(wonka_r(e));
}

function wonka_filter(r) {
  return t => i => {
    var a = wonka_e;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (!r(e[0])) {
        a(0);
      } else {
        i(e);
      }
    }));
  };
}

function map(e) {
  return r => t => r((r => {
    if (0 === r || 0 === r.tag) {
      t(r);
    } else {
      t(push(e(r[0])));
    }
  }));
}

function mergeMap(r) {
  return t => i => {
    var a = [];
    var f = wonka_e;
    var n = !1;
    var s = !1;
    t((t => {
      if (s) {} else if (0 === t) {
        s = !0;
        if (!a.length) {
          i(0);
        }
      } else if (0 === t.tag) {
        f = t[0];
      } else {
        n = !1;
        !function applyInnerSource(r) {
          var t = wonka_e;
          r((e => {
            if (0 === e) {
              if (a.length) {
                var r = a.indexOf(t);
                if (r > -1) {
                  (a = a.slice()).splice(r, 1);
                }
                if (!a.length) {
                  if (s) {
                    i(0);
                  } else if (!n) {
                    n = !0;
                    f(0);
                  }
                }
              }
            } else if (0 === e.tag) {
              a.push(t = e[0]);
              t(0);
            } else if (a.length) {
              i(e);
              t(0);
            }
          }));
        }(r(t[0]));
        if (!n) {
          n = !0;
          f(0);
        }
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!s) {
          s = !0;
          f(1);
        }
        for (var r = 0, t = a, i = a.length; r < i; r++) {
          t[r](1);
        }
        a.length = 0;
      } else {
        if (!s && !n) {
          n = !0;
          f(0);
        } else {
          n = !1;
        }
        for (var l = 0, u = a, o = a.length; l < o; l++) {
          u[l](0);
        }
      }
    })));
  };
}

function mergeAll(e) {
  return mergeMap(identity)(e);
}

function merge(e) {
  return mergeAll(wonka_r(e));
}

function onEnd(e) {
  return r => t => {
    var i = !1;
    r((r => {
      if (i) {} else if (0 === r) {
        i = !0;
        t(0);
        e();
      } else if (0 === r.tag) {
        var a = r[0];
        t(start((r => {
          if (1 === r) {
            i = !0;
            a(1);
            e();
          } else {
            a(r);
          }
        })));
      } else {
        t(r);
      }
    }));
  };
}

function onPush(e) {
  return r => t => {
    var i = !1;
    r((r => {
      if (i) {} else if (0 === r) {
        i = !0;
        t(0);
      } else if (0 === r.tag) {
        var a = r[0];
        t(start((e => {
          if (1 === e) {
            i = !0;
          }
          a(e);
        })));
      } else {
        e(r[0]);
        t(r);
      }
    }));
  };
}

function onStart(e) {
  return r => t => r((r => {
    if (0 === r) {
      t(0);
    } else if (0 === r.tag) {
      t(r);
      e();
    } else {
      t(r);
    }
  }));
}

function sample(r) {
  return t => i => {
    var a = wonka_e;
    var f = wonka_e;
    var n;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        f(1);
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
      } else {
        n = e[0];
        if (!s) {
          s = !0;
          f(0);
          a(0);
        } else {
          s = !1;
        }
      }
    }));
    r((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        a(1);
        i(0);
      } else if (0 === e.tag) {
        f = e[0];
      } else if (void 0 !== n) {
        var r = push(n);
        n = void 0;
        i(r);
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        f(1);
      } else if (!l && !s) {
        s = !0;
        a(0);
        f(0);
      }
    })));
  };
}

function scan(e, r) {
  return t => i => {
    var a = r;
    t((r => {
      if (0 === r) {
        i(0);
      } else if (0 === r.tag) {
        i(r);
      } else {
        i(push(a = e(a, r[0])));
      }
    }));
  };
}

function share(r) {
  var t = [];
  var i = wonka_e;
  var a = !1;
  return e => {
    t.push(e);
    if (1 === t.length) {
      r((e => {
        if (0 === e) {
          for (var r = 0, f = t, n = t.length; r < n; r++) {
            f[r](0);
          }
          t.length = 0;
        } else if (0 === e.tag) {
          i = e[0];
        } else {
          a = !1;
          for (var s = 0, l = t, u = t.length; s < u; s++) {
            l[s](e);
          }
        }
      }));
    }
    e(start((r => {
      if (1 === r) {
        var f = t.indexOf(e);
        if (f > -1) {
          (t = t.slice()).splice(f, 1);
        }
        if (!t.length) {
          i(1);
        }
      } else if (!a) {
        a = !0;
        i(0);
      }
    })));
  };
}

function skip(r) {
  return t => i => {
    var a = wonka_e;
    var f = r;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (f-- > 0) {
        a(0);
      } else {
        i(e);
      }
    }));
  };
}

function skipUntil(r) {
  return t => i => {
    var a = wonka_e;
    var f = wonka_e;
    var n = !0;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        if (n) {
          f(1);
        }
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {
            if (n) {
              l = !0;
              a(1);
            }
          } else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !1;
            f(1);
          }
        }));
      } else if (!n) {
        s = !1;
        i(e);
      } else if (!s) {
        s = !0;
        a(0);
        f(0);
      } else {
        s = !1;
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        if (n) {
          f(1);
        }
      } else if (!l && !s) {
        s = !0;
        if (n) {
          f(0);
        }
        a(0);
      }
    })));
  };
}

function skipWhile(r) {
  return t => i => {
    var a = wonka_e;
    var f = !0;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (f) {
        if (r(e[0])) {
          a(0);
        } else {
          f = !1;
          i(e);
        }
      } else {
        i(e);
      }
    }));
  };
}

function switchMap(r) {
  return t => i => {
    var a = wonka_e;
    var f = wonka_e;
    var n = !1;
    var s = !1;
    var l = !1;
    var u = !1;
    t((t => {
      if (u) {} else if (0 === t) {
        u = !0;
        if (!l) {
          i(0);
        }
      } else if (0 === t.tag) {
        a = t[0];
      } else {
        if (l) {
          f(1);
          f = wonka_e;
        }
        if (!n) {
          n = !0;
          a(0);
        } else {
          n = !1;
        }
        !function applyInnerSource(e) {
          l = !0;
          e((e => {
            if (!l) {} else if (0 === e) {
              l = !1;
              if (u) {
                i(0);
              } else if (!n) {
                n = !0;
                a(0);
              }
            } else if (0 === e.tag) {
              s = !1;
              (f = e[0])(0);
            } else {
              i(e);
              if (!s) {
                f(0);
              } else {
                s = !1;
              }
            }
          }));
        }(r(t[0]));
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!u) {
          u = !0;
          a(1);
        }
        if (l) {
          l = !1;
          f(1);
        }
      } else {
        if (!u && !n) {
          n = !0;
          a(0);
        }
        if (l && !s) {
          s = !0;
          f(0);
        }
      }
    })));
  };
}

function switchAll(e) {
  return switchMap(identity)(e);
}

function wonka_take(r) {
  return t => i => {
    var a = wonka_e;
    var f = !1;
    var n = 0;
    t((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        i(0);
      } else if (0 === e.tag) {
        if (r <= 0) {
          f = !0;
          i(0);
          e[0](1);
        } else {
          a = e[0];
        }
      } else if (n++ < r) {
        i(e);
        if (!f && n >= r) {
          f = !0;
          i(0);
          a(1);
        }
      } else {
        i(e);
      }
    }));
    i(start((e => {
      if (1 === e && !f) {
        f = !0;
        a(1);
      } else if (0 === e && !f && n < r) {
        a(0);
      }
    })));
  };
}

function takeLast(t) {
  return i => a => {
    var f = [];
    var n = wonka_e;
    i((e => {
      if (0 === e) {
        wonka_r(f)(a);
      } else if (0 === e.tag) {
        if (t <= 0) {
          e[0](1);
          wonka_r(f)(a);
        } else {
          (n = e[0])(0);
        }
      } else {
        if (f.length >= t && t) {
          f.shift();
        }
        f.push(e[0]);
        n(0);
      }
    }));
  };
}

function takeUntil(r) {
  return t => i => {
    var a = wonka_e;
    var f = wonka_e;
    var n = !1;
    t((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        f(1);
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {} else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !0;
            f(1);
            a(1);
            i(0);
          }
        }));
      } else {
        i(e);
      }
    }));
    i(start((e => {
      if (1 === e && !n) {
        n = !0;
        a(1);
        f(1);
      } else if (!n) {
        a(0);
      }
    })));
  };
}

function takeWhile(r, t) {
  return i => a => {
    var f = wonka_e;
    var n = !1;
    i((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        a(0);
      } else if (0 === e.tag) {
        f = e[0];
        a(e);
      } else if (!r(e[0])) {
        n = !0;
        if (t) {
          a(e);
        }
        a(0);
        f(1);
      } else {
        a(e);
      }
    }));
  };
}

function debounce(e) {
  return r => t => {
    var i;
    var a = !1;
    var f = !1;
    r((r => {
      if (f) {} else if (0 === r) {
        f = !0;
        if (i) {
          a = !0;
        } else {
          t(0);
        }
      } else if (0 === r.tag) {
        var n = r[0];
        t(start((e => {
          if (1 === e && !f) {
            f = !0;
            a = !1;
            if (i) {
              clearTimeout(i);
            }
            n(1);
          } else if (!f) {
            n(0);
          }
        })));
      } else {
        if (i) {
          clearTimeout(i);
        }
        i = setTimeout((() => {
          i = void 0;
          t(r);
          if (a) {
            t(0);
          }
        }), e(r[0]));
      }
    }));
  };
}

function delay(e) {
  return r => t => {
    var i = 0;
    r((r => {
      if (0 !== r && 0 === r.tag) {
        t(r);
      } else {
        i++;
        setTimeout((() => {
          if (i) {
            i--;
            t(r);
          }
        }), e);
      }
    }));
  };
}

function throttle(e) {
  return r => t => {
    var i = !1;
    var a;
    r((r => {
      if (0 === r) {
        if (a) {
          clearTimeout(a);
        }
        t(0);
      } else if (0 === r.tag) {
        var f = r[0];
        t(start((e => {
          if (1 === e) {
            if (a) {
              clearTimeout(a);
            }
            f(1);
          } else {
            f(0);
          }
        })));
      } else if (!i) {
        i = !0;
        if (a) {
          clearTimeout(a);
        }
        a = setTimeout((() => {
          a = void 0;
          i = !1;
        }), e(r[0]));
        t(r);
      }
    }));
  };
}

function lazy(e) {
  return r => e()(r);
}

function fromAsyncIterable(e) {
  return r => {
    var t = e[Symbol.asyncIterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((async e => {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i; ) {
          if ((n = await t.next()).done) {
            i = !0;
            if (t.return) {
              await t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!(await t.throw(e)).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return r => {
    var t = e[Symbol.iterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((e => {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i; ) {
          if ((n = t.next()).done) {
            i = !0;
            if (t.return) {
              t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!t.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

var wonka_r = fromIterable;

function fromValue(e) {
  return r => {
    var t = !1;
    r(start((i => {
      if (1 === i) {
        t = !0;
      } else if (!t) {
        t = !0;
        r(push(e));
        r(0);
      }
    })));
  };
}

function make(e) {
  return r => {
    var t = !1;
    var i = e({
      next(e) {
        if (!t) {
          r(push(e));
        }
      },
      complete() {
        if (!t) {
          t = !0;
          r(0);
        }
      }
    });
    r(start((e => {
      if (1 === e && !t) {
        t = !0;
        i();
      }
    })));
  };
}

function makeSubject() {
  var e;
  var r;
  return {
    source: share(make((t => {
      e = t.next;
      r = t.complete;
      return teardownPlaceholder;
    }))),
    next(r) {
      if (e) {
        e(r);
      }
    },
    complete() {
      if (r) {
        r();
      }
    }
  };
}

var empty = e => {
  var r = !1;
  e(start((t => {
    if (1 === t) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  })));
};

var never = r => {
  r(start(wonka_e));
};

function interval(e) {
  return make((r => {
    var t = 0;
    var i = setInterval((() => r.next(t++)), e);
    return () => clearInterval(i);
  }));
}

function fromDomEvent(e, r) {
  return make((t => {
    e.addEventListener(r, t.next);
    return () => e.removeEventListener(r, t.next);
  }));
}

function fromPromise(e) {
  return make((r => {
    e.then((e => {
      Promise.resolve(e).then((() => {
        r.next(e);
        r.complete();
      }));
    }));
    return teardownPlaceholder;
  }));
}

function subscribe(r) {
  return t => {
    var i = wonka_e;
    var a = !1;
    t((e => {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else if (!a) {
        r(e[0]);
        i(0);
      }
    }));
    return {
      unsubscribe() {
        if (!a) {
          a = !0;
          i(1);
        }
      }
    };
  };
}

function forEach(e) {
  return r => {
    subscribe(e)(r);
  };
}

function publish(e) {
  subscribe((e => {}))(e);
}

var wonka_t = {
  done: !0
};

var wonka_toAsyncIterable = r => ({
  [Symbol.asyncIterator]() {
    var i = [];
    var a = !1;
    var f = wonka_e;
    var n;
    r((e => {
      if (a) {} else if (0 === e) {
        if (n) {
          n = n(wonka_t);
        }
        a = !0;
      } else if (0 === e.tag) {
        (f = e[0])(0);
      } else if (n) {
        n = n({
          value: e[0],
          done: !1
        });
      } else {
        i.push(e[0]);
      }
    }));
    return {
      async next() {
        if (a && !i.length) {
          return wonka_t;
        } else if (!a && i.length <= 1) {
          f(0);
        }
        return i.length ? {
          value: i.shift(),
          done: !1
        } : new Promise((e => n = e));
      },
      async return() {
        if (!a) {
          n = f(1);
        }
        a = !0;
        return wonka_t;
      }
    };
  }
});

function toArray(r) {
  var t = [];
  var i = wonka_e;
  var a = !1;
  r((e => {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (i = e[0])(0);
    } else {
      t.push(e[0]);
      i(0);
    }
  }));
  if (!a) {
    i(1);
  }
  return t;
}

function wonka_toPromise(r) {
  return new Promise((t => {
    var i = wonka_e;
    var a;
    r((e => {
      if (0 === e) {
        Promise.resolve(a).then(t);
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else {
        a = e[0];
        i(0);
      }
    }));
  }));
}

function zip(r) {
  var t = Object.keys(r).length;
  return i => {
    var a = new Set;
    var f = Array.isArray(r) ? new Array(t).fill(wonka_e) : {};
    var n = Array.isArray(r) ? new Array(t) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function(v) {
      r[v]((c => {
        if (0 === c) {
          if (o >= t - 1) {
            u = !0;
            i(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < t) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || wonka_e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            i(push(Array.isArray(n) ? n.slice() : {
              ...n
            }));
          }
        }
      }));
    };
    for (var v in r) {
      loop(v);
    }
    i(start((e => {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var t in f) {
          f[t](0);
        }
      }
    })));
  };
}

function combine(...e) {
  return zip(e);
}

var observableSymbol = () => Symbol.observable || "@@observable";

function fromObservable(e) {
  return r => {
    var t = (e[observableSymbol()] ? e[observableSymbol()]() : e).subscribe({
      next(e) {
        r(push(e));
      },
      complete() {
        r(0);
      },
      error(e) {
        throw e;
      }
    });
    r(start((e => {
      if (1 === e) {
        t.unsubscribe();
      }
    })));
  };
}

function toObservable(r) {
  return {
    subscribe(t, i, a) {
      var f = "object" == typeof t ? t : {
        next: t,
        error: i,
        complete: a
      };
      var n = wonka_e;
      var s = !1;
      r((e => {
        if (s) {} else if (0 === e) {
          s = !0;
          if (f.complete) {
            f.complete();
          }
        } else if (0 === e.tag) {
          (n = e[0])(0);
        } else {
          f.next(e[0]);
          n(0);
        }
      }));
      var l = {
        closed: !1,
        unsubscribe() {
          l.closed = !0;
          s = !0;
          n(1);
        }
      };
      return l;
    },
    [observableSymbol()]() {
      return this;
    }
  };
}

function fromCallbag(e) {
  return r => {
    e(0, ((e, t) => {
      if (0 === e) {
        r(start((e => {
          t(e + 1);
        })));
      } else if (1 === e) {
        r(push(t));
      } else {
        r(0);
      }
    }));
  };
}

function toCallbag(e) {
  return (r, t) => {
    if (0 === r) {
      e((e => {
        if (0 === e) {
          t(2);
        } else if (0 === e.tag) {
          t(0, (r => {
            if (r < 3) {
              e[0](r - 1);
            }
          }));
        } else {
          t(1, e[0]);
        }
      }));
    }
  };
}

var wonka_pipe = (...e) => {
  var r = e[0];
  for (var t = 1, i = e.length; t < i; t++) {
    r = e[t](r);
  }
  return r;
};


//# sourceMappingURL=wonka.mjs.map

;// ../../node_modules/.pnpm/@urql+core@4.0.10_graphql@16.8.1/node_modules/@urql/core/dist/urql-core-chunk.mjs




var rehydrateGraphQlError = e => {
  if (e && e.message && (e.extensions || "GraphQLError" === e.name)) {
    return e;
  } else if ("object" == typeof e && e.message) {
    return new GraphQLError(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {});
  } else {
    return new GraphQLError(e);
  }
};

class urql_core_chunk_CombinedError extends Error {
  constructor(r) {
    var e = (r.graphQLErrors || []).map(rehydrateGraphQlError);
    var t = ((r, e) => {
      var t = "";
      if (r) {
        return `[Network] ${r.message}`;
      }
      if (e) {
        for (var a of e) {
          if (t) {
            t += "\n";
          }
          t += `[GraphQL] ${a.message}`;
        }
      }
      return t;
    })(r.networkError, e);
    super(t);
    this.name = "CombinedError";
    this.message = t;
    this.graphQLErrors = e;
    this.networkError = r.networkError;
    this.response = r.response;
  }
  toString() {
    return this.message;
  }
}

var phash = (r, e) => {
  var t = 0 | (e || 5381);
  for (var a = 0, o = 0 | r.length; a < o; a++) {
    t = (t << 5) + t + r.charCodeAt(a);
  }
  return t;
};

var urql_core_chunk_i = new Set;

var urql_core_chunk_f = new WeakMap;

var stringify = r => {
  if (null === r || urql_core_chunk_i.has(r)) {
    return "null";
  } else if ("object" != typeof r) {
    return JSON.stringify(r) || "";
  } else if (r.toJSON) {
    return stringify(r.toJSON());
  } else if (Array.isArray(r)) {
    var e = "[";
    for (var t of r) {
      if (e.length > 1) {
        e += ",";
      }
      e += stringify(t) || "null";
    }
    return e += "]";
  } else if (urql_core_chunk_v !== NoopConstructor && r instanceof urql_core_chunk_v || urql_core_chunk_l !== NoopConstructor && r instanceof urql_core_chunk_l) {
    return "null";
  }
  var a = Object.keys(r).sort();
  if (!a.length && r.constructor && r.constructor !== Object) {
    var o = urql_core_chunk_f.get(r) || Math.random().toString(36).slice(2);
    urql_core_chunk_f.set(r, o);
    return stringify({
      __key: o
    });
  }
  urql_core_chunk_i.add(r);
  var n = "{";
  for (var s of a) {
    var c = stringify(r[s]);
    if (c) {
      if (n.length > 1) {
        n += ",";
      }
      n += stringify(s) + ":" + c;
    }
  }
  urql_core_chunk_i.delete(r);
  return n += "}";
};

var extract = (r, e, t) => {
  if (null == t || "object" != typeof t || t.toJSON || urql_core_chunk_i.has(t)) {} else if (Array.isArray(t)) {
    for (var a = 0, o = t.length; a < o; a++) {
      extract(r, `${e}.${a}`, t[a]);
    }
  } else if (t instanceof urql_core_chunk_v || t instanceof urql_core_chunk_l) {
    r.set(e, t);
  } else {
    urql_core_chunk_i.add(t);
    for (var n of Object.keys(t)) {
      extract(r, `${e}.${n}`, t[n]);
    }
  }
};

var stringifyVariables = r => {
  urql_core_chunk_i.clear();
  return stringify(r);
};

class NoopConstructor {}

var urql_core_chunk_v = "undefined" != typeof File ? File : NoopConstructor;

var urql_core_chunk_l = "undefined" != typeof Blob ? Blob : NoopConstructor;

var urql_core_chunk_c = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;

var urql_core_chunk_d = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g;

var replaceOutsideStrings = (r, e) => e % 2 == 0 ? r.replace(urql_core_chunk_d, "\n") : r;

var sanitizeDocument = r => r.split(urql_core_chunk_c).map(replaceOutsideStrings).join("").trim();

var urql_core_chunk_p = new Map;

var urql_core_chunk_u = new Map;

var stringifyDocument = r => {
  var t;
  if ("string" == typeof r) {
    t = sanitizeDocument(r);
  } else if (r.loc && urql_core_chunk_u.get(r.__key) === r) {
    t = r.loc.source.body;
  } else {
    t = urql_core_chunk_p.get(r) || sanitizeDocument(print(r));
    urql_core_chunk_p.set(r, t);
  }
  if ("string" != typeof r && !r.loc) {
    r.loc = {
      start: 0,
      end: t.length,
      source: {
        body: t,
        name: "gql",
        locationOffset: {
          line: 1,
          column: 1
        }
      }
    };
  }
  return t;
};

var hashDocument = r => {
  var e = phash(stringifyDocument(r));
  if (r.definitions) {
    var t = getOperationName(r);
    if (t) {
      e = phash(`\n# ${t}`, e);
    }
  }
  return e;
};

var keyDocument = r => {
  var e;
  var a;
  if ("string" == typeof r) {
    e = hashDocument(r);
    a = urql_core_chunk_u.get(e) || parse(r, {
      noLocation: !0
    });
  } else {
    e = r.__key || hashDocument(r);
    a = urql_core_chunk_u.get(e) || r;
  }
  if (!a.loc) {
    stringifyDocument(a);
  }
  a.__key = e;
  urql_core_chunk_u.set(e, a);
  return a;
};

var createRequest = (r, e, t) => {
  var a = e || {};
  var o = keyDocument(r);
  var n = stringifyVariables(a);
  var s = o.__key;
  if ("{}" !== n) {
    s = phash(n, s);
  }
  return {
    key: s,
    query: o,
    variables: a,
    extensions: t
  };
};

var getOperationName = r => {
  for (var e of r.definitions) {
    if (e.kind === graphql_web_e.OPERATION_DEFINITION) {
      return e.name ? e.name.value : void 0;
    }
  }
};

var getOperationType = r => {
  for (var e of r.definitions) {
    if (e.kind === a.OPERATION_DEFINITION) {
      return e.operation;
    }
  }
};

var makeResult = (r, e, t) => {
  if (!("data" in e) && !("errors" in e)) {
    throw new Error("No Content");
  }
  var a = "subscription" === r.kind;
  return {
    operation: r,
    data: e.data,
    error: Array.isArray(e.errors) ? new urql_core_chunk_CombinedError({
      graphQLErrors: e.errors,
      response: t
    }) : void 0,
    extensions: e.extensions ? {
      ...e.extensions
    } : void 0,
    hasNext: null == e.hasNext ? a : e.hasNext,
    stale: !1
  };
};

var deepMerge = (r, e) => {
  if ("object" == typeof r && null != r) {
    if (!r.constructor || r.constructor === Object || Array.isArray(r)) {
      r = Array.isArray(r) ? [ ...r ] : {
        ...r
      };
      for (var t of Object.keys(e)) {
        r[t] = deepMerge(r[t], e[t]);
      }
      return r;
    }
  }
  return e;
};

var mergeResultPatch = (r, e, t) => {
  var a = r.error ? r.error.graphQLErrors : [];
  var o = !!r.extensions || !!e.extensions;
  var n = {
    ...r.extensions,
    ...e.extensions
  };
  var s = e.incremental;
  if ("path" in e) {
    s = [ e ];
  }
  var i = {
    data: r.data
  };
  if (s) {
    for (var f of s) {
      if (Array.isArray(f.errors)) {
        a.push(...f.errors);
      }
      if (f.extensions) {
        Object.assign(n, f.extensions);
        o = !0;
      }
      var v = "data";
      var l = i;
      for (var c = 0, d = f.path.length; c < d; v = f.path[c++]) {
        l = l[v] = Array.isArray(l[v]) ? [ ...l[v] ] : {
          ...l[v]
        };
      }
      if (f.items) {
        var p = +v >= 0 ? v : 0;
        for (var u = 0, y = f.items.length; u < y; u++) {
          l[p + u] = deepMerge(l[p + u], f.items[u]);
        }
      } else if (void 0 !== f.data) {
        l[v] = deepMerge(l[v], f.data);
      }
    }
  } else {
    i.data = e.data || r.data;
    a = e.errors || a;
  }
  return {
    operation: r.operation,
    data: i.data,
    error: a.length ? new urql_core_chunk_CombinedError({
      graphQLErrors: a,
      response: t
    }) : void 0,
    extensions: o ? n : void 0,
    hasNext: null != e.hasNext ? e.hasNext : r.hasNext,
    stale: !1
  };
};

var makeErrorResult = (r, e, t) => ({
  operation: r,
  data: void 0,
  error: new urql_core_chunk_CombinedError({
    networkError: e,
    response: t
  }),
  extensions: void 0,
  hasNext: !1,
  stale: !1
});

function makeFetchBody(r) {
  return {
    query: r.extensions && r.extensions.persistedQuery && !r.extensions.persistedQuery.miss ? void 0 : stringifyDocument(r.query),
    operationName: getOperationName(r.query),
    variables: r.variables || void 0,
    extensions: r.extensions
  };
}

var makeFetchURL = (r, e) => {
  var t = "query" === r.kind && r.context.preferGetMethod;
  if (!t || !e) {
    return r.context.url;
  }
  var a = new URL(r.context.url);
  for (var o in e) {
    var n = e[o];
    if (n) {
      a.searchParams.set(o, "object" == typeof n ? stringifyVariables(n) : n);
    }
  }
  var s = a.toString();
  if (s.length > 2047 && "force" !== t) {
    r.context.preferGetMethod = !1;
    return r.context.url;
  }
  return s;
};

var serializeBody = (r, e) => {
  if (e && !("query" === r.kind && !!r.context.preferGetMethod)) {
    var t = stringifyVariables(e);
    var a = (r => {
      var e = new Map;
      if (urql_core_chunk_v !== NoopConstructor || urql_core_chunk_l !== NoopConstructor) {
        urql_core_chunk_i.clear();
        extract(e, "variables", r);
      }
      return e;
    })(e.variables);
    if (a.size) {
      var o = new FormData;
      o.append("operations", t);
      o.append("map", stringifyVariables({
        ...[ ...a.keys() ].map((r => [ r ]))
      }));
      var n = 0;
      for (var s of a.values()) {
        o.append("" + n++, s);
      }
      return o;
    }
    return t;
  }
};

var makeFetchOptions = (r, e) => {
  var t = {
    accept: "subscription" === r.kind ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed"
  };
  var a = ("function" == typeof r.context.fetchOptions ? r.context.fetchOptions() : r.context.fetchOptions) || {};
  if (a.headers) {
    for (var o in a.headers) {
      t[o.toLowerCase()] = a.headers[o];
    }
  }
  var n = serializeBody(r, e);
  if ("string" == typeof n && !t["content-type"]) {
    t["content-type"] = "application/json";
  }
  return {
    ...a,
    method: n ? "POST" : "GET",
    body: n,
    headers: t
  };
};

var urql_core_chunk_y = "undefined" != typeof TextDecoder ? new TextDecoder : null;

var urql_core_chunk_h = /boundary="?([^=";]+)"?/i;

var urql_core_chunk_x = /data: ?([^\n]+)/;

var urql_core_chunk_toString = r => "Buffer" === r.constructor.name ? r.toString() : urql_core_chunk_y.decode(r);

async function* streamBody(r) {
  if (r.body[Symbol.asyncIterator]) {
    for await (var e of r.body) {
      yield urql_core_chunk_toString(e);
    }
  } else {
    var t = r.body.getReader();
    var a;
    try {
      while (!(a = await t.read()).done) {
        yield urql_core_chunk_toString(a.value);
      }
    } finally {
      t.cancel();
    }
  }
}

async function* split(r, e) {
  var t = "";
  var a;
  for await (var o of r) {
    t += o;
    while ((a = t.indexOf(e)) > -1) {
      yield t.slice(0, a);
      t = t.slice(a + e.length);
    }
  }
}

async function* fetchOperation(r, e, t) {
  var a = !0;
  var o = null;
  var n;
  try {
    yield await Promise.resolve();
    var s = (n = await (r.context.fetch || fetch)(e, t)).headers.get("Content-Type") || "";
    var i;
    if (/multipart\/mixed/i.test(s)) {
      i = async function* parseMultipartMixed(r, e) {
        var t = r.match(urql_core_chunk_h);
        var a = "--" + (t ? t[1] : "-");
        var o = !0;
        var n;
        for await (var s of split(streamBody(e), "\r\n" + a)) {
          if (o) {
            o = !1;
            var i = s.indexOf(a);
            if (i > -1) {
              s = s.slice(i + a.length);
            } else {
              continue;
            }
          }
          try {
            yield n = JSON.parse(s.slice(s.indexOf("\r\n\r\n") + 4));
          } catch (r) {
            if (!n) {
              throw r;
            }
          }
          if (n && !1 === n.hasNext) {
            break;
          }
        }
        if (n && !1 !== n.hasNext) {
          yield {
            hasNext: !1
          };
        }
      }(s, n);
    } else if (/text\/event-stream/i.test(s)) {
      i = async function* parseEventStream(r) {
        var e;
        for await (var t of split(streamBody(r), "\n\n")) {
          var a = t.match(urql_core_chunk_x);
          if (a) {
            var o = a[1];
            try {
              yield e = JSON.parse(o);
            } catch (r) {
              if (!e) {
                throw r;
              }
            }
            if (e && !1 === e.hasNext) {
              break;
            }
          }
        }
        if (e && !1 !== e.hasNext) {
          yield {
            hasNext: !1
          };
        }
      }(n);
    } else if (!/text\//i.test(s)) {
      i = async function* parseJSON(r) {
        yield JSON.parse(await r.text());
      }(n);
    } else {
      throw new Error(await n.text());
    }
    for await (var f of i) {
      o = o ? mergeResultPatch(o, f, n) : makeResult(r, f, n);
      a = !1;
      yield o;
      a = !0;
    }
    if (!o) {
      yield o = makeResult(r, {}, n);
    }
  } catch (e) {
    if (!a) {
      throw e;
    }
    yield makeErrorResult(r, n && (n.status < 200 || n.status >= 300) && n.statusText ? new Error(n.statusText) : e, n);
  }
}

function makeFetchSource(r, e, t) {
  var a;
  if ("undefined" != typeof AbortController) {
    t.signal = (a = new AbortController).signal;
  }
  return onEnd((() => {
    if (a) {
      a.abort();
    }
  }))(wonka_filter((r => !!r))(fromAsyncIterable(fetchOperation(r, e, t))));
}


//# sourceMappingURL=urql-core-chunk.mjs.map

;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/DataHydrator.js
const Hydrators = {
    DateTime(value) {
        return new Date(value);
    },
};
/**
 * Utility for declaratively transforming object trees.
 * Useful for turning API date strings into real Date objects, etc.
 * Declarative so that the operations it peforms can be serialized.
 */
class DataHydrator_DataHydrator {
    constructor(plan) {
        Object.defineProperty(this, "plan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: plan
        });
    }
    apply(source) {
        if (Array.isArray(source)) {
            return source.map((object) => this.hydrateObject(object));
        }
        else {
            return this.hydrateObject(source);
        }
    }
    hydrateObject(object) {
        const hydrated = { ...object };
        for (const [key, hydrator] of Object.entries(this.plan)) {
            const value = hydrated[key];
            if (value != null) {
                hydrated[key] = Hydrators[hydrator](value);
            }
        }
        return hydrated;
    }
}
//# sourceMappingURL=DataHydrator.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/GadgetRecord.js
var _a, _b, _c, _d, _e;


var ChangeTracking;
(function (ChangeTracking) {
    ChangeTracking[ChangeTracking["SinceLoaded"] = 0] = "SinceLoaded";
    ChangeTracking[ChangeTracking["SinceLastPersisted"] = 1] = "SinceLastPersisted";
})(ChangeTracking || (ChangeTracking = {}));
const kFields = Symbol.for("g/fields");
const kInstantiatedFields = Symbol.for("g/if");
const kPersistedFields = Symbol.for("g/pf");
const kFieldKeys = Symbol.for("g/fk");
const kTouched = Symbol.for("g/t");
/** Represents one record returned from a high level Gadget API call */
class GadgetRecord_ {
    constructor(data) {
        var _f, _g;
        /** Storage of the actual keys and values of this record */
        Object.defineProperty(this, _a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        /** Storage of the keys and values of this record at the time it was instantiated */
        Object.defineProperty(this, _b, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        /** Storage of the keys and values of this record at the time it was last persisted */
        Object.defineProperty(this, _c, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        /** Storage of the keys and values of this record at the time it was last persisted */
        Object.defineProperty(this, _d, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _e, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "empty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this[kInstantiatedFields] = (_f = cloneDeep(data)) !== null && _f !== void 0 ? _f : {};
        this[kPersistedFields] = (_g = cloneDeep(data)) !== null && _g !== void 0 ? _g : {};
        Object.assign(this[kFields], data);
        if (!data || Object.keys(data).length === 0) {
            this.empty = true;
            this[kFieldKeys] = new Set();
        }
        else {
            this[kFieldKeys] = new Set(Object.keys(this[kFields]));
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const handler = {
            get: (obj, prop) => {
                if (prop in self || typeof prop == "symbol") {
                    // if the GadgetRecord responds to the property or function, call that prioritize that
                    let val = self[prop];
                    if (typeof val == "function") {
                        val = val.bind(self);
                    }
                    return val;
                }
                else if (prop in obj) {
                    // otherwise proxy it to this [kFields] object
                    return obj[prop];
                }
            },
            set: (obj, prop, value) => {
                self.trackKey(prop);
                obj[prop.toString()] = value;
                return true;
            },
        };
        return new Proxy(this[kFields], handler);
    }
    /** Makes sure our data keys are all tracked, to avoid repeated runtime object-to-array conversions */
    trackKey(key) {
        const trackingKey = key.toString();
        this[kFieldKeys].add(trackingKey);
    }
    /** Helper method to compare values with special handling for Date vs string comparisons in either direction */
    hasValueChanged(current, previous) {
        if ((current instanceof Date && typeof previous === "string") || (previous instanceof Date && typeof current === "string")) {
            const currentDate = current instanceof Date ? current : new Date(current);
            const previousDate = previous instanceof Date ? previous : new Date(previous);
            // Check if both dates are valid before comparing
            if (!isNaN(currentDate.getTime()) && !isNaN(previousDate.getTime())) {
                return currentDate.getTime() !== previousDate.getTime();
            }
            return true; // If either can't be converted to a valid date, they're different
        }
        return !isEqual(current, previous);
    }
    /** Returns true if even a single field has changed */
    hasChanges(tracking = ChangeTracking.SinceLoaded) {
        if (this[kTouched])
            return true;
        const diffFields = tracking == ChangeTracking.SinceLoaded ? this[kInstantiatedFields] : this[kPersistedFields];
        return [...this[kFieldKeys]].some((key) => this.hasValueChanged(this[kFields][key], diffFields[key]));
    }
    /** Checks if the original constructor data was empty or not */
    isEmpty() {
        return this.empty;
    }
    /** Returns the value of the field for the given `apiIdentifier`. These properties may also be accessed on this record directly. This method can be used if your model field `apiIdentifier` conflicts with the `GadgetRecord` helper functions. */
    getField(apiIdentifier) {
        return this[kFields][apiIdentifier];
    }
    /** Sets the value of the field for the given `apiIdentifier`. These properties may also be accessed on this record directly. This method can be used if your model field `apiIdentifier` conflicts with the `GadgetRecord` helper functions. */
    setField(apiIdentifier, value) {
        this.trackKey(apiIdentifier);
        return (this[kFields][apiIdentifier] = value);
    }
    changes(prop, tracking = ChangeTracking.SinceLoaded) {
        const trackChangesSince = typeof prop == "string" ? tracking : prop || tracking;
        const diffFields = trackChangesSince == ChangeTracking.SinceLoaded ? this[kInstantiatedFields] : this[kPersistedFields];
        if (prop && typeof prop == "string") {
            const previous = diffFields[prop];
            const current = this[kFields][prop];
            const changed = this.hasValueChanged(current, previous);
            return changed ? { changed, current, previous } : { changed };
        }
        else {
            const diff = {};
            for (const key of this[kFieldKeys]) {
                if (!isEqual(diffFields[key], this[kFields][key])) {
                    diff[key] = { current: this[kFields][key], previous: diffFields[key] };
                }
            }
            return diff;
        }
    }
    /** Returns all current values for fields that have changed */
    toChangedJSON(tracking = ChangeTracking.SinceLoaded) {
        const diffFields = tracking == ChangeTracking.SinceLoaded ? this[kInstantiatedFields] : this[kPersistedFields];
        const current = {};
        for (const key of this[kFieldKeys]) {
            if (!isEqual(diffFields[key], this[kFields][key])) {
                current[key] = this[kFields][key];
            }
        }
        return current;
    }
    changed(prop, tracking = ChangeTracking.SinceLoaded) {
        if (prop && typeof prop == "string") {
            return this.changes(prop, tracking).changed;
        }
        else {
            return this.hasChanges(prop === undefined ? tracking : prop);
        }
    }
    /** Flushes all `changes` and starts tracking new changes from the current state of the record. */
    flushChanges(tracking = ChangeTracking.SinceLoaded) {
        if (tracking == ChangeTracking.SinceLoaded) {
            this[kInstantiatedFields] = cloneDeep(this[kFields]);
        }
        else if (tracking == ChangeTracking.SinceLastPersisted) {
            this[kPersistedFields] = cloneDeep(this[kFields]);
        }
        this[kTouched] = false;
    }
    /** Reverts all `changes` on the record, and returns to either the values this record were instantiated with, or the values at the time of the last `flushChanges` call. */
    revertChanges(tracking = ChangeTracking.SinceLoaded) {
        let persistedKeys;
        if (tracking == ChangeTracking.SinceLoaded) {
            persistedKeys = Object.keys(this[kInstantiatedFields]);
        }
        else {
            persistedKeys = Object.keys(this[kPersistedFields]);
        }
        for (const key of this[kFieldKeys]) {
            if (!persistedKeys.includes(key))
                delete this[kFields][key];
        }
        if (tracking == ChangeTracking.SinceLoaded) {
            Object.assign(this[kFields], cloneDeep(this[kInstantiatedFields]));
        }
        else {
            Object.assign(this[kFields], cloneDeep(this[kPersistedFields]));
        }
        this[kTouched] = false;
    }
    /** Returns a JSON representation of all fields on this record. */
    toJSON() {
        return toPrimitiveObject({ ...this[kFields] });
    }
    /** Marks this record as changed so that the next save will save it and adjust any `updatedAt` timestamps */
    touch() {
        this[kTouched] = true;
    }
}
_a = kFields, _b = kInstantiatedFields, _c = kPersistedFields, _d = kFieldKeys, _e = kTouched;
/**
 * Instantiates a `GadgetRecord` with the attributes of your model. A `GadgetRecord` can be used to track changes to your model and persist those changes via Gadget actions.
 **/
const GadgetRecord_GadgetRecord = (/* unused pure expression or super */ null && (GadgetRecord_));
/**
 * Legacy export for old generated clients expecting to find the class named this
 * @hidden
 */
const GadgetRecordImplementation = (/* unused pure expression or super */ null && (GadgetRecord_));
//# sourceMappingURL=GadgetRecord.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/support.js




/**
 * Error caused by a violated internal expectation that isn't the users fault, but the Gadget platform's. Often the best way to handle is to just retry.
 **/
class GadgetInternalError extends Error {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_INTERNAL_ERROR"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InternalError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 500
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
}
/**
 * An error representing misuse or a violation of the assumptions of the Gadget Client.
 */
class support_GadgetClientError extends Error {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_CLIENT_ERROR"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ClientError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 500
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
}
/**
 * A Gadget API error with an `code` and `message` describing the error. Most often these errors are caused by invalid input data or by misconfigured Gadget models. Consult the documentation for the specific `code` to learn more.
 **/
class support_GadgetOperationError extends Error {
    constructor(incomingMessage, code) {
        super(incomingMessage.startsWith("GGT_") ? incomingMessage : `${code}: ${incomingMessage}`);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
}
/**
 * A client error when the Gadget API closes the connection unexpectedly.
 */
class GadgetUnexpectedCloseError extends Error {
    constructor(event) {
        let message;
        if (isCloseEvent(event)) {
            message = `GraphQL websocket closed unexpectedly by the server with error code ${event.code} and reason "${event.reason}"`;
        }
        else {
            message = "GraphQL websocket closed unexpectedly by the server";
        }
        super(message);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_UNKNOWN"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnexpectedCloseError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 500
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        /** The event that caused the unexpected close */
        Object.defineProperty(this, "event", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.event = event;
    }
}
/**
 * A client error when the client times out waiting for the Gadget API to open websocket connection.
 */
class GadgetWebsocketConnectionTimeoutError extends Error {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_WEBSOCKET_CONNECTION_TIMEOUT"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WebsocketConnectionTimeoutError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 500
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
}
/**
 * A Gadget API error when there are more requests sent in the alloted time window then permitted
 */
class GadgetTooManyRequestsError extends Error {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_TOO_MANY_REQUESTS"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TooManyRequestsError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 429
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
}
/**
 * A Gadget API error representing a backend validation error on the input data for an action. Thrown when any of the validations configured on a model fail for the given input data. Has a `validationErrors` property describing which fields failed validation, with messages for each.
 */
class InvalidRecordError extends Error {
    constructor(message, validationErrors, modelApiIdentifier, record) {
        const firstErrors = validationErrors.slice(0, 3);
        const extraErrorMessage = validationErrors.length > 3
            ? `, and ${validationErrors.length - 3} more error${validationErrors.length > 4 ? "s" : ""} need${validationErrors.length > 4 ? "" : "s"} to be corrected`
            : "";
        super(message !== null && message !== void 0 ? message : `GGT_INVALID_RECORD: ${modelApiIdentifier !== null && modelApiIdentifier !== void 0 ? modelApiIdentifier : "Record"} is invalid and can't be saved. ${firstErrors
            .map(({ apiIdentifier, message }) => `${apiIdentifier} ${message}`)
            .join(", ")}${extraErrorMessage}.`);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_INVALID_RECORD"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidRecordError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 422
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        /**
         * A list of validation errors for each field that failed validation.
         */
        Object.defineProperty(this, "validationErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * The API identifier of the model for this record which failed to validate
         */
        Object.defineProperty(this, "modelApiIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * The record that failed to validate, if available
         */
        Object.defineProperty(this, "record", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.validationErrors = validationErrors;
        this.modelApiIdentifier = modelApiIdentifier;
        this.record = record;
    }
}
/**
 * @deprecated Use `InvalidRecordError` instead, here for backwards compatability
 */
const GadgetValidationError = (/* unused pure expression or super */ null && (InvalidRecordError));
/**
 * A Gadget API error that represents an error from the server. Thrown when the server encounters data that is not unique despite the existence of unique validation on a field. If you receive this error, it is likely that you added a unique validation to a field that has duplicate data.
 */
class GadgetNonUniqueDataError extends Error {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_NON_UNIQUE_DATA"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonUniqueDataError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 417
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
}
/**
 * A Gadget API error that represents an error where the client asked the server for data that doesn't exist server side.
 */
class support_GadgetNotFoundError extends Error {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "GGT_RECORD_NOT_FOUND"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RecordNotFoundError"
        });
        /** @private */
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 404
        });
        /** @private */
        Object.defineProperty(this, "causedByClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
}
/**
 * Represents a group of errors that occurred when running a number of operations at once */
class support_GadgetErrorGroup extends Error {
    constructor(
    /** The list of inner errors that occurred */
    errors, 
    /* Any objects that were successfully processed during the bulk operation (the ones that didn't throw errors) */
    results) {
        super(errors.length > 1 ? "Multiple errors occurred" : errors[0].message);
        Object.defineProperty(this, "errors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: errors
        });
        Object.defineProperty(this, "results", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: results
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ErrorGroup"
        });
    }
    get code() {
        return `GGT_ERROR_GROUP(${this.errors
            .slice(0, 10)
            .map((error) => { var _a; return (_a = error.code) !== null && _a !== void 0 ? _a : "GGT_UNKNOWN"; })
            .join(",")})`;
    }
    /** @private */
    get statusCode() {
        return Math.max(...this.errors.map((error) => { var _a; return (_a = error.statusCode) !== null && _a !== void 0 ? _a : 500; }));
    }
}
function support_assert(value, message) {
    if (!value) {
        throw new Error("assertion error" + (message ? `: ${message}` : ""));
    }
    return value;
}
const support_get = (object, path) => {
    const length = path.length;
    let index = 0;
    while (object != null && index < length) {
        object = object[path[index++]];
    }
    return index && index == length ? object : undefined;
};
const isCloseEvent = (event) => (event === null || event === void 0 ? void 0 : event.type) == "close";
/**
 * Converts a string to camel case, optionally capitalizing the first character.
 * Defaults to capitalizing the first character.
 * @param str
 * @param capitalizeFirstCharacter
 * @returns Camelize string
 */
const support_capitalizeIdentifier = (str, capitalizeFirstCharacter) => {
    if (typeof str !== "string")
        return "";
    return support_camelize(str, capitalizeFirstCharacter);
};
const capitalizeFirstCharacter = (str) => {
    const result = str === null || str === undefined ? "" : String(str);
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const support_camelize = (term, uppercaseFirstLetter = true) => {
    let result = "" + term;
    if (uppercaseFirstLetter) {
        result = result.replace(/^[a-z\d]*/, (a) => {
            return capitalizeFirstCharacter(a);
        });
    }
    else {
        result = result.replace(new RegExp("^(?:(?=\\b|[A-Z_])|\\w)"), (a) => {
            return a.toLowerCase();
        });
    }
    result = result.replace(/(?:_|(\/))([a-z\d]*)/gi, (_match, a, b, _idx, _string) => {
        a || (a = "");
        return "" + a + capitalizeFirstCharacter(b);
    });
    return result;
};
const support_namespacedGraphQLTypeName = (modelApiIdentifier, givenNamespaces) => {
    const namespaces = Array.isArray(givenNamespaces) ? givenNamespaces : givenNamespaces ? [givenNamespaces] : [];
    const segments = [...namespaces, modelApiIdentifier];
    return segments.map((segment) => support_camelize(segment)).join("");
};
const support_sortTypeName = (modelApiIdentifier, namespace) => `${support_namespacedGraphQLTypeName(modelApiIdentifier, namespace)}Sort`;
const support_filterTypeName = (modelApiIdentifier, namespace) => `${support_namespacedGraphQLTypeName(modelApiIdentifier, namespace)}Filter`;
const support_getNonUniqueDataError = (modelApiIdentifier, fieldName, fieldValue) => new GadgetNonUniqueDataError(`More than one record found for ${modelApiIdentifier}.${fieldName} = ${fieldValue}. Please confirm your unique validation is not reporting an error.`);
const getNonNullableError = (response, dataPath) => {
    if (response.fetching) {
        return;
    }
    const result = support_get(response.data, dataPath);
    if (result === undefined) {
        return new GadgetInternalError(`Internal Error: Gadget API didn't return expected data. Nothing found in response at ${dataPath.join(".")}`);
    }
    else if (result === null) {
        return new support_GadgetNotFoundError(`Record Not Found Error: Gadget API returned no data at ${dataPath.join(".")}`);
    }
};
const support_assertOperationSuccess = (response, dataPath, throwOnEmptyData = false) => {
    var _a;
    if (response.error) {
        if (response.error instanceof urql_core_chunk_CombinedError && ((_a = response.error.networkError) === null || _a === void 0 ? void 0 : _a.length)) {
            response.error.message = response.error.networkError.map((error) => "[Network] " + error.message).join("\n");
        }
        throw response.error;
    }
    const result = support_get(response.data, dataPath);
    const edges = support_get(result, ["edges"]);
    const dataArray = edges !== null && edges !== void 0 ? edges : result;
    if (result === undefined) {
        throw new GadgetInternalError(`Internal Error: Gadget API didn't return expected data. Nothing found in response at ${dataPath.join(".")}`);
    }
    else if (result === null || (throwOnEmptyData && Array.isArray(dataArray) && dataArray.length === 0)) {
        throw new support_GadgetNotFoundError(`Record Not Found Error: Gadget API returned no data at ${dataPath.join(".")}`);
    }
    return result;
};
const support_assertNullableOperationSuccess = (response, dataPath) => {
    var _a;
    if (response.error) {
        if (response.error instanceof CombinedError && ((_a = response.error.networkError) === null || _a === void 0 ? void 0 : _a.length)) {
            response.error.message = response.error.networkError.map((error) => "[Network] " + error.message).join("\n");
        }
        throw response.error;
    }
    const result = support_get(response.data, dataPath);
    return result !== null && result !== void 0 ? result : null;
};
const support_gadgetErrorFor = (error) => {
    var _a;
    if (error.code == "GGT_INVALID_RECORD") {
        return new InvalidRecordError(error.message, error.validationErrors, (_a = error.model) === null || _a === void 0 ? void 0 : _a.apiIdentifier, error.record);
    }
    else if (error.code == "GGT_UNKNOWN" && error.message.includes("duplicate key value violates unique constraint")) {
        return new GadgetNonUniqueDataError(error.message);
    }
    else {
        return new support_GadgetOperationError(error.message, error.code);
    }
};
const support_assertMutationSuccess = (response, dataPath) => {
    const operationResponse = support_assertOperationSuccess(response, dataPath);
    return support_assertResponseSuccess(operationResponse);
};
const support_assertResponseSuccess = (operationResponse) => {
    if (!operationResponse.success) {
        const firstErrorBlob = operationResponse.errors && operationResponse.errors[0];
        if (firstErrorBlob) {
            throw support_gadgetErrorFor(firstErrorBlob);
        }
        else {
            throw new support_GadgetOperationError(`Gadget API operation not successful.`, "GGT_UNKNOWN");
        }
    }
    return operationResponse;
};
const getHydrator = (response) => {
    var _a, _b, _c, _d;
    if ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.gadgetMeta) === null || _b === void 0 ? void 0 : _b.hydrations) {
        return new DataHydrator((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.gadgetMeta) === null || _d === void 0 ? void 0 : _d.hydrations);
    }
};
const support_hydrateRecord = (response, record) => {
    const hydrator = getHydrator(response);
    if (hydrator) {
        record = hydrator.apply(record);
    }
    return new GadgetRecord(record);
};
const support_hydrateRecordArray = (response, records) => {
    const hydrator = getHydrator(response);
    if (hydrator) {
        records = hydrator.apply(records);
    }
    return records === null || records === void 0 ? void 0 : records.map((record) => new GadgetRecord(record));
};
const support_hydrateConnection = (response, connection) => {
    const nodes = connection.edges.map((edge) => edge.node);
    return support_hydrateRecordArray(response, nodes);
};
const objObjType = "[object Object]";
const stringObjType = "[object String]";
const support_toPrimitiveObject = (value) => {
    if (value != null && typeof value.toJSON === "function")
        value = value.toJSON();
    if (value === undefined)
        return undefined;
    if (value === null)
        return null;
    if (typeof value === "boolean")
        return value;
    if (typeof value === "string")
        return value;
    if (typeof value === "number")
        return Number.isFinite(value) ? value : null;
    if (typeof value === "object") {
        if (Array.isArray(value)) {
            const arr = [];
            for (let i = 0; i < value.length; i++) {
                const v = value[i];
                arr[i] = v === undefined ? null : support_toPrimitiveObject(v);
            }
            return arr;
        }
        if (Object.prototype.toString.call(value) === "[object Error]")
            return {};
        if (Object.prototype.toString.call(value) === objObjType) {
            const obj = {};
            for (const key of Object.keys(value)) {
                const parsed = support_toPrimitiveObject(value[key]);
                // Remove undefined fields
                if (parsed !== undefined)
                    obj[key] = parsed;
            }
            return obj;
        }
    }
};
/**
 * Get a string representing an error that is an `Error` object or anything else that might be `throw`n
 */
const errorMessage = (error) => {
    if (typeof error == "string") {
        return error;
    }
    else if (error && (error === null || error === void 0 ? void 0 : error.message)) {
        return error.message;
    }
    else {
        return String(error);
    }
};
// Gadget Storage Test Key that minifies well
const key = "gstk";
/** Detect if the window object and window.localStorage or window.sessionStorage objects are functional */
const storageAvailable = (type) => {
    try {
        const storage = window[type];
        storage.setItem(key, key);
        storage.removeItem(key);
        return true;
    }
    catch (e) {
        return false;
    }
};
// smaller implementation of lodash's isEqual from https://github.com/NickGard/tiny-isequal but made a bit more performant and typesafe
const support_toString = Object.prototype.toString, getPrototypeOf = Object.getPrototypeOf, getOwnProperties = Object.getOwnPropertySymbols
    ? (c) => Object.keys(c).concat(Object.getOwnPropertySymbols(c))
    : Object.keys;
const checkEquality = (a, b, refs) => {
    // trivial case: primitives and referentially equal objects
    if (a === b)
        return true;
    // if both are null/undefined, the above check would have returned true
    if (a == null || b == null)
        return false;
    // check to see if we've seen this reference before; if yes, return true
    // eslint-disable-next-line lodash/prefer-includes
    if (refs.indexOf(a) > -1 && refs.indexOf(b) > -1)
        return true;
    const aType = support_toString.call(a);
    const bType = support_toString.call(b);
    let aElements, bElements, element;
    // save results for circular checks
    refs.push(a, b);
    // gadget-specific check for _link equality -- this is a special case for GadgetRecord
    if (aType == objObjType && bType == stringObjType && "_link" in a && Object.keys(a).length == 1) {
        return a._link === b;
    }
    else if (bType == objObjType && aType == stringObjType && "_link" in b && Object.keys(b).length == 1) {
        return b._link === a;
    }
    if (aType != bType)
        return false; // not the same type of objects
    // for non-null objects, check all custom properties
    aElements = getOwnProperties(a);
    bElements = getOwnProperties(b);
    if (aElements.length != bElements.length ||
        aElements.some(function (key) {
            return !checkEquality(a[key], b[key], refs);
        })) {
        return false;
    }
    switch (aType.slice(8, -1)) {
        case "Symbol":
            return a.valueOf() == b.valueOf();
        case "Date":
        case "Number":
            return +a == +b || (+a != +a && +b != +b); // convert Dates to ms, check for NaN
        case "RegExp":
        case "Function":
        case "String":
        case "Boolean":
            return "" + a == "" + b;
        case "Set":
        case "Map": {
            aElements = a.entries();
            bElements = b.entries();
            do {
                element = aElements.next();
                if (!checkEquality(element.value, bElements.next().value, refs)) {
                    return false;
                }
            } while (!element.done);
            return true;
        }
        case "ArrayBuffer":
            (a = new Uint8Array(a)), (b = new Uint8Array(b)); // fall through to be handled as an Array
        case "DataView":
            (a = new Uint8Array(a.buffer)), (b = new Uint8Array(b.buffer)); // fall through to be handled as an Array
        case "Float32Array":
        case "Float64Array":
        case "Int8Array":
        case "Int16Array":
        case "Int32Array":
        case "Uint8Array":
        case "Uint16Array":
        case "Uint32Array":
        case "Uint8ClampedArray":
        case "Arguments":
        case "Array":
            if (a.length != b.length)
                return false;
            for (element = 0; element < a.length; element++) {
                if (!(element in a) && !(element in b))
                    continue; // empty slots are equal
                // either one slot is empty but not both OR the elements are not equal
                if (element in a != element in b || !checkEquality(a[element], b[element], refs))
                    return false;
            }
            return true;
        case "Object":
            return checkEquality(getPrototypeOf(a), getPrototypeOf(b), refs);
        default:
            return false;
    }
};
const support_isEqual = (a, b) => checkEquality(a, b, []);
/**
 * Processes the flexible, convenient JS-land inputs for an action to the fully qualified GraphQL API inputs
 * @internal
 **/
const support_disambiguateActionVariables = (action, variables) => {
    var _a, _b, _c;
    variables !== null && variables !== void 0 ? variables : (variables = {});
    if (!("hasAmbiguousIdentifier" in action) && !("acceptsModelInput" in action))
        return variables;
    if (action.hasAmbiguousIdentifier) {
        if (Object.keys(variables).some((key) => { var _a; return key !== "id" && !((_a = action.paramOnlyVariables) === null || _a === void 0 ? void 0 : _a.includes(key)) && key !== action.modelApiIdentifier; })) {
            throw Error(`Invalid arguments found in variables. Did you mean to use ({ ${action.modelApiIdentifier}: { ... } })?`);
        }
    }
    let newVariables;
    // for backwards compatibilty, actions without the operatesWithRecordIdentity metadata should extract the id from the variables
    const shouldExtractId = (_a = action.operatesWithRecordIdentity) !== null && _a !== void 0 ? _a : true;
    if ((_b = action.acceptsModelInput) !== null && _b !== void 0 ? _b : action.hasCreateOrUpdateEffect) {
        if (action.modelApiIdentifier in variables &&
            typeof variables[action.modelApiIdentifier] === "object" &&
            variables[action.modelApiIdentifier] != null) {
            newVariables = variables;
        }
        else {
            newVariables = {
                [action.modelApiIdentifier]: {},
            };
            for (const [key, value] of Object.entries(variables)) {
                if ((_c = action.paramOnlyVariables) === null || _c === void 0 ? void 0 : _c.includes(key)) {
                    newVariables[key] = value;
                }
                else {
                    if (key == "id" && shouldExtractId) {
                        newVariables.id = value;
                    }
                    else {
                        newVariables[action.modelApiIdentifier][key] = value;
                    }
                }
            }
        }
    }
    else {
        newVariables = variables;
    }
    return newVariables;
};
/**
 * Normalizes incoming params from JS land into the variable format the GraphQL API is expecting
 * Some bulk actions take GraphQL variables like `{ids: ["1","2","3"]}`, and others take `{inputs: [{field: "value"}, {field: "value"}]}`. In JS land, we accept the fully qualified variables that look like that, as well as the inner array shorthands.
 **/
const support_disambiguateBulkActionVariables = (action, inputs = {}) => {
    var _a;
    if (action.variables["ids"]) {
        // for actions which accept ids only, normalize the array shorthand into the full GraphQL variables
        return Array.isArray(inputs) ? { ids: inputs } : inputs;
    }
    else {
        // for actions which accept inputs, normalize each element of the array of inputs, and then normalize arrays into the object form
        const inputsArray = (_a = (Array.isArray(inputs) ? inputs : inputs.inputs)) !== null && _a !== void 0 ? _a : [];
        return {
            inputs: inputsArray.map((input) => support_disambiguateActionVariables(action, input)),
        };
    }
};
/**
 * Given a set of variables defined with their types and requiredness and whatnot, return the same options with the values for each variable filled in, suitable for passing to one invocation
 */
const support_setVariableOptionValues = (variableOptions, values) => {
    const result = {};
    for (const [key, variable] of Object.entries(variableOptions)) {
        result[key] = { ...variable, value: values[key] };
    }
    return result;
};
const support_namespaceDataPath = (dataPath, namespace) => {
    if (namespace) {
        dataPath.unshift(...(Array.isArray(namespace) ? namespace : [namespace]));
    }
    return dataPath;
};
/**
 * Build a selection object to retrieve the hydrations for a model from the `gadgetMeta` API
 **/
const support_hydrationSelection = (modelApiIdentifier, namespace) => {
    const fullyQualifiedIdentifier = namespace
        ? [...(Array.isArray(namespace) ? namespace : [namespace]), modelApiIdentifier].join(".")
        : modelApiIdentifier;
    return {
        gadgetMeta: {
            hydrations: Call({ modelName: fullyQualifiedIdentifier }),
        },
    };
};
/**
 * Wrap a field selection in a set of namespaces
 **/
function support_namespacify(namespace, fields) {
    if (!namespace)
        return fields;
    if (!Array.isArray(namespace)) {
        namespace = [namespace];
    }
    if (namespace) {
        for (let i = namespace.length - 1; i >= 0; i--) {
            fields = {
                [namespace[i]]: fields,
            };
        }
    }
    return fields;
}
const support_ErrorsSelection = {
    errors: {
        message: true,
        code: true,
        "... on InvalidRecordError": {
            model: {
                apiIdentifier: true,
            },
            validationErrors: {
                message: true,
                apiIdentifier: true,
            },
        },
    },
};
/**
 * Formats error messages into a structured object.
 *
 * @param {Error} error - The error object to format.
 * @returns {Record<string, any>} An object containing formatted error messages.
 *   For InvalidRecordError, it structures validation errors by model and field.
 *   For other errors, it returns a single root message.
 *
 * @example
 * // For an InvalidRecordError:
 * // {
 * //   modelName: {
 * //     fieldName: { message: "Error message" }
 * //   }
 * // }
 *
 * @example
 * // For other errors:
 * // {
 * //   root: { message: "Error message" }
 * // }
 */
const formatErrorMessages = (error) => {
    var _a;
    var _b;
    const result = {};
    if ("validationErrors" in error) {
        const invalidRecordError = error;
        for (const validationError of invalidRecordError.validationErrors) {
            if (invalidRecordError.modelApiIdentifier) {
                (_a = result[_b = invalidRecordError.modelApiIdentifier]) !== null && _a !== void 0 ? _a : (result[_b] = {});
                result[invalidRecordError.modelApiIdentifier][validationError.apiIdentifier] = { message: validationError.message };
            }
            else {
                result[validationError.apiIdentifier] = { message: validationError.message };
            }
        }
    }
    else {
        const codeToReplace = "code" in error ? `${error.code}: ` : "";
        const message = error.message.replace(codeToReplace, "");
        result.root = { message };
    }
    return result;
};
//# sourceMappingURL=support.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/GadgetRecordList.js

/** Represents a list of objects returned from the API. Facilitates iterating and paginating. */
class GadgetRecordList_GadgetRecordList extends Array {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "modelManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    /** Internal method used to create a list. Should not be used by applications. */
    static boot(modelManager, records, pagination) {
        const list = new GadgetRecordList_GadgetRecordList();
        list.push(...records);
        list.modelManager = modelManager;
        list.pagination = pagination;
        Object.freeze(list);
        return list;
    }
    static get [Symbol.species]() {
        return Array;
    }
    firstOrThrow() {
        if (!this[0]) {
            throw new support_GadgetOperationError("No records found.", "GGT_RECORD_NOT_FOUND");
        }
        return this[0];
    }
    toJSON() {
        return this.map((record) => record.toJSON());
    }
    get hasNextPage() {
        return this.pagination.pageInfo.hasNextPage;
    }
    get hasPreviousPage() {
        return this.pagination.pageInfo.hasPreviousPage;
    }
    get startCursor() {
        return this.pagination.pageInfo.startCursor;
    }
    get endCursor() {
        return this.pagination.pageInfo.endCursor;
    }
    async nextPage() {
        var _a;
        if (!this.hasNextPage)
            throw new support_GadgetClientError("Cannot request next page because there isn't one, should check 'hasNextPage' to see if it exists");
        // Our current implementation of paging determines paging direction based on if "first" is defined. We can pass both "before" and "after" as options but only after is respected if first is sent. One of "before" or "after" is ignored depending on whether "first" is defined.
        const { first, last, before: _before, ...options } = (_a = this.pagination.options) !== null && _a !== void 0 ? _a : {};
        const nextPage = this.modelManager.findMany({
            ...options,
            after: this.pagination.pageInfo.endCursor,
            first: first || last,
        });
        return await nextPage;
    }
    async previousPage() {
        var _a;
        if (!this.hasPreviousPage)
            throw new support_GadgetClientError("Cannot request previous page because there isn't one, should check 'hasPreviousPage' to see if it exists");
        // Our current implementation of paging determines paging direction based on if "first" is defined. We can pass both "before" and "after" as options but only after is respected if first is sent. One of "before" or "after" is ignored depending on whether "first" is defined.
        const { first, last, after: _after, ...options } = (_a = this.pagination.options) !== null && _a !== void 0 ? _a : {};
        const prevPage = this.modelManager.findMany({
            ...options,
            before: this.pagination.pageInfo.startCursor,
            last: last || first,
        });
        return await prevPage;
    }
}
//# sourceMappingURL=GadgetRecordList.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/operationBuilders.js


/**
 * Converts Selection nested object format to the tiny-graphql-query-compiler shape
 **/
const fieldSelectionToQueryCompilerFields = (selection, includeTypename = false) => {
    const output = { ...selection };
    if (includeTypename)
        output.__typename = true;
    return output;
};
const directivesForOptions = (options) => {
    if (options === null || options === void 0 ? void 0 : options.live)
        return ["@live"];
    return undefined;
};
const operationBuilders_findOneOperation = (operation, id, defaultSelection, modelApiIdentifier, options, namespace) => {
    const variables = {};
    if (typeof id !== "undefined")
        variables.id = Var({ type: "GadgetID!", value: id });
    let fields = {
        [operation]: Call(variables, fieldSelectionToQueryCompilerFields((options === null || options === void 0 ? void 0 : options.select) || defaultSelection, true)),
    };
    fields = namespacify(namespace, fields);
    return compileWithVariableValues({
        type: "query",
        name: operation,
        fields: {
            ...fields,
            ...hydrationSelection(modelApiIdentifier, namespace),
        },
        directives: directivesForOptions(options),
    });
};
const operationBuilders_findOneByFieldOperation = (operation, fieldName, fieldValue, defaultSelection, modelApiIdentifier, options, namespace) => {
    return operationBuilders_findManyOperation(operation, defaultSelection, modelApiIdentifier, {
        ...options,
        first: 2,
        filter: {
            [fieldName]: {
                equals: fieldValue,
            },
        },
    }, namespace);
};
const operationBuilders_findManyOperation = (operation, defaultSelection, modelApiIdentifier, options, namespace) => {
    let fields = {
        [operation]: Call({
            after: Var({ value: options === null || options === void 0 ? void 0 : options.after, type: "String" }),
            first: Var({ value: options === null || options === void 0 ? void 0 : options.first, type: "Int" }),
            before: Var({ value: options === null || options === void 0 ? void 0 : options.before, type: "String" }),
            last: Var({ value: options === null || options === void 0 ? void 0 : options.last, type: "Int" }),
            sort: (options === null || options === void 0 ? void 0 : options.sort) ? Var({ value: options.sort, type: `[${sortTypeName(modelApiIdentifier, namespace)}!]` }) : undefined,
            filter: (options === null || options === void 0 ? void 0 : options.filter) ? Var({ value: options.filter, type: `[${filterTypeName(modelApiIdentifier, namespace)}!]` }) : undefined,
            search: (options === null || options === void 0 ? void 0 : options.search) ? Var({ value: options.search, type: "String" }) : undefined,
        }, {
            pageInfo: { hasNextPage: true, hasPreviousPage: true, startCursor: true, endCursor: true },
            edges: {
                cursor: true,
                node: fieldSelectionToQueryCompilerFields((options === null || options === void 0 ? void 0 : options.select) || defaultSelection, true),
            },
        }),
    };
    if (namespace) {
        fields = namespacify(namespace, fields);
    }
    return compileWithVariableValues({
        type: "query",
        name: operation,
        fields: {
            ...fields,
            ...hydrationSelection(modelApiIdentifier, namespace),
        },
        directives: directivesForOptions(options),
    });
};
const variableOptionsToVariables = (variables) => {
    return Object.fromEntries(Object.entries(variables).map(([name, options]) => [name, Var(options)]));
};
const actionResultFieldSelection = (modelSelectionField, selection, isBulkAction, hasReturnType, depth = 0) => {
    const fieldSelection = depth == 0
        ? {
            success: true,
            ...ErrorsSelection,
        }
        : {};
    if (hasReturnType && typeof hasReturnType != "boolean") {
        for (const [selectionField, returnTypeSelection] of Object.entries(hasReturnType)) {
            if ("select" in returnTypeSelection) {
                fieldSelection[selectionField] = fieldSelectionToQueryCompilerFields(selection, true);
            }
            else {
                fieldSelection[selectionField] = {
                    __typename: selectionField.includes("... on"),
                    ...actionResultFieldSelection(modelSelectionField, selection, isBulkAction, returnTypeSelection.hasReturnType, depth + 1),
                };
            }
        }
    }
    else if (hasReturnType) {
        fieldSelection[isBulkAction && depth == 0 ? "results" : "result"] = true;
    }
    else if (selection) {
        fieldSelection[modelSelectionField] = fieldSelectionToQueryCompilerFields(selection, true);
    }
    return fieldSelection;
};
const operationBuilders_actionOperation = (operation, defaultSelection, modelApiIdentifier, modelSelectionField, variables, options, namespace, isBulkAction, hasReturnType) => {
    const selection = (options === null || options === void 0 ? void 0 : options.select) || defaultSelection;
    let fields = {
        [operation]: Call(variableOptionsToVariables(variables), actionResultFieldSelection(modelSelectionField, selection, isBulkAction, hasReturnType)),
    };
    fields = namespacify(namespace, fields);
    const actionOperation = {
        type: "mutation",
        name: operation,
        fields: {
            ...fields,
            ...hydrationSelection(modelApiIdentifier, namespace),
        },
        directives: directivesForOptions(options),
    };
    return compileWithVariableValues(actionOperation);
};
const operationBuilders_backgroundActionResultOperation = (id, action, options) => {
    let fields = {};
    let resultType;
    const backgroundAction = action.isBulk && action.singleAction ? action.singleAction : action;
    let operationName = backgroundAction.operationName;
    if (backgroundAction.isBulk) {
        operationName = backgroundAction.operationName.replace(/^bulk/, "").replace(/s$/, "");
    }
    if (!backgroundAction.operationReturnType) {
        resultType = `${camelize(operationName)}Result`;
    }
    else {
        resultType = `${backgroundAction.operationReturnType}Result`;
    }
    switch (backgroundAction.type) {
        case "action": {
            const selection = (options === null || options === void 0 ? void 0 : options.select) || backgroundAction.defaultSelection;
            fields = {
                [`... on ${resultType}`]: actionResultFieldSelection(backgroundAction.modelApiIdentifier, selection, backgroundAction.isBulk, backgroundAction.hasReturnType),
            };
            break;
        }
        case "globalAction": {
            fields = {
                [`... on ${resultType}`]: globalActionFieldSelection(),
            };
        }
    }
    const actionResultOperation = {
        type: "subscription",
        name: capitalizeIdentifier(operationName) + "BackgroundResult",
        fields: {
            backgroundAction: Call({ id: Var({ value: id, type: "String!" }) }, {
                id: true,
                outcome: true,
                result: {
                    ...fields,
                },
            }),
        },
    };
    return compileWithVariableValues(actionResultOperation);
};
/** @deprecated previous export name, @see backgroundActionResultOperation */
const actionResultOperation = (/* unused pure expression or super */ null && (operationBuilders_backgroundActionResultOperation));
const globalActionFieldSelection = () => {
    return {
        success: true,
        ...ErrorsSelection,
        result: true,
    };
};
const operationBuilders_globalActionOperation = (operation, variables, namespace, options) => {
    let fields = {
        [operation]: Call(variableOptionsToVariables(variables), globalActionFieldSelection()),
    };
    fields = namespacify(namespace, fields);
    return compileWithVariableValues({
        type: "mutation",
        name: operation,
        fields,
        directives: directivesForOptions(options),
    });
};
const graphqlizeBackgroundOptions = (options) => {
    if (!options)
        return null;
    const obj = { ...options };
    if (typeof obj.retries == "number") {
        obj.retries = {
            retryCount: obj.retries,
        };
    }
    if (typeof obj.queue == "string") {
        obj.queue = {
            name: obj.queue,
        };
    }
    if (obj.startAt instanceof Date) {
        obj.startAt = obj.startAt.toISOString();
    }
    for (const key of Object.keys(obj)) {
        if (["id", "retries", "queue", "priority", "startAt"].includes(key))
            continue;
        delete obj[key];
    }
    return obj;
};
const operationBuilders_enqueueActionOperation = (operation, variables, namespace, options, isBulk) => {
    let fields = {
        [operation]: Call({
            ...variableOptionsToVariables(variables),
            backgroundOptions: Var({
                type: "EnqueueBackgroundActionOptions",
                value: graphqlizeBackgroundOptions(options),
            }),
        }, {
            success: true,
            errors: {
                message: true,
                code: true,
            },
            [isBulk ? "backgroundActions" : "backgroundAction"]: {
                id: true,
            },
        }),
    };
    fields = namespacify(namespace, fields);
    return compileWithVariableValues({
        type: "mutation",
        name: "enqueue" + camelize(operation),
        fields: {
            background: fields,
        },
    });
};
//# sourceMappingURL=operationBuilders.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/operationRunners.js





const mapAsyncIterable = (source, mapper) => {
    return {
        [Symbol.asyncIterator]() {
            const iter = source[Symbol.asyncIterator]();
            return {
                async next() {
                    const { done, value } = await iter.next();
                    return {
                        done,
                        value: typeof value != "undefined" ? mapper(value) : undefined,
                    };
                },
                async return(value) {
                    var _a;
                    return (await ((_a = iter.return) === null || _a === void 0 ? void 0 : _a.call(iter, value)));
                },
            };
        },
    };
};
/** Given a stream, return an async iterable when live querying, and a promise resolving to the last value otherwise */
function maybeLiveStream($result, mapper, options) {
    if (options === null || options === void 0 ? void 0 : options.live) {
        return mapAsyncIterable(toAsyncIterable($result), mapper);
    }
    else {
        const promise = pipe($result, filter((result) => !result.stale && !result.hasNext), take(1), toPromise);
        return promise.then((value) => mapper(value));
    }
}
const findOneRunner = (modelManager, operation, id, defaultSelection, modelApiIdentifier, options, throwOnEmptyData = true, namespace) => {
    const plan = findOneOperation(operation, id, defaultSelection, modelApiIdentifier, options, namespace);
    const $results = modelManager.connection.currentClient.query(plan.query, plan.variables);
    return maybeLiveStream($results, (response) => {
        const assertSuccess = throwOnEmptyData ? assertOperationSuccess : assertNullableOperationSuccess;
        const dataPath = namespaceDataPath([operation], namespace);
        const record = assertSuccess(response, dataPath);
        return hydrateRecord(response, record);
    }, options);
};
const findOneByFieldRunner = (modelManager, operation, fieldName, fieldValue, defaultSelection, modelApiIdentifier, options, throwOnEmptyData = true, namespace) => {
    const plan = findOneByFieldOperation(operation, fieldName, fieldValue, defaultSelection, modelApiIdentifier, options, namespace);
    const dataPath = namespaceDataPath([operation], namespace);
    const $results = modelManager.connection.currentClient.query(plan.query, plan.variables);
    return maybeLiveStream($results, (response) => {
        const connectionObject = assertOperationSuccess(response, dataPath);
        const records = hydrateConnection(response, connectionObject);
        if (records.length > 1) {
            throw getNonUniqueDataError(modelApiIdentifier, fieldName, fieldValue);
        }
        const result = records[0];
        if (!result && throwOnEmptyData) {
            throw new GadgetNotFoundError(`${modelApiIdentifier} record with ${fieldName}=${fieldValue} not found`);
        }
        return result !== null && result !== void 0 ? result : null;
    }, options);
};
const findManyRunner = (modelManager, operation, defaultSelection, modelApiIdentifier, options, throwOnEmptyData, namespace) => {
    const plan = findManyOperation(operation, defaultSelection, modelApiIdentifier, options, namespace);
    const $results = modelManager.connection.currentClient.query(plan.query, plan.variables);
    const dataPath = namespaceDataPath([operation], namespace);
    return maybeLiveStream($results, (response) => {
        let connectionObject;
        if (throwOnEmptyData === false) {
            // If this is a nullable operation, don't throw errors on empty
            connectionObject = assertNullableOperationSuccess(response, dataPath);
        }
        else {
            // Otherwise, passthrough the `throwOnEmptyData` flag, to account for
            // `findMany` (allows empty arrays) vs `findFirst` (no empty result) usage.
            connectionObject = assertOperationSuccess(response, dataPath, throwOnEmptyData);
        }
        const records = hydrateConnection(response, connectionObject);
        return GadgetRecordList.boot(modelManager, records, { options, pageInfo: connectionObject.pageInfo });
    }, options);
};
const actionRunner = async (modelManager, operation, defaultSelection, modelApiIdentifier, modelSelectionField, isBulkAction, variables, options, namespace, hasReturnType) => {
    const plan = actionOperation(operation, defaultSelection, modelApiIdentifier, modelSelectionField, variables, options, namespace, isBulkAction, hasReturnType);
    const response = await modelManager.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
    const dataPath = namespaceDataPath([operation], namespace);
    // pass bulk responses through without any assertions since we can have a success: false response but still want
    // to process it in a similar fashion since some of the records could have been processed
    if (!isBulkAction) {
        const mutationTriple = assertMutationSuccess(response, dataPath);
        return processActionResponse(defaultSelection, response, mutationTriple, modelSelectionField, hasReturnType);
    }
    else {
        const mutationTriple = get(response.data, dataPath);
        const results = processBulkActionResponse(defaultSelection, response, mutationTriple, modelSelectionField, hasReturnType);
        if (mutationTriple.errors) {
            const errors = mutationTriple.errors.map((error) => gadgetErrorFor(error));
            throw new GadgetErrorGroup(errors, results);
        }
        return results;
    }
};
const processBulkActionResponse = (defaultSelection, response, records, modelSelectionField, hasReturnType) => {
    if (defaultSelection == null)
        return;
    if (!hasReturnType) {
        return hydrateRecordArray(response, records[modelSelectionField]);
    }
    else if (typeof hasReturnType == "boolean") {
        return records.results;
    }
    else {
        return Object.entries(hasReturnType).flatMap(([returnTypeField, innerHasReturnType]) => {
            const results = records[returnTypeField];
            if (!Array.isArray(results)) {
                return [];
            }
            return results.map((result) => {
                const returnTypeForResult = "hasReturnType" in innerHasReturnType ? returnTypeForRecord(result, innerHasReturnType.hasReturnType) : false;
                if (!returnTypeForResult) {
                    return hydrateRecord(response, result);
                }
                else {
                    return processActionResponse(defaultSelection, response, result, modelSelectionField, returnTypeForResult);
                }
            });
        });
    }
};
const processActionResponse = (defaultSelection, response, record, modelSelectionField, hasReturnType) => {
    // Delete actions have a null selection. We do an early return for this because `hydrateRecordArray` will fail
    // if there's nothing at `mutationResult[modelSelectionField]`, but the caller isn't expecting a return (void).
    if (defaultSelection == null)
        return;
    if (!hasReturnType) {
        return hydrateRecord(response, record[modelSelectionField]);
    }
    else if (typeof hasReturnType == "boolean") {
        return record.result;
    }
    else {
        const innerReturnType = returnTypeForRecord(record, hasReturnType);
        return processActionResponse(defaultSelection, response, record, modelSelectionField, innerReturnType);
    }
};
const returnTypeForRecord = (record, hasReturnType) => {
    if (typeof hasReturnType == "boolean") {
        return hasReturnType;
    }
    const innerReturnTypeForTypename = hasReturnType[`... on ${record.__typename}`];
    return innerReturnTypeForTypename && "hasReturnType" in innerReturnTypeForTypename ? innerReturnTypeForTypename.hasReturnType : false;
};
const globalActionRunner = async (connection, operation, variables, namespace) => {
    const plan = globalActionOperation(operation, variables, namespace);
    const response = await connection.currentClient.mutation(plan.query, plan.variables).toPromise();
    const dataPath = namespaceDataPath([operation], namespace);
    return assertMutationSuccess(response, dataPath).result;
};
async function enqueueActionRunner(connection, action, variables, options = {}) {
    const normalizedVariableValues = action.isBulk
        ? disambiguateBulkActionVariables(action, variables)
        : disambiguateActionVariables(action, variables);
    const variableOptions = setVariableOptionValues(action.variables, normalizedVariableValues);
    const plan = enqueueActionOperation(action.operationName, variableOptions, action.namespace, options, action.isBulk);
    const response = await connection.currentClient.mutation(plan.query, plan.variables, options).toPromise();
    const dataPath = ["background", ...namespaceDataPath([action.operationName], action.namespace)];
    try {
        const result = assertMutationSuccess(response, dataPath);
        if (action.isBulk) {
            return result.backgroundActions.map((result) => new BackgroundActionHandle(connection, action, result.id));
        }
        else {
            return new BackgroundActionHandle(connection, action, result.backgroundAction.id);
        }
    }
    catch (error) {
        if ("code" in error && error.code == "GGT_DUPLICATE_BACKGROUND_ACTION_ID" && (options === null || options === void 0 ? void 0 : options.id) && options.onDuplicateID == "ignore") {
            return new BackgroundActionHandle(connection, action, options.id);
        }
        throw error;
    }
}
const operationRunners_backgroundActionResultRunner = async (connection, id, action, options) => {
    const plan = backgroundActionResultOperation(id, action, options);
    const subscription = connection.currentClient.subscription(plan.query, plan.variables);
    const response = await pipe(subscription, filter((operation) => { var _a, _b; return operation.error || ((_b = (_a = operation.data) === null || _a === void 0 ? void 0 : _a.backgroundAction) === null || _b === void 0 ? void 0 : _b.outcome); }), take(1), toPromise);
    const backgroundAction = assertOperationSuccess(response, ["backgroundAction"]);
    assertResponseSuccess(backgroundAction.result);
    switch (action.type) {
        case "action": {
            backgroundAction.result = processActionResponse(action.defaultSelection, response.data, backgroundAction.result, action.isBulk ? action.modelApiIdentifier : action.modelSelectionField, action.hasReturnType);
            break;
        }
        case "globalAction": {
            backgroundAction.result = backgroundAction.result.result;
            break;
        }
    }
    return backgroundAction;
};
/** @deprecated previous export name, @see backgroundActionResultRunner */
const actionResultRunner = (/* unused pure expression or super */ null && (operationRunners_backgroundActionResultRunner));
//# sourceMappingURL=operationRunners.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/BackgroundActionHandle.js

/** Represents a handle to a background action which has been enqueued */
class BackgroundActionHandle_BackgroundActionHandle {
    constructor(connection, action, id) {
        Object.defineProperty(this, "connection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: connection
        });
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: action
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: id
        });
    }
    /** Wait for this background action to complete and return the result. */
    async result(options) {
        return (await backgroundActionResultRunner(this.connection, this.id, this.action, options))
            .result;
    }
}
//# sourceMappingURL=BackgroundActionHandle.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/ClientOptions.js
/**
 * If using the `browserSession` authentication mode, sets how long the stored authentication information will last for for each user.
 */
var BrowserSessionStorageType;
(function (BrowserSessionStorageType) {
    /**
     * `Durable` authentications ask the browser to keep the user's authentication information around for as long as it can, like the "Remember Me" button on a lot of webpages. Uses `window.localStorage` to store authentication tokens.
     */
    BrowserSessionStorageType["Durable"] = "Durable";
    /**
     * `Session` authentications ask the browser to keep the user's authentication information around for a given browser tab, and then remove it when the tab is closed. Useful for high security scenarios where authenticated sessions are sensitive and should be forgotten quickly, or where the user's identity is temporary and only needs to last a short while. Uses `window.sessionStorage` to store authentication tokens.
     */
    BrowserSessionStorageType["Session"] = "session";
    /**
     * `Temporary` authentications don't ask the browser to keep the user's authentication information around at all, such that refreshing the page will result in the user having no saved authentication state and likely being logged out. Useful for high security scenarios where authenticated sessions are sensitive and should be forgotten quickly.
     */
    BrowserSessionStorageType["Temporary"] = "temporary";
})(BrowserSessionStorageType || (BrowserSessionStorageType = {}));
//# sourceMappingURL=ClientOptions.js.map
;// ../../node_modules/.pnpm/@urql+core@4.0.10_graphql@16.8.1/node_modules/@urql/core/dist/urql-core.mjs








var collectTypes = (e, r) => {
  if (Array.isArray(e)) {
    for (var t of e) {
      collectTypes(t, r);
    }
  } else if ("object" == typeof e && null !== e) {
    for (var n in e) {
      if ("__typename" === n && "string" == typeof e[n]) {
        r.add(e[n]);
      } else {
        collectTypes(e[n], r);
      }
    }
  }
  return r;
};

var formatNode = r => {
  var t = !1;
  if ("definitions" in r) {
    var n = [];
    for (var a of r.definitions) {
      var o = formatNode(a);
      t = t || o !== a;
      n.push(o);
    }
    if (t) {
      return {
        ...r,
        definitions: n
      };
    }
  } else if ("selectionSet" in r) {
    var i = [];
    var s = r.kind === graphql_web_e.OPERATION_DEFINITION;
    if (r.selectionSet) {
      for (var c of r.selectionSet.selections || []) {
        s = s || c.kind === graphql_web_e.FIELD && "__typename" === c.name.value && !c.alias;
        var u = formatNode(c);
        t = t || u !== c;
        i.push(u);
      }
      if (!s) {
        t = !0;
        i.push({
          kind: graphql_web_e.FIELD,
          name: {
            kind: graphql_web_e.NAME,
            value: "__typename"
          }
        });
      }
      if (t) {
        return {
          ...r,
          selectionSet: {
            ...r.selectionSet,
            selections: i
          }
        };
      }
    }
  }
  return r;
};

var I = new Map;

var formatDocument = e => {
  var t = keyDocument(e);
  var n = I.get(t.__key);
  if (!n) {
    I.set(t.__key, n = formatNode(t));
    Object.defineProperty(n, "__key", {
      value: t.__key,
      enumerable: !1
    });
  }
  return n;
};

var maskTypename = (e, r) => {
  if (!e || "object" != typeof e) {
    return e;
  } else if (Array.isArray(e)) {
    return e.map((e => maskTypename(e)));
  } else if (e && "object" == typeof e && (r || "__typename" in e)) {
    var t = {};
    for (var n in e) {
      if ("__typename" === n) {
        Object.defineProperty(t, "__typename", {
          enumerable: !1,
          value: e.__typename
        });
      } else {
        t[n] = maskTypename(e[n]);
      }
    }
    return t;
  } else {
    return e;
  }
};

function withPromise(e) {
  var source$ = r => e(r);
  source$.toPromise = () => wonka_toPromise(wonka_take(1)(wonka_filter((e => !e.stale && !e.hasNext))(source$)));
  source$.then = (e, r) => source$.toPromise().then(e, r);
  source$.subscribe = e => subscribe(e)(source$);
  return source$;
}

function makeOperation(e, r, t) {
  return {
    ...r,
    kind: e,
    context: r.context ? {
      ...r.context,
      ...t
    } : t || r.context
  };
}

var addMetadata = (e, r) => makeOperation(e.kind, e, {
  meta: {
    ...e.context.meta,
    ...r
  }
});

var noop = () => {};

function gql(n) {
  var a = new Map;
  var o = [];
  var i = [];
  var s = Array.isArray(n) ? n[0] : n || "";
  for (var c = 1; c < arguments.length; c++) {
    var u = arguments[c];
    if (u && u.definitions) {
      i.push(u);
    } else {
      s += u;
    }
    s += arguments[0][c];
  }
  i.unshift(r(s));
  for (var p of i) {
    for (var d of p.definitions) {
      if (d.kind === e.FRAGMENT_DEFINITION) {
        var f = d.name.value;
        var v = t(d);
        if (!a.has(f)) {
          a.set(f, v);
          o.push(d);
        } else if (false) {}
      } else {
        o.push(d);
      }
    }
  }
  return r({
    kind: e.DOCUMENT,
    definitions: o
  });
}

var shouldSkip = ({kind: e}) => "mutation" !== e && "query" !== e;

var cacheExchange = ({forward: e, client: r, dispatchDebug: t}) => {
  var n = new Map;
  var a = new Map;
  var mapTypeNames = e => {
    var r = makeOperation(e.kind, e);
    r.query = formatDocument(e.query);
    return r;
  };
  var isOperationCached = e => "query" === e.kind && "network-only" !== e.context.requestPolicy && ("cache-only" === e.context.requestPolicy || n.has(e.key));
  return o => {
    var i = map((e => {
      var a = n.get(e.key);
       false && 0;
      var o = a;
      if (false) {}
      if ("cache-and-network" === e.context.requestPolicy) {
        o.stale = !0;
        reexecuteOperation(r, e);
      }
      return o;
    }))(wonka_filter((e => !shouldSkip(e) && isOperationCached(e)))(o));
    var s = onPush((e => {
      var {operation: o} = e;
      if (!o) {
        return;
      }
      var i = o.context.additionalTypenames || [];
      if ("subscription" !== e.operation.kind) {
        i = (e => [ ...collectTypes(e, new Set) ])(e.data).concat(i);
      }
      if ("mutation" === e.operation.kind || "subscription" === e.operation.kind) {
        var s = new Set;
         false && 0;
        for (var c = 0; c < i.length; c++) {
          var u = i[c];
          var p = a.get(u);
          if (!p) {
            a.set(u, p = new Set);
          }
          for (var d of p.values()) {
            s.add(d);
          }
          p.clear();
        }
        for (var f of s.values()) {
          if (n.has(f)) {
            o = n.get(f).operation;
            n.delete(f);
            reexecuteOperation(r, o);
          }
        }
      } else if ("query" === o.kind && e.data) {
        n.set(o.key, e);
        for (var v = 0; v < i.length; v++) {
          var l = i[v];
          var h = a.get(l);
          if (!h) {
            a.set(l, h = new Set);
          }
          h.add(o.key);
        }
      }
    }))(e(wonka_filter((e => "query" !== e.kind || "cache-only" !== e.context.requestPolicy))(map((e =>  false ? 0 : e))(merge([ map(mapTypeNames)(wonka_filter((e => !shouldSkip(e) && !isOperationCached(e)))(o)), wonka_filter((e => shouldSkip(e)))(o) ])))));
    return merge([ i, s ]);
  };
};

var reexecuteOperation = (e, r) => e.reexecuteOperation(makeOperation(r.kind, r, {
  requestPolicy: "network-only"
}));

var T = new Set;

var ssrExchange = (e = {}) => {
  var r = !!e.staleWhileRevalidate;
  var t = !!e.includeExtensions;
  var a = {};
  var o = [];
  var invalidate = e => {
    o.push(e.operation.key);
    if (1 === o.length) {
      Promise.resolve().then((() => {
        var e;
        while (e = o.shift()) {
          a[e] = null;
        }
      }));
    }
  };
  var ssr = ({client: o, forward: i}) => s => {
    var c = e && "boolean" == typeof e.isClient ? !!e.isClient : !o.suspense;
    var u = i(y((e => !a[e.key] || !!a[e.key].hasNext || "network-only" === e.context.requestPolicy))(s));
    var p = m((e => {
      var i = ((e, r, t) => ({
        operation: e,
        data: r.data ? JSON.parse(r.data) : void 0,
        extensions: t && r.extensions ? JSON.parse(r.extensions) : void 0,
        error: r.error ? new n({
          networkError: r.error.networkError ? new Error(r.error.networkError) : void 0,
          graphQLErrors: r.error.graphQLErrors
        }) : void 0,
        stale: !1,
        hasNext: !!r.hasNext
      }))(e, a[e.key], t);
      if (r && !T.has(e.key)) {
        i.stale = !0;
        T.add(e.key);
        reexecuteOperation(o, e);
      }
      return {
        ...i,
        operation:  false ? 0 : e
      };
    }))(y((e => !!a[e.key] && "network-only" !== e.context.requestPolicy))(s));
    if (!c) {
      u = x((e => {
        var {operation: r} = e;
        if ("mutation" !== r.kind) {
          var n = ((e, r) => {
            var t = {
              data: JSON.stringify(e.data),
              hasNext: e.hasNext
            };
            if (void 0 !== e.data) {
              t.data = JSON.stringify(e.data);
            }
            if (r && void 0 !== e.extensions) {
              t.extensions = JSON.stringify(e.extensions);
            }
            if (e.error) {
              t.error = {
                graphQLErrors: e.error.graphQLErrors.map((e => {
                  if (!e.path && !e.extensions) {
                    return e.message;
                  }
                  return {
                    message: e.message,
                    path: e.path,
                    extensions: e.extensions
                  };
                }))
              };
              if (e.error.networkError) {
                t.error.networkError = "" + e.error.networkError;
              }
            }
            return t;
          })(e, t);
          a[r.key] = n;
        }
      }))(u);
    } else {
      p = x(invalidate)(p);
    }
    return E([ u, p ]);
  };
  ssr.restoreData = e => {
    for (var r in e) {
      if (null !== a[r]) {
        a[r] = e[r];
      }
    }
  };
  ssr.extractData = () => {
    var e = {};
    for (var r in a) {
      if (null != a[r]) {
        e[r] = a[r];
      }
    }
    return e;
  };
  if (e && e.initialState) {
    ssr.restoreData(e.initialState);
  }
  return ssr;
};

var subscriptionExchange = ({forwardSubscription: e, enableAllOperations: r, isSubscriptionOperation: t}) => ({client: n, forward: i}) => {
  var u = t || (e => "subscription" === e.kind || !!r && ("query" === e.kind || "mutation" === e.kind));
  return r => {
    var t = mergeMap((t => {
      var {key: i} = t;
      var u = wonka_filter((e => "teardown" === e.kind && e.key === i))(r);
      return takeUntil(u)((r => {
        var t = e(makeFetchBody(r), r);
        return make((({next: e, complete: a}) => {
          var i = !1;
          var u;
          var p;
          Promise.resolve().then((() => {
            if (i) {
              return;
            }
            u = t.subscribe({
              next(t) {
                e(p = p ? mergeResultPatch(p, t) : makeResult(r, t));
              },
              error(t) {
                e(makeErrorResult(r, t));
              },
              complete() {
                if (!i) {
                  i = !0;
                  if ("subscription" === r.kind) {
                    n.reexecuteOperation(makeOperation("teardown", r, r.context));
                  }
                  if (p && p.hasNext) {
                    e(mergeResultPatch(p, {
                      hasNext: !1
                    }));
                  }
                  a();
                }
              }
            });
          }));
          return () => {
            i = !0;
            if (u) {
              u.unsubscribe();
            }
          };
        }));
      })(t));
    }))(wonka_filter((e => "teardown" !== e.kind && u(e)))(r));
    var p = i(wonka_filter((e => "teardown" === e.kind || !u(e)))(r));
    return merge([ t, p ]);
  };
};

var debugExchange = ({forward: e}) => {
  if (true) {
    return r => e(r);
  } else {}
};

var dedupExchange = ({forward: e}) => r => e(r);

var fetchExchange = ({forward: e, dispatchDebug: r}) => t => {
  var n = mergeMap((e => {
    var n = makeFetchBody(e);
    var o = makeFetchURL(e, n);
    var i = makeFetchOptions(e, n);
     false && 0;
    var s = takeUntil(wonka_filter((r => "teardown" === r.kind && r.key === e.key))(t))(makeFetchSource(e, o, i));
    if (false) {}
    return s;
  }))(wonka_filter((e => "teardown" !== e.kind && ("subscription" !== e.kind || !!e.context.fetchSubscriptions)))(t));
  var o = e(wonka_filter((e => "teardown" === e.kind || "subscription" === e.kind && !e.context.fetchSubscriptions))(t));
  return merge([ n, o ]);
};

var composeExchanges = e => ({client: r, forward: t, dispatchDebug: n}) => e.reduceRight(((e, t) => {
  var a = !1;
  return t({
    client: r,
    forward(r) {
      if (false) {}
      return share(e(share(r)));
    },
    dispatchDebug(e) {
       false && 0;
    }
  });
}), t);

var mapExchange = ({onOperation: e, onResult: r, onError: t}) => ({forward: n}) => a => mergeMap((e => {
  if (t && e.error) {
    t(e.error, e.operation);
  }
  var n = r && r(e) || e;
  return "then" in n ? fromPromise(n) : fromValue(n);
}))(n(mergeMap((r => {
  var t = e && e(r) || r;
  return "then" in t ? fromPromise(t) : fromValue(t);
}))(a)));

var fallbackExchange = ({dispatchDebug: e}) => r => {
  if (false) {}
  return wonka_filter((e => !1))(r);
};

var C = function Client(e) {
  if (false) {}
  var r = 0;
  var t = new Map;
  var n = new Map;
  var a = new Set;
  var o = [];
  var i = {
    url: e.url,
    fetchSubscriptions: e.fetchSubscriptions,
    fetchOptions: e.fetchOptions,
    fetch: e.fetch,
    preferGetMethod: !!e.preferGetMethod,
    requestPolicy: e.requestPolicy || "cache-first"
  };
  var s = makeSubject();
  function nextOperation(e) {
    if ("mutation" === e.kind || "teardown" === e.kind || !a.has(e.key)) {
      if ("teardown" === e.kind) {
        a.delete(e.key);
      } else if ("mutation" !== e.kind) {
        a.add(e.key);
      }
      s.next(e);
    }
  }
  var c = !1;
  function dispatchOperation(e) {
    if (e) {
      nextOperation(e);
    }
    if (!c) {
      c = !0;
      while (c && (e = o.shift())) {
        nextOperation(e);
      }
      c = !1;
    }
  }
  var makeResultSource = r => {
    var i = takeUntil(wonka_filter((e => "teardown" === e.kind && e.key === r.key))(s.source))(wonka_filter((e => e.operation.kind === r.kind && e.operation.key === r.key && (!e.operation.context._instance || e.operation.context._instance === r.context._instance)))(g));
    if ("query" !== r.kind) {
      i = takeWhile((e => !!e.hasNext), !0)(i);
    } else {
      i = switchMap((e => {
        var t = fromValue(e);
        return e.stale || e.hasNext ? t : merge([ t, map((() => {
          e.stale = !0;
          return e;
        }))(wonka_take(1)(wonka_filter((e => e.key === r.key))(s.source))) ]);
      }))(i);
    }
    if ("mutation" !== r.kind) {
      i = onEnd((() => {
        a.delete(r.key);
        t.delete(r.key);
        n.delete(r.key);
        c = !1;
        for (var e = o.length - 1; e >= 0; e--) {
          if (o[e].key === r.key) {
            o.splice(e, 1);
          }
        }
        nextOperation(makeOperation("teardown", r, r.context));
      }))(onPush((e => {
        if (e.stale) {
          for (var n of o) {
            if (n.key === e.operation.key) {
              a.delete(n.key);
              break;
            }
          }
        } else if (!e.hasNext) {
          a.delete(r.key);
        }
        t.set(r.key, e);
      }))(i));
    } else {
      i = onStart((() => {
        nextOperation(r);
      }))(i);
    }
    if (e.maskTypename) {
      i = map((e => ({
        ...e,
        data: maskTypename(e.data, !0)
      })))(i);
    }
    return share(i);
  };
  var u = this instanceof Client ? this : Object.create(Client.prototype);
  var p = Object.assign(u, {
    suspense: !!e.suspense,
    operations$: s.source,
    reexecuteOperation(e) {
      if ("teardown" === e.kind) {
        dispatchOperation(e);
      } else if ("mutation" === e.kind || n.has(e.key)) {
        o.push(e);
        Promise.resolve().then(dispatchOperation);
      }
    },
    createRequestOperation(e, t, n) {
      if (!n) {
        n = {};
      }
      var a;
      if (false) {}
      return makeOperation(e, t, {
        _instance: "mutation" === e ? r = r + 1 | 0 : void 0,
        ...i,
        ...n,
        requestPolicy: n.requestPolicy || i.requestPolicy,
        suspense: n.suspense || !1 !== n.suspense && p.suspense
      });
    },
    executeRequestOperation(e) {
      if ("mutation" === e.kind) {
        return withPromise(makeResultSource(e));
      }
      return withPromise(lazy((() => {
        var r = n.get(e.key);
        if (!r) {
          n.set(e.key, r = makeResultSource(e));
        }
        r = onStart((() => {
          dispatchOperation(e);
        }))(r);
        var a = t.get(e.key);
        if ("query" === e.kind && a && (a.stale || a.hasNext)) {
          return switchMap(fromValue)(merge([ r, wonka_filter((r => r === t.get(e.key)))(fromValue(a)) ]));
        } else {
          return r;
        }
      })));
    },
    executeQuery(e, r) {
      var t = p.createRequestOperation("query", e, r);
      return p.executeRequestOperation(t);
    },
    executeSubscription(e, r) {
      var t = p.createRequestOperation("subscription", e, r);
      return p.executeRequestOperation(t);
    },
    executeMutation(e, r) {
      var t = p.createRequestOperation("mutation", e, r);
      return p.executeRequestOperation(t);
    },
    readQuery(e, r, t) {
      var n = null;
      subscribe((e => {
        n = e;
      }))(p.query(e, r, t)).unsubscribe();
      return n;
    },
    query: (e, r, t) => p.executeQuery(createRequest(e, r), t),
    subscription: (e, r, t) => p.executeSubscription(createRequest(e, r), t),
    mutation: (e, r, t) => p.executeMutation(createRequest(e, r), t)
  });
  var d = noop;
  if (false) { var x, l; }
  var w = composeExchanges(e.exchanges);
  var g = share(w({
    client: p,
    dispatchDebug: d,
    forward: fallbackExchange({
      dispatchDebug: d
    })
  })(s.source));
  publish(g);
  return p;
};

var j = (/* unused pure expression or super */ null && (C));


//# sourceMappingURL=urql-core.mjs.map

;// ../../node_modules/.pnpm/graphql-ws@5.14.1_graphql@16.8.1/node_modules/graphql-ws/lib/utils.mjs
/** @private */
function extendedTypeof(val) {
    if (val === null) {
        return 'null';
    }
    if (Array.isArray(val)) {
        return 'array';
    }
    return typeof val;
}
/** @private */
function isObject(val) {
    return extendedTypeof(val) === 'object';
}
/** @private */
function isAsyncIterable(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
/** @private */
function isAsyncGenerator(val) {
    return (isObject(val) &&
        typeof Object(val)[Symbol.asyncIterator] === 'function' &&
        typeof val.return === 'function'
    // for lazy ones, we only need the return anyway
    // typeof val.throw === 'function' &&
    // typeof val.next === 'function'
    );
}
/** @private */
function areGraphQLErrors(obj) {
    return (Array.isArray(obj) &&
        // must be at least one error
        obj.length > 0 &&
        // error has at least a message
        obj.every((ob) => 'message' in ob));
}
/**
 * Limits the WebSocket close event reason to not exceed a length of one frame.
 * Reference: https://datatracker.ietf.org/doc/html/rfc6455#section-5.2.
 *
 * @private
 */
function limitCloseReason(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

;// ../../node_modules/.pnpm/graphql-ws@5.14.1_graphql@16.8.1/node_modules/graphql-ws/lib/common.mjs
/**
 *
 * common
 *
 */

/**
 * The WebSocket sub-protocol used for the [GraphQL over WebSocket Protocol](https://github.com/graphql/graphql-over-http/blob/main/rfcs/GraphQLOverWebSocket.md).
 *
 * @category Common
 */
const GRAPHQL_TRANSPORT_WS_PROTOCOL = 'graphql-transport-ws';
/**
 * The deprecated subprotocol used by [subscriptions-transport-ws](https://github.com/apollographql/subscriptions-transport-ws).
 *
 * @private
 */
const DEPRECATED_GRAPHQL_WS_PROTOCOL = 'graphql-ws';
/**
 * `graphql-ws` expected and standard close codes of the [GraphQL over WebSocket Protocol](https://github.com/graphql/graphql-over-http/blob/main/rfcs/GraphQLOverWebSocket.md).
 *
 * @category Common
 */
var CloseCode;
(function (CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */
    CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */
    CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})(CloseCode || (CloseCode = {}));
/**
 * Types of messages allowed to be sent by the client/server over the WS protocol.
 *
 * @category Common
 */
var MessageType;
(function (MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})(MessageType || (MessageType = {}));
/**
 * Validates the message against the GraphQL over WebSocket Protocol.
 *
 * Invalid messages will throw descriptive errors.
 *
 * @category Common
 */
function validateMessage(val) {
    if (!isObject(val)) {
        throw new Error(`Message is expected to be an object, but got ${extendedTypeof(val)}`);
    }
    if (!val.type) {
        throw new Error(`Message is missing the 'type' property`);
    }
    if (typeof val.type !== 'string') {
        throw new Error(`Message is expects the 'type' property to be a string, but got ${extendedTypeof(val.type)}`);
    }
    switch (val.type) {
        case MessageType.ConnectionInit:
        case MessageType.ConnectionAck:
        case MessageType.Ping:
        case MessageType.Pong: {
            if (val.payload != null && !isObject(val.payload)) {
                throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            }
            break;
        }
        case MessageType.Subscribe: {
            if (typeof val.id !== 'string') {
                throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
            }
            if (!val.id) {
                throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            }
            if (!isObject(val.payload)) {
                throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
            }
            if (typeof val.payload.query !== 'string') {
                throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${extendedTypeof(val.payload.query)}`);
            }
            if (val.payload.variables != null && !isObject(val.payload.variables)) {
                throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.variables)}`);
            }
            if (val.payload.operationName != null &&
                extendedTypeof(val.payload.operationName) !== 'string') {
                throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${extendedTypeof(val.payload.operationName)}`);
            }
            if (val.payload.extensions != null && !isObject(val.payload.extensions)) {
                throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.extensions)}`);
            }
            break;
        }
        case MessageType.Next: {
            if (typeof val.id !== 'string') {
                throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
            }
            if (!val.id) {
                throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            }
            if (!isObject(val.payload)) {
                throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
            }
            break;
        }
        case MessageType.Error: {
            if (typeof val.id !== 'string') {
                throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
            }
            if (!val.id) {
                throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            }
            if (!areGraphQLErrors(val.payload)) {
                throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            }
            break;
        }
        case MessageType.Complete: {
            if (typeof val.id !== 'string') {
                throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
            }
            if (!val.id) {
                throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            }
            break;
        }
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
/**
 * Checks if the provided value is a valid GraphQL over WebSocket message.
 *
 * @deprecated Use `validateMessage` instead.
 *
 * @category Common
 */
function isMessage(val) {
    try {
        validateMessage(val);
        return true;
    }
    catch (_a) {
        return false;
    }
}
/**
 * Parses the raw websocket message data to a valid message.
 *
 * @category Common
 */
function parseMessage(data, reviver) {
    return validateMessage(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
/**
 * Stringifies a valid message ready to be sent through the socket.
 *
 * @category Common
 */
function stringifyMessage(msg, replacer) {
    validateMessage(msg);
    return JSON.stringify(msg, replacer);
}

;// ../../node_modules/.pnpm/graphql-ws@5.14.1_graphql@16.8.1/node_modules/graphql-ws/lib/client.mjs
/**
 *
 * client
 *
 */
var __await = (undefined && undefined.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (undefined && undefined.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};


/** This file is the entry point for browsers, re-export common elements. */

/**
 * Creates a disposable GraphQL over WebSocket client.
 *
 * @category Client
 */
function createClient(options) {
    const { url, connectionParams, lazy = true, onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive = 0, disablePong, connectionAckWaitTimeout = 0, retryAttempts = 5, retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for (let i = 0; i < retries; i++) {
            retryDelay *= 2;
        }
        await new Promise((resolve) => setTimeout(resolve, retryDelay +
            // add random timeout from 300ms to 3s
            Math.floor(Math.random() * (3000 - 300) + 300)));
    }, shouldRetry = isLikeCloseEvent, isFatalConnectionProblem, on, webSocketImpl, 
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver, } = options;
    let ws;
    if (webSocketImpl) {
        if (!isWebSocket(webSocketImpl)) {
            throw new Error('Invalid WebSocket implementation provided');
        }
        ws = webSocketImpl;
    }
    else if (typeof WebSocket !== 'undefined') {
        ws = WebSocket;
    }
    else if (typeof global !== 'undefined') {
        ws =
            global.WebSocket ||
                // @ts-expect-error: Support more browsers
                global.MozWebSocket;
    }
    else if (typeof window !== 'undefined') {
        ws =
            window.WebSocket ||
                // @ts-expect-error: Support more browsers
                window.MozWebSocket;
    }
    if (!ws)
        throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (() => {
        const message = (() => {
            const listeners = {};
            return {
                on(id, listener) {
                    listeners[id] = listener;
                    return () => {
                        delete listeners[id];
                    };
                },
                emit(message) {
                    var _a;
                    if ('id' in message)
                        (_a = listeners[message.id]) === null || _a === void 0 ? void 0 : _a.call(listeners, message);
                },
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [on.connecting] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [on.opened] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [on.connected] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [on.ping] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [on.pong] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [message.emit, on.message] : [message.emit],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [on.closed] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [on.error] : [],
        };
        return {
            onMessage: message.on,
            on(event, listener) {
                const l = listeners[event];
                l.push(listener);
                return () => {
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit(event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [...listeners[event]]) {
                    // @ts-expect-error: The args should fit
                    listener(...args);
                }
            },
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err) => {
                listening.forEach((unlisten) => unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event) => {
                listening.forEach((unlisten) => unlisten());
                cb(event);
            }),
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : (connecting = new Promise((connected, denied) => (async () => {
            if (retrying) {
                await retryWait(retries);
                // subscriptions might complete while waiting for retry
                if (!locks) {
                    connecting = undefined;
                    return denied({ code: 1000, reason: 'All Subscriptions Gone' });
                }
                retries++;
            }
            emitter.emit('connecting');
            const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, GRAPHQL_TRANSPORT_WS_PROTOCOL);
            let connectionAckTimeout, queuedPing;
            function enqueuePing() {
                if (isFinite(keepAlive) && keepAlive > 0) {
                    clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                    queuedPing = setTimeout(() => {
                        if (socket.readyState === WebSocketImpl.OPEN) {
                            socket.send(stringifyMessage({ type: MessageType.Ping }));
                            emitter.emit('ping', false, undefined);
                        }
                    }, keepAlive);
                }
            }
            errorOrClosed((errOrEvent) => {
                connecting = undefined;
                clearTimeout(connectionAckTimeout);
                clearTimeout(queuedPing);
                denied(errOrEvent);
                if (isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                    socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                    socket.onerror = null;
                    socket.onclose = null;
                }
            });
            socket.onerror = (err) => emitter.emit('error', err);
            socket.onclose = (event) => emitter.emit('closed', event);
            socket.onopen = async () => {
                try {
                    emitter.emit('opened', socket);
                    const payload = typeof connectionParams === 'function'
                        ? await connectionParams()
                        : connectionParams;
                    // connectionParams might take too long causing the server to kick off the client
                    // the necessary error/close event is already reported - simply stop execution
                    if (socket.readyState !== WebSocketImpl.OPEN)
                        return;
                    socket.send(stringifyMessage(payload
                        ? {
                            type: MessageType.ConnectionInit,
                            payload,
                        }
                        : {
                            type: MessageType.ConnectionInit,
                            // payload is completely absent if not provided
                        }, replacer));
                    if (isFinite(connectionAckWaitTimeout) &&
                        connectionAckWaitTimeout > 0) {
                        connectionAckTimeout = setTimeout(() => {
                            socket.close(CloseCode.ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                    }
                    enqueuePing(); // enqueue ping (noop if disabled)
                }
                catch (err) {
                    emitter.emit('error', err);
                    socket.close(CloseCode.InternalClientError, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                }
            };
            let acknowledged = false;
            socket.onmessage = ({ data }) => {
                try {
                    const message = parseMessage(data, reviver);
                    emitter.emit('message', message);
                    if (message.type === 'ping' || message.type === 'pong') {
                        emitter.emit(message.type, true, message.payload); // received
                        if (message.type === 'pong') {
                            enqueuePing(); // enqueue next ping (noop if disabled)
                        }
                        else if (!disablePong) {
                            // respond with pong on ping
                            socket.send(stringifyMessage(message.payload
                                ? {
                                    type: MessageType.Pong,
                                    payload: message.payload,
                                }
                                : {
                                    type: MessageType.Pong,
                                    // payload is completely absent if not provided
                                }));
                            emitter.emit('pong', false, message.payload);
                        }
                        return; // ping and pongs can be received whenever
                    }
                    if (acknowledged)
                        return; // already connected and acknowledged
                    if (message.type !== MessageType.ConnectionAck)
                        throw new Error(`First message cannot be of type ${message.type}`);
                    clearTimeout(connectionAckTimeout);
                    acknowledged = true;
                    emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                    retrying = false; // future lazy connects are not retries
                    retries = 0; // reset the retries on connect
                    connected([
                        socket,
                        new Promise((_, reject) => errorOrClosed(reject)),
                    ]);
                }
                catch (err) {
                    socket.onmessage = null; // stop reading messages as soon as reading breaks once
                    emitter.emit('error', err);
                    socket.close(CloseCode.BadResponse, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                }
            };
        })())));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING)
            await throwOnClose;
        let release = () => {
            // releases this connection
        };
        const released = new Promise((resolve) => (release = resolve));
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(() => {
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = () => socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) {
                            // if the keepalive is set, allow for the specified calmdown time and
                            // then complete if the socket is still open.
                            lazyCloseTimeout = setTimeout(() => {
                                if (socket.readyState === WebSocketImpl.OPEN)
                                    complete();
                            }, lazyCloseTimeoutMs);
                        }
                        else {
                            // otherwise complete immediately
                            complete();
                        }
                    }
                }),
                // or
                throwOnClose,
            ]),
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */
    function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if (isLikeCloseEvent(errOrCloseEvent) &&
            (isFatalInternalCloseCode(errOrCloseEvent.code) ||
                [
                    CloseCode.InternalServerError,
                    CloseCode.InternalClientError,
                    CloseCode.BadRequest,
                    CloseCode.BadResponse,
                    CloseCode.Unauthorized,
                    // CloseCode.Forbidden, might grant access out after retry
                    CloseCode.SubprotocolNotAcceptable,
                    // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
                    // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
                    CloseCode.SubscriberAlreadyExists,
                    CloseCode.TooManyInitialisationRequests,
                    // 4499, // Terminated, probably because the socket froze, we want to retry
                ].includes(errOrCloseEvent.code)))
            throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed)
            return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000)
            return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts)
            throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent))
            throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent))
            throw errOrCloseEvent;
        // looks good, start retrying
        return (retrying = true);
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) {
        (async () => {
            locks++;
            for (;;) {
                try {
                    const [, , throwOnClose] = await connect();
                    await throwOnClose; // will always throw because releaser is not used
                }
                catch (errOrCloseEvent) {
                    try {
                        if (!shouldRetryConnectOrThrow(errOrCloseEvent))
                            return;
                    }
                    catch (errOrCloseEvent) {
                        // report thrown error, no further retries
                        return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
                    }
                }
            }
        })();
    }
    return {
        on: emitter.on,
        subscribe(payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = () => {
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async () => {
                locks++;
                for (;;) {
                    try {
                        const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                        // if done while waiting for connect, release the connection lock right away
                        if (done)
                            return release();
                        const unlisten = emitter.onMessage(id, (message) => {
                            switch (message.type) {
                                case MessageType.Next: {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                    sink.next(message.payload);
                                    return;
                                }
                                case MessageType.Error: {
                                    (errored = true), (done = true);
                                    sink.error(message.payload);
                                    releaser();
                                    return;
                                }
                                case MessageType.Complete: {
                                    done = true;
                                    releaser(); // release completes the sink
                                    return;
                                }
                            }
                        });
                        socket.send(stringifyMessage({
                            id,
                            type: MessageType.Subscribe,
                            payload,
                        }, replacer));
                        releaser = () => {
                            if (!done && socket.readyState === WebSocketImpl.OPEN)
                                // if not completed already and socket is open, send complete message to server on release
                                socket.send(stringifyMessage({
                                    id,
                                    type: MessageType.Complete,
                                }, replacer));
                            locks--;
                            done = true;
                            release();
                        };
                        // either the releaser will be called, connection completed and
                        // the promise resolved or the socket closed and the promise rejected.
                        // whatever happens though, we want to stop listening for messages
                        await waitForReleaseOrThrowOnClose.finally(unlisten);
                        return; // completed, shouldnt try again
                    }
                    catch (errOrCloseEvent) {
                        if (!shouldRetryConnectOrThrow(errOrCloseEvent))
                            return;
                    }
                }
            })()
                .then(() => {
                // delivering either an error or a complete terminates the sequence
                if (!errored)
                    sink.complete();
            }) // resolves on release or normal closure
                .catch((err) => {
                sink.error(err);
            }); // rejects on close events and errors
            return () => {
                // dispose only of active subscriptions
                if (!done)
                    releaser();
            };
        },
        iterate(request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: () => {
                    // noop
                },
            };
            const dispose = this.subscribe(request, {
                next(val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error(err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete() {
                    deferred.done = true;
                    deferred.resolve();
                },
            });
            const iterator = (function iterator() {
                return __asyncGenerator(this, arguments, function* iterator_1() {
                    for (;;) {
                        if (!pending.length) {
                            // only wait if there are no pending messages available
                            yield __await(new Promise((resolve) => (deferred.resolve = resolve)));
                        }
                        // first flush
                        while (pending.length) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            yield yield __await(pending.shift());
                        }
                        // then error
                        if (deferred.error) {
                            throw deferred.error;
                        }
                        // or complete
                        if (deferred.done) {
                            return yield __await(void 0);
                        }
                    }
                });
            })();
            iterator.throw = async (err) => {
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return { done: true, value: undefined };
            };
            iterator.return = async () => {
                dispose();
                return { done: true, value: undefined };
            };
            return iterator;
        },
        async dispose() {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate() {
            if (connecting) {
                // only if there is a connection
                emitter.emit('closed', {
                    code: 4499,
                    reason: 'Terminated',
                    wasClean: false,
                });
            }
        },
    };
}
function isLikeCloseEvent(val) {
    return isObject(val) && 'code' in val && 'reason' in val;
}
function isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1013, // Bad Gateway
    ].includes(code))
        return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function isWebSocket(val) {
    return (typeof val === 'function' &&
        'constructor' in val &&
        'CLOSED' in val &&
        'CLOSING' in val &&
        'CONNECTING' in val &&
        'OPEN' in val);
}

;// ../../node_modules/.pnpm/isomorphic-ws@5.0.0_ws@8.18.2/node_modules/isomorphic-ws/browser.js
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js

var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof __webpack_require__.g !== 'undefined') {
  ws = __webpack_require__.g.WebSocket || __webpack_require__.g.MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
} else if (typeof self !== 'undefined') {
  ws = self.WebSocket || self.MozWebSocket
}

/* harmony default export */ const browser = (ws);

;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/GadgetTransaction.js

/** Represents the error thrown when a transaction is explicity rolled back, sometimes due to another inner error */
class TransactionRolledBack extends Error {
}
/** Represents an open transaction against the Gadget API */
class GadgetTransaction {
    constructor(client, subscriptionClient) {
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: client
        });
        Object.defineProperty(this, "subscriptionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subscriptionClient
        });
        Object.defineProperty(this, "open", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    /** Shut down this transaction by closing the connection to the backend. */
    close() {
        if (this.open) {
            void this.rollback().catch(() => null);
        }
        void this.subscriptionClient.dispose();
    }
    /** Explicitly roll back this transaction, preventing any of the changes made during it from being committed. */
    async rollback() {
        support_assertOperationSuccess(await this.client.mutation(`mutation RollbackTransaction { internal { rollbackTransaction }}`, {}).toPromise(), [
            "internal",
            "rollbackTransaction",
        ]);
        this.open = false;
        throw new TransactionRolledBack("Transaction rolled back.");
    }
    /**
     * @private
     */
    async start() {
        support_assertOperationSuccess(await this.client.mutation(`mutation StartTransaction { internal { startTransaction }}`, {}).toPromise(), [
            "internal",
            "startTransaction",
        ]);
        this.open = true;
    }
    /**
     * @private
     */
    async commit() {
        support_assertOperationSuccess(await this.client.mutation(`mutation CommitTransaction { internal { commitTransaction }}`, {}).toPromise(), [
            "internal",
            "commitTransaction",
        ]);
        this.open = false;
    }
}
//# sourceMappingURL=GadgetTransaction.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/InMemoryStorage.js
/**
 * Implements part of the `window.localStorage` api, but in memory such that the stored values are lost as soon as the JS VM's life ends
 **/
class InMemoryStorage {
    constructor() {
        Object.defineProperty(this, "values", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    getItem(key) {
        return this.values[key] || null;
    }
    setItem(key, value) {
        this.values[key] = value;
    }
}
//# sourceMappingURL=InMemoryStorage.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/exchanges/liveQueryExchange.js


/**
 * Exchange that prevents duplicate execution of live queries while allowing proper teardown and re-establishment.
 *
 * Live queries are long-running special subscriptions that receive real-time updates from the server. When mutations occur, urql's cache exchange tries to re-execute any mounted queries that could be affected and so re-executes live queries. Live queries automatically update their own data using their own persistent connection, so they shouldn't be re-executed if already mounted.
 */
const liveQueryExchange = ({ forward }) => {
    const executed = new Set();
    const getOperationId = (op) => {
        return op.key;
    };
    return (operations$) => {
        const notLive = wonka_pipe(operations$, wonka_filter((op) => !op.query.definitions.some(isLiveQueryOperationDefinitionNode)));
        const live = wonka_pipe(operations$, wonka_filter((op) => op.query.definitions.some(isLiveQueryOperationDefinitionNode)), wonka_filter((op) => {
            const opId = getOperationId(op);
            return !executed.has(opId) || op.kind !== "query";
        }), onPush((op) => {
            const opId = getOperationId(op);
            if (op.kind === "query") {
                executed.add(opId);
            }
            else if (op.kind === "teardown") {
                executed.delete(opId);
            }
        }));
        return forward(merge([live, notLive]));
    };
};
//# sourceMappingURL=liveQueryExchange.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/exchanges/operationNameExchange.js

const graphqlDocumentName = (doc) => {
    const lastDefinition = [...doc.definitions]
        .reverse()
        .find((definition) => definition.kind == "OperationDefinition");
    if (lastDefinition) {
        if (lastDefinition.name) {
            return lastDefinition.name.value;
        }
        const firstSelection = lastDefinition.selectionSet.selections.find((node) => node.kind == "Field");
        return firstSelection.name.value;
    }
};
const operationNameExchange = mapExchange({
    onOperation: (operation) => {
        var _a;
        var _b;
        (_a = (_b = operation.context).operationName) !== null && _a !== void 0 ? _a : (_b.operationName = graphqlDocumentName(operation.query) || "unknown");
    },
});
//# sourceMappingURL=operationNameExchange.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/exchanges/urlParamExchange.js

const addUrlParams = (url, paramsToAdd) => {
    const [start, params] = url.split("?");
    const paramsObj = new URLSearchParams(params);
    for (const [key, value] of Object.entries(paramsToAdd)) {
        paramsObj.set(key, value);
    }
    return `${start}?${paramsObj.toString()}`;
};
const urlParamExchange = mapExchange({
    onOperation: (operation) => {
        if (operation.context.url && operation.context.operationName) {
            try {
                operation.context.url = addUrlParams(operation.context.url, { operation: operation.context.operationName });
            }
            catch (error) {
                // not able to parse URL params, just don't add this optional param and let the rest of the system react to the invalid URL
            }
        }
    },
});
//# sourceMappingURL=urlParamExchange.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/GadgetConnection.js










var GadgetGraphQLCloseCode;
(function (GadgetGraphQLCloseCode) {
    GadgetGraphQLCloseCode[GadgetGraphQLCloseCode["TooManyRequests"] = 4294] = "TooManyRequests";
})(GadgetGraphQLCloseCode || (GadgetGraphQLCloseCode = {}));
const DEFAULT_CONN_ATTEMPTS = 2;
const DEFAULT_CONN_ACK_TIMEOUT = 4800;
const DEFAULT_CONN_GLOBAL_TIMEOUT = 10000;
const RETRYABLE_CLOSE_CODES = [CloseCode.ConnectionAcknowledgementTimeout, CloseCode.ConnectionInitialisationTimeout];
const $transaction = Symbol.for("gadget/transaction");
const $gadgetConnection = Symbol.for("gadget/connection");
const sessionStorageKey = "token";
const base64 = typeof btoa !== "undefined" ? btoa : (str) => Buffer.from(str).toString("base64");
/**
 * Represents the current strategy for authenticating with the Gadget platform.
 * For individual users in web browsers, we authenticate using a session token stored client side, like a cookie, but with cross domain support.
 * For server to server communication, or traceable access from the browser, we use pre shared secrets called API Keys
 * And when within the Gadget platform itself, we use a private secret token called an Internal Auth Token. Internal Auth Tokens are managed by Gadget and should never be used by external developers.
 **/
var AuthenticationMode;
(function (AuthenticationMode) {
    AuthenticationMode["BrowserSession"] = "browser-session";
    AuthenticationMode["APIKey"] = "api-key";
    AuthenticationMode["Internal"] = "internal";
    AuthenticationMode["InternalAuthToken"] = "internal-auth-token";
    AuthenticationMode["Anonymous"] = "anonymous";
    AuthenticationMode["Custom"] = "custom";
})(AuthenticationMode || (AuthenticationMode = {}));
const objectForGlobals = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : undefined;
/**
 * Root level database connection that Actions can use to mutate data in a Gadget database.
 * Manages transactions and the connection to a Gadget API
 */
class GadgetConnection {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        // Options used when generating new GraphQL clients for the base connection and for for transactions
        Object.defineProperty(this, "endpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subscriptionClientOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "websocketsEndpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "websocketImplementation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fetchImplementation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exchanges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // the base client using HTTP requests that non-transactional operations will use
        Object.defineProperty(this, "baseClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** @private (but accessible for testing purposes) */
        Object.defineProperty(this, "baseSubscriptionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // the transactional websocket client that will be used inside a transaction block
        Object.defineProperty(this, "currentTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        // How this client will authenticate (if at all) against the Gadget backed
        Object.defineProperty(this, "authenticationMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: AuthenticationMode.Anonymous
        });
        Object.defineProperty(this, "sessionTokenStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requestPolicy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createSubscriptionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (optionsOrRun, maybeRun) => {
                let run;
                let options;
                if (maybeRun) {
                    run = maybeRun;
                    options = optionsOrRun;
                }
                else {
                    run = optionsOrRun;
                    options = {};
                }
                if (this.currentTransaction) {
                    return await run(this.currentTransaction);
                }
                let subscriptionClient = null;
                let transaction;
                try {
                    // The server will error if it receives any operations before the auth dance has been completed, so we block on that happening before sending our first operation. It's important that this happens synchronously after instantiating the client so we don't miss any messages
                    subscriptionClient = await this.waitForOpenedConnection({
                        isFatalConnectionProblem(errorOrCloseEvent) {
                            // any interruption of the transaction is fatal to the transaction
                            console.warn("Transport error encountered during transaction processing", errorOrCloseEvent);
                            return true;
                        },
                        connectionAckWaitTimeout: DEFAULT_CONN_ACK_TIMEOUT,
                        ...options,
                        lazy: false,
                        // super ultra critical option that ensures graphql-ws doesn't automatically close the websocket connection when there are no outstanding operations. this is key so we can start a transaction then make mutations within it
                        lazyCloseTimeout: 100000,
                        retryAttempts: 0,
                    });
                    const client = new C({
                        url: "/-", // not used because there's no fetch exchange, set for clarity
                        requestPolicy: "network-only", // skip any cached data during transactions
                        exchanges: [
                            ...this.exchanges.beforeAll,
                            operationNameExchange,
                            ...this.exchanges.beforeAsync,
                            subscriptionExchange({
                                forwardSubscription(request) {
                                    const input = { ...request, query: request.query || "" };
                                    return {
                                        subscribe: (sink) => {
                                            const dispose = subscriptionClient.subscribe(input, sink);
                                            return {
                                                unsubscribe: dispose,
                                            };
                                        },
                                    };
                                },
                                enableAllOperations: true,
                            }),
                            ...this.exchanges.afterAll,
                        ],
                    });
                    client[$gadgetConnection] = this;
                    transaction = new GadgetTransaction(client, subscriptionClient);
                    this.currentTransaction = transaction;
                    await transaction.start();
                    const result = await run(transaction);
                    await transaction.commit();
                    return result;
                }
                catch (error) {
                    try {
                        if (transaction === null || transaction === void 0 ? void 0 : transaction.open)
                            await transaction.rollback();
                    }
                    catch (rollbackError) {
                        if (!(rollbackError instanceof TransactionRolledBack)) {
                            console.warn("Encountered another error while rolling back a Gadget transaction that errored. The other error:", rollbackError);
                        }
                    }
                    if (isCloseEvent(error)) {
                        throw new GadgetUnexpectedCloseError(error);
                    }
                    else {
                        throw error;
                    }
                }
                finally {
                    await (subscriptionClient === null || subscriptionClient === void 0 ? void 0 : subscriptionClient.dispose());
                    this.currentTransaction = null;
                }
            }
        });
        /**
         * `fetch` function that works the same as the built-in `fetch` function, but automatically passes authentication information for this API client.
         *
         * @example
         * await api.connection.fetch("https://myapp--development.gadget.app/foo/bar");
         *
         * @example
         * // fetch a relative URL from the endpoint this API client is configured to fetch from
         * await api.connection.fetch("/foo/bar");
         **/
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (input, init = {}) => {
                var _a;
                input = processMaybeRelativeInput(input, (_a = this.options.baseRouteURL) !== null && _a !== void 0 ? _a : this.options.endpoint);
                if (this.isGadgetRequest(input)) {
                    const requestHeaders = await this.requestHeaders();
                    init.headers = { ...requestHeaders, ...init.headers };
                    if (this.authenticationMode == AuthenticationMode.Custom) {
                        await this.options.authenticationMode.custom.processFetch(input, init);
                    }
                }
                const response = await this._fetchImplementation(input, init);
                if (this.authenticationMode == AuthenticationMode.BrowserSession) {
                    const headerValue = response.headers.get("x-set-authorization");
                    const sessionToken = (headerValue === null || headerValue === void 0 ? void 0 : headerValue.startsWith("Session ")) ? headerValue.replace("Session ", "") : null;
                    if (sessionToken) {
                        this.sessionTokenStore.setItem(this.sessionStorageKey, sessionToken);
                    }
                }
                return response;
            }
        });
        if (!options.endpoint)
            throw new Error("Must provide an `endpoint` option for a GadgetConnection to connect to");
        this.endpoint = options.endpoint;
        if (options.fetchImplementation) {
            this._fetchImplementation = options.fetchImplementation;
        }
        else if (typeof objectForGlobals != "undefined" && objectForGlobals.fetch) {
            this._fetchImplementation = objectForGlobals.fetch.bind(objectForGlobals);
        }
        else {
            this._fetchImplementation = async (...args) => {
                // lazily import cross-fetch to avoid bundling it in the client
                let fetch = (await __webpack_require__.e(/* import() */ 459).then(__webpack_require__.t.bind(__webpack_require__, 459, 19)));
                // when compiled to CJS, the dynamic import above returns the default export right away. in ESM though, we need to access it ourselves
                if (fetch.default) {
                    fetch = fetch.default;
                }
                return await fetch(...args);
            };
        }
        this.websocketImplementation = (_b = (_a = options.websocketImplementation) !== null && _a !== void 0 ? _a : globalThis === null || globalThis === void 0 ? void 0 : globalThis.WebSocket) !== null && _b !== void 0 ? _b : browser;
        this.websocketsEndpoint = (_c = options.websocketsEndpoint) !== null && _c !== void 0 ? _c : options.endpoint + "/batch";
        this.websocketsEndpoint = this.websocketsEndpoint.replace(/^http/, "ws");
        this.environment = (_d = options.environment) !== null && _d !== void 0 ? _d : "Development";
        this.requestPolicy = (_e = options.requestPolicy) !== null && _e !== void 0 ? _e : "cache-and-network";
        this.exchanges = {
            beforeAll: [],
            beforeAsync: [],
            afterAll: [],
            ...options.exchanges,
        };
        this.createSubscriptionClient = (_f = options.createSubscriptionClient) !== null && _f !== void 0 ? _f : createClient;
        this.setAuthenticationMode(options.authenticationMode);
        this.baseClient = this.newBaseClient();
    }
    get sessionStorageKey() {
        return `${sessionStorageKey}-${this.endpoint}`;
    }
    get currentClient() {
        var _a;
        return ((_a = this.currentTransaction) === null || _a === void 0 ? void 0 : _a.client) || this.baseClient;
    }
    set fetchImplementation(implementation) {
        this._fetchImplementation = implementation;
        this.resetClients();
    }
    /**
     * Change the authentication mode settings for this connection imperatively.
     * @private This function is generally not required for use by external developers, but is useful for those building integrations against the Gadget API to configure passed in `api` objects.
     */
    setAuthenticationMode(options) {
        var _a;
        if (options) {
            if (options.browserSession) {
                this.enableSessionMode(options.browserSession);
            }
            else if (options.internal) {
                this.authenticationMode = AuthenticationMode.Internal;
            }
            else if (options.internalAuthToken) {
                this.authenticationMode = AuthenticationMode.InternalAuthToken;
            }
            else if (options.apiKey) {
                this.authenticationMode = AuthenticationMode.APIKey;
            }
            else if (options.custom) {
                this.authenticationMode = AuthenticationMode.Custom;
            }
            this.options.authenticationMode = options;
        }
        (_a = this.authenticationMode) !== null && _a !== void 0 ? _a : (this.authenticationMode = AuthenticationMode.Anonymous);
    }
    enableSessionMode(options) {
        this.authenticationMode = AuthenticationMode.BrowserSession;
        const desiredMode = !options || typeof options == "boolean" ? BrowserSessionStorageType.Durable : options.storageType;
        let sessionTokenStore;
        if (desiredMode == BrowserSessionStorageType.Durable && storageAvailable("localStorage")) {
            sessionTokenStore = window.localStorage;
        }
        else if (desiredMode == BrowserSessionStorageType.Session && storageAvailable("sessionStorage")) {
            sessionTokenStore = window.sessionStorage;
        }
        else {
            sessionTokenStore = new InMemoryStorage();
        }
        if (options !== null && typeof options === "object" && "initialToken" in options && options.initialToken) {
            sessionTokenStore.setItem(this.sessionStorageKey, options.initialToken);
        }
        this.sessionTokenStore = sessionTokenStore;
        this.resetClients();
    }
    close() {
        if (this.baseSubscriptionClient)
            this.disposeClient(this.baseSubscriptionClient);
        if (this.currentTransaction) {
            this.currentTransaction.close();
        }
    }
    isGadgetRequest(input) {
        let requestUrl;
        if (typeof input === "string") {
            requestUrl = input;
        }
        else if (typeof input === "object" && "url" in input) {
            requestUrl = input.url;
        }
        else {
            requestUrl = String(input);
        }
        if (isRelativeUrl(this.options.endpoint)) {
            if (isRelativeUrl(requestUrl)) {
                return true;
            }
            else {
                return false;
            }
        }
        const host = new URL(this.options.endpoint).host;
        return requestUrl.includes(host);
    }
    resetClients() {
        if (this.currentTransaction) {
            throw new Error("Can't reset clients while a transaction is open");
        }
        if (this.baseSubscriptionClient)
            this.disposeClient(this.baseSubscriptionClient);
        if (this.baseClient)
            this.baseClient = this.newBaseClient();
    }
    newBaseClient() {
        const exchanges = [...this.exchanges.beforeAll, operationNameExchange, urlParamExchange];
        // apply urql's default caching behaviour when client side (but skip it server side)
        if (typeof window != "undefined") {
            exchanges.push(cacheExchange);
            exchanges.push(liveQueryExchange);
        }
        exchanges.push(...this.exchanges.beforeAsync, 
        // standard subscriptions for normal GraphQL subscriptions
        subscriptionExchange({
            forwardSubscription: (request) => {
                return {
                    subscribe: (sink) => {
                        const input = { ...request, query: request.query || "" };
                        const dispose = this.getBaseSubscriptionClient().subscribe(input, sink);
                        return {
                            unsubscribe: dispose,
                        };
                    },
                };
            },
        }), 
        // another subscription exchange for live queries
        // live queries pass through the same WS client, but use jsondiffs for patching in results
        subscriptionExchange({
            isSubscriptionOperation: (request) => {
                return request.query.definitions.some((definition) => isLiveQueryOperationDefinitionNode(definition));
            },
            forwardSubscription: (request) => {
                return {
                    subscribe: (sink) => {
                        let unsubscribe = undefined;
                        // dynamic import on first subscription the live utils to keep the base bundle size small
                        const loadAndSubscribe = __webpack_require__.e(/* import() */ 549).then(__webpack_require__.bind(__webpack_require__, 549))
                            .then(({ applyAsyncIterableIteratorToSink, applyLiveQueryJSONDiffPatch, makeAsyncIterableIteratorFromSink }) => {
                            const input = { ...request, query: request.query || "" };
                            unsubscribe = applyAsyncIterableIteratorToSink(applyLiveQueryJSONDiffPatch(makeAsyncIterableIteratorFromSink((sink) => this.getBaseSubscriptionClient().subscribe(input, sink))), sink);
                            return unsubscribe;
                        })
                            .catch((error) => sink.error(error));
                        return {
                            unsubscribe: () => {
                                if (unsubscribe) {
                                    unsubscribe();
                                }
                                else {
                                    void loadAndSubscribe.then((unsubscribe) => {
                                        if (unsubscribe) {
                                            unsubscribe();
                                        }
                                    });
                                }
                            },
                        };
                    },
                };
            },
        }), fetchExchange, ...this.exchanges.afterAll);
        const client = new C({
            url: this.endpoint,
            fetch: this.fetch,
            exchanges,
            requestPolicy: this.requestPolicy,
        });
        client[$gadgetConnection] = this;
        return client;
    }
    newSubscriptionClient(overrides) {
        if (!this.websocketImplementation) {
            throw new Error("Can't use this GadgetClient for this subscription-based operation as there's no global WebSocket implementation available. Please pass one as the `websocketImplementation` option to the GadgetClient constructor.");
        }
        let url = this.websocketsEndpoint;
        if (overrides === null || overrides === void 0 ? void 0 : overrides.urlParams) {
            url = addUrlParams(url, overrides.urlParams);
        }
        let activeSocket;
        let timedOut;
        return this.createSubscriptionClient({
            url,
            webSocketImpl: this.websocketImplementation,
            keepAlive: 7000,
            connectionParams: async () => {
                var _a, _b, _c, _d;
                // In the browser, we can't set arbitrary headers on the websocket request, so we don't use the same auth mechanism that we use for normal HTTP requests. Instead we use graphql-ws' connectionParams to send the auth information in the connection setup message to the server.
                const connectionParams = { environment: this.environment, auth: { type: this.authenticationMode } };
                if (this.authenticationMode == AuthenticationMode.APIKey) {
                    connectionParams.auth.key = this.options.authenticationMode.apiKey;
                }
                else if (this.authenticationMode == AuthenticationMode.Internal ||
                    this.authenticationMode == AuthenticationMode.InternalAuthToken) {
                    const authToken = this.authenticationMode == AuthenticationMode.Internal
                        ? this.options.authenticationMode.internal.authToken
                        : this.options.authenticationMode.internalAuthToken;
                    connectionParams.auth.token = authToken;
                    if (this.authenticationMode == AuthenticationMode.Internal && this.options.authenticationMode.internal.actAsSession) {
                        connectionParams.auth.actAsInternalSession = true;
                        connectionParams.auth.internalSessionId = await ((_b = (_a = this.options.authenticationMode.internal).getSessionId) === null || _b === void 0 ? void 0 : _b.call(_a));
                    }
                }
                else if (this.authenticationMode == AuthenticationMode.BrowserSession) {
                    connectionParams.auth.sessionToken = this.sessionTokenStore.getItem(this.sessionStorageKey);
                }
                else if (this.authenticationMode == AuthenticationMode.Custom) {
                    await ((_d = (_c = this.options.authenticationMode) === null || _c === void 0 ? void 0 : _c.custom) === null || _d === void 0 ? void 0 : _d.processTransactionConnectionParams(connectionParams));
                }
                return connectionParams;
            },
            onNonLazyError: () => {
                // we catch this outside in the runner function
            },
            on: {
                connected: (socket, payload) => {
                    var _a, _b, _c, _d, _e, _f;
                    // If we're using session token authorization, we don't use request headers to exchange the session token, we use graphql-ws' ConnectionAck payload to persist the token. When the subscription client first starts, the server will send us session token identifying this client, and we persist it to the session token store
                    if (this.authenticationMode == AuthenticationMode.BrowserSession && (payload === null || payload === void 0 ? void 0 : payload.sessionToken)) {
                        const browserSession = (_a = this.options.authenticationMode) === null || _a === void 0 ? void 0 : _a.browserSession;
                        const initialToken = browserSession !== null && typeof browserSession === "object" ? browserSession.initialToken : null;
                        if (!initialToken) {
                            this.sessionTokenStore.setItem(this.sessionStorageKey, payload.sessionToken);
                        }
                    }
                    (_d = (_c = (_b = this.subscriptionClientOptions) === null || _b === void 0 ? void 0 : _b.on) === null || _c === void 0 ? void 0 : _c.connected) === null || _d === void 0 ? void 0 : _d.call(_c, socket, payload);
                    (_f = (_e = overrides === null || overrides === void 0 ? void 0 : overrides.on) === null || _e === void 0 ? void 0 : _e.connected) === null || _f === void 0 ? void 0 : _f.call(_e, socket, payload);
                    activeSocket = socket;
                },
                ping: (received) => {
                    if (!received) {
                        timedOut = setTimeout(() => {
                            if (activeSocket.readyState === browser.OPEN) {
                                activeSocket.close(4408, "Request Timeout");
                            }
                        }, 3000);
                    }
                },
                pong: (received) => {
                    if (received)
                        clearTimeout(timedOut);
                },
            },
            ...this.subscriptionClientOptions,
            ...overrides,
        });
    }
    async requestHeaders() {
        var _a, _b, _c;
        const headers = {};
        if (this.authenticationMode == AuthenticationMode.Internal || this.authenticationMode == AuthenticationMode.InternalAuthToken) {
            const authToken = this.authenticationMode == AuthenticationMode.Internal
                ? this.options.authenticationMode.internal.authToken
                : this.options.authenticationMode.internalAuthToken;
            headers.authorization = "Basic " + base64("gadget-internal" + ":" + authToken);
            if (this.authenticationMode == AuthenticationMode.Internal && this.options.authenticationMode.internal.actAsSession) {
                headers["x-gadget-act-as-internal-session"] = "true";
                const sessionId = await ((_b = (_a = this.options.authenticationMode.internal).getSessionId) === null || _b === void 0 ? void 0 : _b.call(_a));
                if (sessionId) {
                    headers["x-gadget-internal-session-id"] = sessionId;
                }
            }
        }
        else if (this.authenticationMode == AuthenticationMode.APIKey) {
            headers.authorization = `Bearer ${(_c = this.options.authenticationMode) === null || _c === void 0 ? void 0 : _c.apiKey}`;
        }
        else if (this.authenticationMode == AuthenticationMode.BrowserSession) {
            const val = this.sessionTokenStore.getItem(this.sessionStorageKey);
            if (val) {
                headers.authorization = `Session ${val}`;
            }
        }
        headers["x-gadget-environment"] = this.environment;
        return headers;
    }
    async waitForOpenedConnection(options) {
        let subscriptionClient = this.newSubscriptionClient(options);
        let unsubscribes = []; // eslint-disable-line @typescript-eslint/ban-types
        let attempts = options.connectionAttempts || DEFAULT_CONN_ATTEMPTS;
        const globalTimeout = options.connectionGlobalTimeoutMs || DEFAULT_CONN_GLOBAL_TIMEOUT;
        const clearListeners = () => {
            unsubscribes.forEach((fn) => fn());
            unsubscribes = [];
        };
        return await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                this.disposeClient(subscriptionClient);
                wrappedReject(new GadgetWebsocketConnectionTimeoutError("Timeout opening websocket connection to Gadget API"));
            }, globalTimeout);
            const retryOnClose = (event) => {
                if (isCloseEvent(event)) {
                    if (event.code == GadgetGraphQLCloseCode.TooManyRequests) {
                        clearListeners();
                        return wrappedReject(new GadgetTooManyRequestsError(event.reason));
                    }
                    if (RETRYABLE_CLOSE_CODES.includes(event.code) && attempts > 0) {
                        attempts -= 1;
                        this.disposeClient(subscriptionClient);
                        subscriptionClient = this.newSubscriptionClient(options);
                        resetListeners();
                        return;
                    }
                }
                clearTimeout(timeout);
                reject(new GadgetUnexpectedCloseError(event));
            };
            const wrappedReject = (err) => {
                clearTimeout(timeout);
                reject(err);
            };
            const wrappedResolve = () => {
                clearTimeout(timeout);
                resolve(subscriptionClient);
            };
            const resetListeners = () => {
                clearListeners();
                unsubscribes.push(subscriptionClient.on("connected", wrappedResolve));
                unsubscribes.push(subscriptionClient.on("closed", retryOnClose));
                unsubscribes.push(subscriptionClient.on("error", wrappedReject));
            };
            resetListeners();
        }).finally(clearListeners);
    }
    disposeClient(client) {
        const maybePromise = client.dispose();
        if (maybePromise) {
            maybePromise.catch((err) => console.error(`Error closing SubscriptionClient: ${err.message}`));
        }
    }
    getBaseSubscriptionClient() {
        if (!this.baseSubscriptionClient) {
            this.baseSubscriptionClient = this.newSubscriptionClient({ lazy: true });
        }
        return this.baseSubscriptionClient;
    }
}
Object.defineProperty(GadgetConnection, "version", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "0.15.44"
});
function processMaybeRelativeInput(input, endpoint) {
    if (typeof input != "string")
        return input;
    if (isRelativeUrl(input)) {
        try {
            return String(new URL(input, endpoint));
        }
        catch (err) {
            return input;
        }
    }
    return input;
}
function isRelativeUrl(url) {
    return url.startsWith("/") && !url.startsWith("//");
}
const getLiveDirectiveNode = (input) => {
    var _a;
    if (input.kind !== "OperationDefinition" || input.operation !== "query") {
        return null;
    }
    return (_a = input.directives) === null || _a === void 0 ? void 0 : _a.find((d) => d.name.value === "live");
};
const isLiveQueryOperationDefinitionNode = (input) => {
    return !!getLiveDirectiveNode(input);
};
//# sourceMappingURL=GadgetConnection.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/InternalModelManager.js



const internalFindOneQuery = (apiIdentifier, id, namespace, select) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    return compileWithVariableValues({
        type: "query",
        name: `InternalFind${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [apiIdentifier]: Call({
                    id: Var({ value: id, type: "GadgetID!" }),
                    select: Var({ value: formatInternalSelectVariable(select), type: `[String!]` }),
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalFindListVariables = (apiIdentifier, namespace, options) => {
    return {
        search: (options === null || options === void 0 ? void 0 : options.search) ? Var({ value: options === null || options === void 0 ? void 0 : options.search, type: "String" }) : undefined,
        sort: (options === null || options === void 0 ? void 0 : options.sort) ? Var({ value: options === null || options === void 0 ? void 0 : options.sort, type: `[${sortTypeName(apiIdentifier, namespace)}!]` }) : undefined,
        filter: (options === null || options === void 0 ? void 0 : options.filter) ? Var({ value: options === null || options === void 0 ? void 0 : options.filter, type: `[${filterTypeName(apiIdentifier, namespace)}!]` }) : undefined,
        select: (options === null || options === void 0 ? void 0 : options.select) ? Var({ value: formatInternalSelectVariable(options === null || options === void 0 ? void 0 : options.select), type: `[String!]` }) : undefined,
    };
};
const internalFindFirstQuery = (apiIdentifier, namespace, options) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    const defaultVariables = internalFindListVariables(capitalizedApiIdentifier, namespace, options);
    return compileWithVariableValues({
        type: "query",
        name: `InternalFindFirst${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`list${capitalizedApiIdentifier}`]: Call({
                    ...defaultVariables,
                    first: Var({ value: 1, type: "Int" }),
                }, {
                    edges: {
                        node: true,
                    },
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalFindManyQuery = (apiIdentifier, namespace, options) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    const defaultVariables = internalFindListVariables(capitalizedApiIdentifier, namespace, options);
    return compileWithVariableValues({
        type: "query",
        name: `InternalFindMany${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`list${capitalizedApiIdentifier}`]: Call({
                    ...defaultVariables,
                    after: (options === null || options === void 0 ? void 0 : options.after) ? Var({ value: options.after, type: "String" }) : undefined,
                    before: (options === null || options === void 0 ? void 0 : options.before) ? Var({ value: options === null || options === void 0 ? void 0 : options.before, type: "String" }) : undefined,
                    first: (options === null || options === void 0 ? void 0 : options.first) ? Var({ value: options === null || options === void 0 ? void 0 : options.first, type: "Int" }) : undefined,
                    last: (options === null || options === void 0 ? void 0 : options.last) ? Var({ value: options === null || options === void 0 ? void 0 : options.last, type: "Int" }) : undefined,
                }, {
                    pageInfo: { hasNextPage: true, hasPreviousPage: true, startCursor: true, endCursor: true },
                    edges: { cursor: true, node: true },
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalInputTypeName = (apiIdentifier, namespace) => `Internal${namespacedGraphQLTypeName(apiIdentifier, namespace)}Input`;
const internalCreateMutation = (apiIdentifier, namespace, record) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    return compileWithVariableValues({
        type: "mutation",
        name: `InternalCreate${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`create${capitalizedApiIdentifier}`]: Call({
                    [apiIdentifier]: Var({ value: record, type: internalInputTypeName(apiIdentifier, namespace) }),
                }, {
                    success: true,
                    ...ErrorsSelection,
                    [apiIdentifier]: true,
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalBulkCreateMutation = (apiIdentifier, pluralApiIdentifier, namespace, records) => {
    const capitalizedPluralApiIdentifier = capitalizeIdentifier(pluralApiIdentifier);
    return compileWithVariableValues({
        type: "mutation",
        name: `InternalBulkCreate${capitalizedPluralApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`bulkCreate${capitalizedPluralApiIdentifier}`]: Call({
                    [pluralApiIdentifier]: Var({ value: records, type: `[${internalInputTypeName(apiIdentifier, namespace)}]!` }),
                }, {
                    success: true,
                    ...ErrorsSelection,
                    [pluralApiIdentifier]: true,
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalUpdateMutation = (apiIdentifier, namespace, id, record) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    return compileWithVariableValues({
        type: "mutation",
        name: `InternalUpdate${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`update${capitalizedApiIdentifier}`]: Call({
                    id: Var({ value: id, type: "GadgetID!" }),
                    [apiIdentifier]: Var({ value: record, type: internalInputTypeName(apiIdentifier, namespace) }),
                }, {
                    success: true,
                    ...ErrorsSelection,
                    [apiIdentifier]: true,
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalUpsertMutation = (apiIdentifier, namespace, on, record) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    return compileWithVariableValues({
        type: "mutation",
        name: `InternalUpsert${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`upsert${capitalizedApiIdentifier}`]: Call({
                    on: Var({ value: on, type: "[String!]" }),
                    [apiIdentifier]: Var({ value: record, type: internalInputTypeName(apiIdentifier, namespace) }),
                }, {
                    success: true,
                    ...ErrorsSelection,
                    [apiIdentifier]: true,
                }),
            }),
            ...hydrationSelection(apiIdentifier, namespace),
        },
    });
};
const internalDeleteMutation = (apiIdentifier, namespace, id) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    return compileWithVariableValues({
        type: "mutation",
        name: `InternalDelete${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`delete${capitalizedApiIdentifier}`]: Call({
                    id: Var({ value: id, type: "GadgetID!" }),
                }, {
                    success: true,
                    ...ErrorsSelection,
                }),
            }),
        },
    });
};
const internalDeleteManyMutation = (apiIdentifier, namespace, options) => {
    const capitalizedApiIdentifier = capitalizeIdentifier(apiIdentifier);
    return compileWithVariableValues({
        type: "mutation",
        name: `InternalDeleteMany${capitalizedApiIdentifier}`,
        fields: {
            internal: namespacify(namespace, {
                [`deleteMany${capitalizedApiIdentifier}`]: Call({
                    search: (options === null || options === void 0 ? void 0 : options.search) ? Var({ value: options === null || options === void 0 ? void 0 : options.search, type: "String" }) : undefined,
                    filter: (options === null || options === void 0 ? void 0 : options.filter) ? Var({ value: options === null || options === void 0 ? void 0 : options.filter, type: `[${filterTypeName(apiIdentifier, namespace)}!]` }) : undefined,
                }, {
                    success: true,
                    ...ErrorsSelection,
                }),
            }),
        },
    });
};
/**
 * Model specific manager for a given model's internal representation. Used to access the inner, raw data in the Gadget database. Use with caution -- it's easy to break stuff, and the Public API should be used when possible!
 */
class InternalModelManager {
    constructor(apiIdentifier, connection, options) {
        Object.defineProperty(this, "apiIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: apiIdentifier
        });
        Object.defineProperty(this, "connection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: connection
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(this, "capitalizedApiIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.capitalizedApiIdentifier = camelize(apiIdentifier);
        this.namespace = (options === null || options === void 0 ? void 0 : options.namespace) || [];
    }
    validateRecord(record) {
        if (!this.options || !this.options.hasAmbiguousIdentifiers) {
            return true;
        }
        const keys = Object.keys(record);
        // any keys that aren't the apiIdentifier are invalid
        return keys.every((key) => key === this.apiIdentifier);
    }
    getRecordFromData(record, functionName) {
        let recordData = record;
        if (!this.validateRecord(record)) {
            throw new GadgetOperationError(`Invalid arguments found in variables. Did you mean to use ${functionName}({ ${this.apiIdentifier}: { ... } })?`, "GGT_INVALID_RECORD_DATA");
        }
        if (this.apiIdentifier in record) {
            recordData = recordData[this.apiIdentifier];
        }
        return recordData;
    }
    /**
     * Find a single record by ID. Throws an error by default if the record with the given ID is not found.
     *
     * @example
     * // returns post with id 10
     * const post = await api.internal.post.findOne(10);
     *
     * @param id The ID of the record to find
     * @param options Options for the find operation
     * @param throwOnEmptyData Whether or not to throw an error if the record is not found
     * @returns The record, if found
     */
    async findOne(id, options, throwOnEmptyData = true) {
        const plan = internalFindOneQuery(this.apiIdentifier, id, this.namespace, formatInternalSelectVariable(options === null || options === void 0 ? void 0 : options.select));
        const response = await this.connection.currentClient.query(plan.query, plan.variables).toPromise();
        const assertSuccess = throwOnEmptyData ? assertOperationSuccess : assertNullableOperationSuccess;
        const result = assertSuccess(response, this.dataPath(this.apiIdentifier));
        return hydrateRecord(response, result);
    }
    /**
     * Find a single record by ID. Returns null if the record doesn't exist.
     *
     * @example
     * // returns post with id 10 if it exists, null otherwise
     * const post = await api.internal.post.maybeFindOne(10);
     *
     * @param id The ID of the record to find
     * @param options Options for the find operation
     * @returns The record, if found, null otherwise
     */
    async maybeFindOne(id, options) {
        const record = await this.findOne(id, options, false);
        return record.isEmpty() ? null : record;
    }
    /**
     * Find a list of records matching the given options
     *
     * @example
     * // returns the first page of published posts
     * const posts = await api.internal.post.findMany({ filter: { published: { equals: true }}});
     *
     * @param options Options for the find operation, like sorts, filters, and pagination
     * @returns The record, if found, null otherwise
     */
    async findMany(options) {
        const plan = internalFindManyQuery(this.apiIdentifier, this.namespace, options);
        const response = await this.connection.currentClient.query(plan.query, plan.variables).toPromise();
        const connection = assertNullableOperationSuccess(response, this.dataPath(`list${this.capitalizedApiIdentifier}`));
        const records = hydrateConnection(response, connection);
        return GadgetRecordList.boot(this, records, { options, pageInfo: connection.pageInfo });
    }
    /**
     * Find the first record matching the given options. Throws an error by default if no records matching the options are found.
     *
     * @example
     * // returns the first published post or throws if none found
     * const post = await api.internal.post.findFirst({ filter: { published: { equals: true }}});
     *
     * @param options Options for the find operation, like sorts, filters, and pagination
     * @returns The first record matching the options
     */
    async findFirst(options, throwOnEmptyData = true) {
        const plan = internalFindFirstQuery(this.apiIdentifier, this.namespace, options);
        const response = await this.connection.currentClient.query(plan.query, plan.variables).toPromise();
        const dataPath = this.dataPath(`list${this.capitalizedApiIdentifier}`);
        let connection;
        if (throwOnEmptyData === false) {
            // If this is a nullable operation, don't throw errors on empty
            connection = assertNullableOperationSuccess(response, dataPath);
        }
        else {
            // Otherwise, passthrough the `throwOnEmptyData` flag, to account for
            // `findMany` (allows empty arrays) vs `findFirst` (no empty result) usage.
            connection = assertOperationSuccess(response, dataPath, throwOnEmptyData);
        }
        const records = hydrateConnection(response, connection);
        const recordList = GadgetRecordList.boot(this, records, { options, pageInfo: connection.pageInfo });
        return recordList[0];
    }
    /**
     * Find the first record matching the given options. Returns null if no records matching the options are found.
     *
     * @example
     * // returns the first published post or null if none are published
     * const post = await api.internal.post.maybeFindFirst({ filter: { published: { equals: true }}});
     *
     * @param options Options for the find operation, like sorts, filters, and pagination
     * @returns The first record matching the options, null otherwise
     */
    async maybeFindFirst(options) {
        return await this.findFirst(options, false);
    }
    /**
     * Creates a new record in the backend datastore for this model using the Internal API
     *
     * Does *not* run actions -- use the Public API for that.
     *
     * @example
     * // creates a new post record in the database
     * const post = await api.internal.post.create({ title: "A new post" });
     *
     * @param record The data for the record to create
     * @returns The created record
     */
    async create(record) {
        const plan = internalCreateMutation(this.apiIdentifier, this.namespace, this.getRecordFromData(record, "create"));
        const response = await this.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
        const result = assertMutationSuccess(response, this.dataPath(`create${this.capitalizedApiIdentifier}`));
        return hydrateRecord(response, result[this.apiIdentifier]);
    }
    /**
     * Creates a set of new records in the backend datastore for this model using the Internal API. Creates in bulk within the same database transaction for performance.
     *
     * Does *not* run actions -- use the Public API for that.
     *
     * @example
     * // creates 2 new post records in the database
     * const posts = await api.internal.post.bulkCreate([
     *   { title: "A new post" },
     *   { title: "Another new post" }
     * ]);
     *
     * @param record An array of data for the records to create
     * @returns The created records
     */
    async bulkCreate(records) {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.pluralApiIdentifier)) {
            throw new GadgetClientError("Cannot perform bulkCreate without a pluralApiIdentifier");
        }
        const capitalizedPluralApiIdentifier = capitalizeIdentifier(this.options.pluralApiIdentifier);
        const plan = internalBulkCreateMutation(this.apiIdentifier, this.options.pluralApiIdentifier, this.namespace, records);
        const response = await this.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
        const result = assertMutationSuccess(response, this.dataPath(`bulkCreate${capitalizedPluralApiIdentifier}`));
        return hydrateRecordArray(response, result[this.options.pluralApiIdentifier]);
    }
    /**
     * Updates an existing record in the backend datastore for this model using the Internal API
     *
     * Does *not* run actions -- use the Public API for that.
     *
     * @example
     * // updates post with id 10 in the database
     * const post = await api.internal.post.update(10, { title: "A new post title" });
     *
     * @param record The data for the record to update
     * @returns The updated record
     */
    async update(id, record) {
        assert(id, `Can't update a record without an ID passed`);
        const plan = internalUpdateMutation(this.apiIdentifier, this.namespace, id, this.getRecordFromData(record, "update"));
        const response = await this.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
        const result = assertMutationSuccess(response, this.dataPath(`update${this.capitalizedApiIdentifier}`));
        return hydrateRecord(response, result[this.apiIdentifier]);
    }
    /**
     * Upserts a record in the backend datastore for this model using the Internal API.
     * If a matching record exists, it will be updated. If it doesn't exist, it will be created.
     * By default records will be matched by the `id` field, but you can specify a different field to match on.
     *
     * Does *not* run actions -- use the Public API for that.
     *
     * @example
     * // upserts post with id 10 in the database
     * // if a post with id 10 exists, it will be updated
     * // if a post with id 10 does not exist, it will be created
     * const post = await api.internal.post.upsert({ id: "10", title: "A new post title" });
     *
     * @example
     * // upserts post with slug "new-post" in the database
     * // if a post with slug "new-post" exists, it will be updated
     * // if a post with slug "new-post" does not exist, it will be created
     * const post = await api.internal.post.upsert({ post: {slug: "new-post", title: "A new post title" }, on: ["slug"] });
     *
     * @param record The data for the record to update
     * @returns The upserted record
     */
    async upsert(record) {
        const { on, ...recordData } = record;
        on && assert(on.length > 0, `Must specify at least one field to upsert on`);
        const plan = internalUpsertMutation(this.apiIdentifier, this.namespace, on, this.getRecordFromData(recordData, "upsert"));
        const response = await this.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
        const result = assertMutationSuccess(response, this.dataPath(`upsert${this.capitalizedApiIdentifier}`));
        return hydrateRecord(response, result[this.apiIdentifier]);
    }
    /**
     * Deletes an existing record in the backend datastore for this model using the Internal API
     *
     * Does *not* run actions -- use the Public API for that.
     *
     * @example
     * // removes the post with id 10 in the database
     * await api.internal.post.delete(10);
     *
     * @param id The id of the record to delete
     */
    async delete(id) {
        assert(id, `Can't delete a record without an ID`);
        const plan = internalDeleteMutation(this.apiIdentifier, this.namespace, id);
        const response = await this.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
        assertMutationSuccess(response, this.dataPath(`delete${this.capitalizedApiIdentifier}`));
    }
    /**
     * Deletes the records in the backend datastore that match the given filter criteria. Uses the Internal API.
     *
     * Does *not* run actions -- use the Public API for that.
     *
     * @example
     * // removes all unpublished posts from the database
     * await api.internal.post.deleteMany({filter: { published: { equals: false } } });
     *
     * @param options Search and filter options for the records to delete
     */
    async deleteMany(options) {
        const plan = internalDeleteManyMutation(this.apiIdentifier, this.namespace, options);
        const response = await this.connection.currentClient.mutation(plan.query, plan.variables).toPromise();
        assertMutationSuccess(response, this.dataPath(`deleteMany${this.capitalizedApiIdentifier}`));
    }
    dataPath(dataPath) {
        return ["internal", ...namespaceDataPath([dataPath], this.namespace)];
    }
}
function formatInternalSelectVariable(select) {
    if (!select)
        return;
    if (Array.isArray(select))
        return select;
    const result = [];
    for (const [key, value] of Object.entries(select)) {
        if (value) {
            result.push(key);
        }
    }
    return result;
}
//# sourceMappingURL=InternalModelManager.js.map
;// ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.44_bufferutil@4.0.9_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/index.js

















//# sourceMappingURL=index.js.map
;// ../@gadgetinc/widgets/src/icons/ActionCloseIcon.svg
const ActionCloseIcon_namespaceObject = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z\" fill=\"black\"/>\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/ChevronUpIcon.svg
const ChevronUpIcon_namespaceObject = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path\n    fill-rule=\"evenodd\"\n    clip-rule=\"evenodd\"\n    d=\"M1.94692 10.371C1.90706 10.4656 1.88656 10.5671 1.88666 10.6697C1.88685 10.8222 1.93248 10.9711 2.01772 11.0975C2.10296 11.2239 2.22395 11.322 2.36522 11.3793C2.5065 11.4366 2.66164 11.4505 2.81084 11.4192C2.95981 11.3879 3.09611 11.313 3.20236 11.2041L7.99317 6.41325L12.7837 11.2038C12.8542 11.277 12.9386 11.3355 13.0319 11.3759C13.1255 11.4163 13.2263 11.4377 13.3283 11.4387C13.4303 11.4398 13.5315 11.4205 13.6259 11.3819C13.7203 11.3433 13.8061 11.2863 13.8783 11.2142C13.9504 11.1421 14.0074 11.0563 14.0459 10.9619C14.0845 10.8674 14.1038 10.7662 14.1028 10.6642C14.1018 10.5622 14.0804 10.4615 14.0399 10.3679C13.9996 10.2746 13.9411 10.1902 13.8679 10.1197L8.53522 4.78704C8.39144 4.64332 8.19646 4.56258 7.99317 4.56258C7.78987 4.56258 7.59488 4.64333 7.4511 4.78706L2.11824 10.1199C2.04495 10.1914 1.9867 10.2767 1.94692 10.371Z\"\n    fill=\"black\"\n  />\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/DownLeftArrowIcon.svg
const DownLeftArrowIcon_namespaceObject = "<svg viewBox=\"0 0 16 16\" fill=\"#404B5A\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path\n      d=\"M1.50791 2.65924C1.6404 2.66131 1.76666 2.71589 1.85895 2.81098C1.95123 2.90607 2.002 3.0339 2.0001 3.1664V8.1664C2.0001 8.63248 2.36736 8.99974 2.83343 8.99974H13.2931L10.8132 6.51992C10.7411 6.44967 10.6919 6.35927 10.672 6.26057C10.652 6.16187 10.6624 6.05946 10.7017 5.96673C10.7409 5.87401 10.8072 5.7953 10.892 5.7409C10.9767 5.6865 11.0759 5.65895 11.1765 5.66184C11.3064 5.66563 11.4297 5.7198 11.5203 5.81289L14.8536 9.14622C14.9473 9.23999 15 9.36715 15 9.49973C15 9.63232 14.9473 9.75948 14.8536 9.85325L11.5203 13.1866C11.4742 13.2346 11.419 13.2729 11.358 13.2993C11.2969 13.3257 11.2312 13.3396 11.1647 13.3403C11.0981 13.341 11.0322 13.3284 10.9706 13.3032C10.909 13.2781 10.853 13.2409 10.806 13.1938C10.7589 13.1468 10.7218 13.0909 10.6966 13.0293C10.6715 12.9677 10.6589 12.9017 10.6596 12.8352C10.6602 12.7687 10.6742 12.7029 10.7006 12.6419C10.727 12.5808 10.7653 12.5256 10.8132 12.4796L13.2931 9.99973H2.83343C1.82684 9.99973 1.0001 9.17299 1.0001 8.1664V3.1664C0.999138 3.09948 1.01162 3.03305 1.03681 2.97104C1.062 2.90903 1.09938 2.85271 1.14673 2.80541C1.19409 2.75812 1.25046 2.72081 1.3125 2.6957C1.37454 2.67059 1.44099 2.65819 1.50791 2.65924Z\"\n    />\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/ErrorCircleIcon.svg
const ErrorCircleIcon_namespaceObject = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.41064 6.25811L5.41118 6.25864L7.15259 8.00006L5.41083 9.74182C5.35361 9.79696 5.30791 9.86291 5.27638 9.93586C5.24471 10.0091 5.22798 10.088 5.22717 10.1678C5.22636 10.2476 5.24148 10.3268 5.27165 10.4007C5.30183 10.4746 5.34644 10.5418 5.40289 10.5982C5.45933 10.6547 5.52647 10.6993 5.60038 10.7295C5.67428 10.7596 5.75346 10.7747 5.83329 10.7739C5.91311 10.7731 5.99197 10.7564 6.06524 10.7247C6.13819 10.6932 6.20414 10.6475 6.25928 10.5903L8.00104 8.84852L9.74281 10.5903C9.79794 10.6475 9.86389 10.6932 9.93684 10.7247C10.0101 10.7564 10.089 10.7731 10.1688 10.7739C10.2486 10.7747 10.3278 10.7596 10.4017 10.7295C10.4756 10.6993 10.5427 10.6547 10.5992 10.5982C10.6556 10.5418 10.7003 10.4746 10.7304 10.4007C10.7606 10.3268 10.7757 10.2476 10.7749 10.1678C10.7741 10.088 10.7574 10.0091 10.7257 9.93586C10.6942 9.86292 10.6485 9.79696 10.5913 9.74183L8.84949 8.00006L10.5913 6.2583C10.6781 6.17466 10.7377 6.06681 10.7623 5.94878C10.7871 5.8304 10.7754 5.70731 10.729 5.59566C10.6825 5.484 10.6034 5.38898 10.502 5.32307C10.4006 5.25715 10.2817 5.22341 10.1608 5.22626C10.0027 5.23 9.85248 5.29599 9.7428 5.40986L8.00104 7.15161L6.25963 5.41022L6.25908 5.40965C6.20327 5.35233 6.13655 5.30674 6.06285 5.27557C5.98891 5.2443 5.90945 5.22819 5.82917 5.22819H5.82914C5.70974 5.22822 5.59305 5.26387 5.49402 5.33059C5.39499 5.3973 5.31812 5.49205 5.27324 5.6027C5.22836 5.71335 5.21751 5.83488 5.24208 5.95173C5.2666 6.06833 5.32528 6.17499 5.41064 6.25811ZM8.00104 1.2334C4.26983 1.2334 1.23438 4.26886 1.23438 8.00006C1.23438 11.7313 4.26983 14.7667 8.00104 14.7667C11.7322 14.7667 14.7677 11.7313 14.7677 8.00006C14.7677 4.26886 11.7322 1.2334 8.00104 1.2334ZM8.00104 2.4334C11.0814 2.4334 13.5677 4.91976 13.5677 8.00006C13.5677 11.0804 11.0814 13.5667 8.00104 13.5667C4.92073 13.5667 2.43437 11.0804 2.43437 8.00006C2.43437 4.91976 4.92073 2.4334 8.00104 2.4334Z\" fill=\"currentColor\"/>\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/OpenInNewTabIcon.svg
const OpenInNewTabIcon_namespaceObject = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      d=\"M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z\"\n      fill=\"currentColor\"\n    />\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/ReturnKeyCommandIcon.svg
const ReturnKeyCommandIcon_namespaceObject = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M9.49079 3.32623C9.35829 3.3283 9.23204 3.38288 9.13975 3.47797C9.04747 3.57306 8.9967 3.7009 8.9986 3.83339V8.50006C8.9986 8.78223 8.78077 9.00006 8.4986 9.00006H5.03897L5.51878 8.52024C5.59092 8.44999 5.64016 8.3596 5.66007 8.2609C5.67999 8.1622 5.66964 8.05978 5.63038 7.96706C5.59112 7.87434 5.52479 7.79563 5.44006 7.74123C5.35533 7.68683 5.25615 7.65927 5.1555 7.66217C5.02565 7.66596 4.90237 7.72013 4.81175 7.81321L3.47842 9.14655C3.38469 9.24032 3.33203 9.36748 3.33203 9.50006C3.33203 9.63265 3.38469 9.75981 3.47842 9.85358L4.81175 11.1869C4.85783 11.2349 4.91301 11.2732 4.97407 11.2996C5.03514 11.326 5.10085 11.3399 5.16737 11.3406C5.23389 11.3413 5.29988 11.3287 5.36147 11.3035C5.42306 11.2784 5.47901 11.2412 5.52605 11.1942C5.57309 11.1471 5.61027 11.0912 5.63541 11.0296C5.66055 10.968 5.67316 10.902 5.67248 10.8355C5.67181 10.769 5.65786 10.7033 5.63147 10.6422C5.60508 10.5811 5.56677 10.526 5.51878 10.4799L5.03897 10.0001H8.4986C9.3211 10.0001 9.9986 9.32256 9.9986 8.50006V3.83339C9.99956 3.76647 9.98708 3.70004 9.96189 3.63803C9.9367 3.57602 9.89932 3.5197 9.85196 3.47241C9.80461 3.42511 9.74824 3.3878 9.6862 3.36269C9.62416 3.33759 9.55771 3.32519 9.49079 3.32623Z\" fill=\"#6D6D6D\"/>\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/SparkleIcon.svg
const SparkleIcon_namespaceObject = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M9.83716 4.62808C10.0977 3.57469 11.5967 3.57467 11.8572 4.62808L12.2908 6.38883C12.9389 9.01279 14.9885 11.0626 17.6126 11.7106L19.3733 12.1457C20.4272 12.406 20.4273 13.904 19.3733 14.1642L17.6126 14.5993C14.9883 15.2474 12.9387 17.2967 12.2908 19.9211L11.8572 21.6818C11.5964 22.7346 10.098 22.7347 9.83716 21.6818L9.40357 19.9211C8.75568 17.2967 6.70603 15.2474 4.08179 14.5993L2.32105 14.1642C1.26703 13.904 1.2672 12.4061 2.32105 12.1457L4.08179 11.7106C6.70573 11.0625 8.75542 9.01274 9.40357 6.38883L9.83716 4.62808ZM18.635 1.78482C18.719 1.44676 19.2001 1.44669 19.2839 1.78482C19.6411 3.23019 20.7696 4.36052 22.2151 4.71744C22.5536 4.8012 22.5538 5.28276 22.2151 5.36637C20.7696 5.72347 19.6409 6.85194 19.2839 8.29752C19.1997 8.63502 18.7192 8.63503 18.635 8.29752C18.2781 6.85173 17.1482 5.72335 15.7024 5.36637C15.3645 5.28248 15.3648 4.80168 15.7024 4.71744C17.148 4.36059 18.2778 3.23027 18.635 1.78482Z\" fill=\"url(#paint0_radial_2231_9971)\"/>\n<defs>\n<radialGradient id=\"paint0_radial_2231_9971\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(1.60523 11.5715) rotate(46.3593) scale(15.0617 14.638)\">\n<stop offset=\"0.015\" stop-color=\"#A259FF\"/>\n<stop offset=\"1\" stop-color=\"#FF597D\"/>\n</radialGradient>\n</defs>\n</svg>\n";
;// ../@gadgetinc/widgets/src/icons/SpeedometerIcon.svg
const SpeedometerIcon_namespaceObject = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7.9918 0.999545C7.96152 1.00035 7.93135 1.00378 7.90166 1.00979C6.67254 1.0269 5.52199 1.36587 4.52322 1.9413C4.43794 1.96702 4.36062 2.01402 4.29854 2.07789C3.33745 2.68081 2.5343 3.50867 1.96156 4.48998C1.90923 4.54543 1.86961 4.61161 1.84547 4.68393C1.32633 5.64352 1.02618 6.73757 1.00956 7.89915C0.996812 7.96501 0.996812 8.03271 1.00956 8.09857C1.06261 11.9092 4.17698 14.9934 8 14.9934C11.8221 14.9934 14.9359 11.9107 14.9904 8.1013C15.0032 8.03544 15.0032 7.96774 14.9904 7.90188C14.9743 6.73983 14.6743 5.64532 14.1552 4.6853C14.1311 4.61243 14.0912 4.54576 14.0384 4.48998C13.4656 3.50851 12.6621 2.68084 11.7008 2.07789C11.6392 2.01456 11.5626 1.96782 11.4781 1.94198C10.4798 1.36651 9.32971 1.02737 8.10107 1.00979C8.06511 1.00256 8.02849 0.99913 7.9918 0.999545ZM7.47551 2.08267V2.93018C7.47453 2.99968 7.48737 3.06868 7.51329 3.13318C7.5392 3.19767 7.57768 3.25637 7.62648 3.30587C7.67528 3.35537 7.73343 3.39467 7.79755 3.4215C7.86168 3.44832 7.93049 3.46214 8 3.46214C8.06951 3.46214 8.13832 3.44832 8.20245 3.4215C8.26657 3.39467 8.32472 3.35537 8.37352 3.30587C8.42232 3.25637 8.4608 3.19767 8.48671 3.13318C8.51263 3.06868 8.52547 2.99968 8.52449 2.93018V2.08267C9.26017 2.14679 9.95463 2.34703 10.5883 2.65359L10.1533 3.38023C10.1173 3.43935 10.0934 3.505 10.0829 3.5734C10.0724 3.6418 10.0756 3.7116 10.0922 3.77878C10.1088 3.84596 10.1385 3.90919 10.1797 3.96482C10.2208 4.02046 10.2726 4.0674 10.332 4.10294C10.3913 4.13849 10.4572 4.16193 10.5256 4.17192C10.5941 4.18192 10.6639 4.17826 10.7309 4.16117C10.798 4.14408 10.861 4.11388 10.9163 4.07233C10.9717 4.03078 11.0182 3.97869 11.0534 3.91906L11.4891 3.19106C12.0459 3.59531 12.5327 4.09023 12.9198 4.66003L12.174 5.07525C12.0525 5.14299 11.9629 5.25624 11.9248 5.39007C11.8868 5.52391 11.9035 5.66738 11.9712 5.78891C12.039 5.91044 12.1522 6.00009 12.286 6.03813C12.4199 6.07617 12.5633 6.05948 12.6849 5.99174L13.4272 5.57857C13.6893 6.16661 13.8591 6.80455 13.9176 7.47574H13.07C13.0005 7.47475 12.9315 7.4876 12.867 7.51351C12.8026 7.53943 12.7439 7.57791 12.6944 7.62671C12.6449 7.67551 12.6056 7.73366 12.5787 7.79778C12.5519 7.8619 12.5381 7.93072 12.5381 8.00023C12.5381 8.06973 12.5519 8.13855 12.5787 8.20267C12.6056 8.26679 12.6449 8.32494 12.6944 8.37374C12.7439 8.42254 12.8026 8.46102 12.867 8.48694C12.9315 8.51286 13.0005 8.5257 13.07 8.52471H13.9176C13.6524 11.5664 11.1119 13.9444 8 13.9444C4.88809 13.9444 2.34755 11.5664 2.08244 8.52471H2.92995C2.99945 8.5257 3.06846 8.51286 3.13295 8.48694C3.19745 8.46102 3.25615 8.42254 3.30564 8.37374C3.35514 8.32494 3.39444 8.26679 3.42127 8.20267C3.4481 8.13855 3.46191 8.06973 3.46191 8.00023C3.46191 7.93072 3.4481 7.8619 3.42127 7.79778C3.39444 7.73366 3.35514 7.67551 3.30564 7.62671C3.25615 7.57791 3.19745 7.53943 3.13295 7.51351C3.06846 7.4876 2.99945 7.47475 2.92995 7.47574H2.08244C2.14094 6.80455 2.31071 6.16661 2.57278 5.57857L3.31512 5.99174C3.3753 6.02528 3.4415 6.04664 3.50993 6.0546C3.57836 6.06256 3.64769 6.05696 3.71396 6.03813C3.78023 6.01929 3.84214 5.98759 3.89616 5.94483C3.95017 5.90207 3.99524 5.84909 4.02878 5.78891C4.06232 5.72873 4.08368 5.66254 4.09164 5.59411C4.0996 5.52567 4.09401 5.45634 4.07517 5.39007C4.05634 5.3238 4.02463 5.26189 3.98187 5.20788C3.93911 5.15386 3.88613 5.10879 3.82595 5.07525L3.0802 4.66003C3.46729 4.09023 3.9541 3.59531 4.51093 3.19106L4.94664 3.91906C4.98175 3.97869 5.02832 4.03078 5.08366 4.07233C5.13899 4.11388 5.202 4.14408 5.26906 4.16117C5.33612 4.17826 5.4059 4.18192 5.47437 4.17192C5.54285 4.16193 5.60867 4.13849 5.66804 4.10294C5.72742 4.0674 5.77917 4.02046 5.82033 3.96482C5.86148 3.90919 5.89122 3.84596 5.90783 3.77878C5.92444 3.7116 5.92759 3.6418 5.91711 3.5734C5.90662 3.505 5.8827 3.43935 5.84673 3.38023L5.41171 2.65359C6.04537 2.34703 6.73983 2.14679 7.47551 2.08267ZM5.72176 5.19749C5.61738 5.19752 5.51538 5.22869 5.42881 5.28701C5.34224 5.34533 5.27504 5.42815 5.23581 5.52488C5.19657 5.6216 5.18709 5.72784 5.20857 5.82998C5.23005 5.93213 5.28152 6.02554 5.35639 6.09828L6.98722 7.7291C6.94565 7.88446 6.94036 8.04729 6.97176 8.20502C7.00316 8.36274 7.0704 8.51114 7.16829 8.63873C7.26618 8.76633 7.3921 8.86971 7.53632 8.94088C7.68053 9.01205 7.83918 9.04912 8 9.0492C8.27821 9.0492 8.54502 8.93868 8.74174 8.74196C8.93846 8.54524 9.04897 8.27843 9.04897 8.00023C9.04897 7.72202 8.93846 7.45521 8.74174 7.25849C8.54502 7.06177 8.27821 6.95125 8 6.95125C7.90863 6.95171 7.81772 6.96411 7.72956 6.98813L6.09805 5.35662C6.04916 5.30627 5.99067 5.26625 5.92603 5.23891C5.8614 5.21158 5.79193 5.1975 5.72176 5.19749Z\" fill=\"currentColor\"/>\n</svg>\n";
;// ../framework/src/core/errors/overlay.ts
const ErrorIconUrl = `data:image/svg+xml;base64,${btoa(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.41064 6.25811L5.41118 6.25864L7.15259 8.00006L5.41083 9.74182C5.35361 9.79696 5.30791 9.86291 5.27638 9.93586C5.24471 10.0091 5.22798 10.088 5.22717 10.1678C5.22636 10.2476 5.24148 10.3268 5.27165 10.4007C5.30183 10.4746 5.34644 10.5418 5.40289 10.5982C5.45933 10.6547 5.52647 10.6993 5.60038 10.7295C5.67428 10.7596 5.75346 10.7747 5.83329 10.7739C5.91311 10.7731 5.99197 10.7564 6.06524 10.7247C6.13819 10.6932 6.20414 10.6475 6.25928 10.5903L8.00104 8.84852L9.74281 10.5903C9.79794 10.6475 9.86389 10.6932 9.93684 10.7247C10.0101 10.7564 10.089 10.7731 10.1688 10.7739C10.2486 10.7747 10.3278 10.7596 10.4017 10.7295C10.4756 10.6993 10.5427 10.6547 10.5992 10.5982C10.6556 10.5418 10.7003 10.4746 10.7304 10.4007C10.7606 10.3268 10.7757 10.2476 10.7749 10.1678C10.7741 10.088 10.7574 10.0091 10.7257 9.93586C10.6942 9.86292 10.6485 9.79696 10.5913 9.74183L8.84949 8.00006L10.5913 6.2583C10.6781 6.17466 10.7377 6.06681 10.7623 5.94878C10.7871 5.8304 10.7754 5.70731 10.729 5.59566C10.6825 5.484 10.6034 5.38898 10.502 5.32307C10.4006 5.25715 10.2817 5.22341 10.1608 5.22626C10.0027 5.23 9.85248 5.29599 9.7428 5.40986L8.00104 7.15161L6.25963 5.41022L6.25908 5.40965C6.20327 5.35233 6.13655 5.30674 6.06285 5.27557C5.98891 5.2443 5.90945 5.22819 5.82917 5.22819H5.82914C5.70974 5.22822 5.59305 5.26387 5.49402 5.33059C5.39499 5.3973 5.31812 5.49205 5.27324 5.6027C5.22836 5.71335 5.21751 5.83488 5.24208 5.95173C5.2666 6.06833 5.32528 6.17499 5.41064 6.25811ZM8.00104 1.2334C4.26983 1.2334 1.23438 4.26886 1.23438 8.00006C1.23438 11.7313 4.26983 14.7667 8.00104 14.7667C11.7322 14.7667 14.7677 11.7313 14.7677 8.00006C14.7677 4.26886 11.7322 1.2334 8.00104 1.2334ZM8.00104 2.4334C11.0814 2.4334 13.5677 4.91976 13.5677 8.00006C13.5677 11.0804 11.0814 13.5667 8.00104 13.5667C4.92073 13.5667 2.43437 11.0804 2.43437 8.00006C2.43437 4.91976 4.92073 2.4334 8.00104 2.4334Z"
    fill="#B13325"
  />
</svg>`)}`;
const FixIconUrl = `data:image/svg+xml;base64,${btoa(`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.83716 4.62808C10.0977 3.57469 11.5967 3.57467 11.8572 4.62808L12.2908 6.38883C12.9389 9.01279 14.9885 11.0626 17.6126 11.7106L19.3733 12.1457C20.4272 12.406 20.4273 13.904 19.3733 14.1642L17.6126 14.5993C14.9883 15.2474 12.9387 17.2967 12.2908 19.9211L11.8572 21.6818C11.5964 22.7346 10.098 22.7347 9.83716 21.6818L9.40357 19.9211C8.75568 17.2967 6.70603 15.2474 4.08179 14.5993L2.32105 14.1642C1.26703 13.904 1.2672 12.4061 2.32105 12.1457L4.08179 11.7106C6.70573 11.0625 8.75542 9.01274 9.40357 6.38883L9.83716 4.62808ZM18.635 1.78482C18.719 1.44676 19.2001 1.44669 19.2839 1.78482C19.6411 3.23019 20.7696 4.36052 22.2151 4.71744C22.5536 4.8012 22.5538 5.28276 22.2151 5.36637C20.7696 5.72347 19.6409 6.85194 19.2839 8.29752C19.1997 8.63502 18.7192 8.63503 18.635 8.29752C18.2781 6.85173 17.1482 5.72335 15.7024 5.36637C15.3645 5.28248 15.3648 4.80168 15.7024 4.71744C17.148 4.36059 18.2778 3.23027 18.635 1.78482Z"
    fill="url(#paint0_radial_2231_9971)"
  />
  <defs>
    <radialGradient id="paint0_radial_2231_9971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1.60523 11.5715) rotate(46.3593) scale(15.0617 14.638)">
      <stop offset="0.015" stop-color="#A259FF"/>
      <stop offset="1" stop-color="#FF597D"/>
    </radialGradient>
  </defs>
</svg>
`)}`;
const CopyIconUrl = `data:image/svg+xml;base64,${btoa(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M5.13385 1.31567C4.61819 1.31567 4.20052 1.73334 4.20052 2.24901V9.71567C4.20052 10.2313 4.61819 10.649 5.13385 10.649H11.2005C11.7162 10.649 12.1339 10.2313 12.1339 9.71567V4.34901C12.1339 4.22534 12.0849 4.10679 11.9971 4.01906L9.43047 1.45239C9.34274 1.36466 9.22419 1.31567 9.10052 1.31567H5.13385ZM8.86719 2.20435L11.2452 4.58234H9.33385C9.07625 4.58234 8.86719 4.37327 8.86719 4.11567V2.20435ZM2.80052 3.64901C2.28485 3.64901 1.86719 4.06667 1.86719 4.58234V12.049C1.86719 12.5647 2.28485 12.9823 2.80052 12.9823H8.86719C9.38285 12.9823 9.80052 12.5647 9.80052 12.049V11.5823H5.13385C4.10439 11.5823 3.26719 10.7451 3.26719 9.71567V3.64901H2.80052Z"
    fill="black"
  />
</svg>`)}`;
const ChevronRightIconUrl = `data:image/svg+xml;base64,${btoa(`<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.62439 2.45284C5.52986 2.41298 5.4283 2.39248 5.32572 2.39258C5.17327 2.39277 5.0243 2.4384 4.89791 2.52364C4.77152 2.60888 4.67341 2.72987 4.61611 2.87114C4.55882 3.01242 4.54493 3.16756 4.57624 3.31676C4.6075 3.46573 4.68239 3.60203 4.79137 3.70828L9.58217 8.49909L4.79161 13.2897C4.71838 13.3602 4.6599 13.4445 4.61957 13.5378C4.5791 13.6315 4.55772 13.7322 4.55668 13.8342C4.55564 13.9362 4.57497 14.0374 4.61352 14.1318C4.65208 14.2263 4.70909 14.3121 4.78121 14.3842C4.85334 14.4563 4.93913 14.5133 5.03357 14.5519C5.128 14.5904 5.22918 14.6098 5.33118 14.6087C5.43317 14.6077 5.53394 14.5863 5.62757 14.5458C5.72087 14.5055 5.80522 14.447 5.87572 14.3738L11.2084 9.04114C11.3521 8.89736 11.4328 8.70238 11.4328 8.49909C11.4328 8.29579 11.3521 8.10081 11.2084 7.95702L5.8755 2.62416C5.80407 2.55087 5.71869 2.49262 5.62439 2.45284Z" fill="#6F6C71"/>
</svg>`)}`;
const InconsolataFont = /* css */ `
:root {
  --inconsolata: Gadget-Inconsolata-Private, sans-serif;
  font-family: var(--inconsolata);
}
  /* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
`;
const baseStyle = /* css */ `

gadget-dev-harness {
  display: none;
}

.window {
  font-family: var(--inconsolata);
  line-height: 1.5;
  max-width: 80vw;
  box-sizing: border-box;
  margin: 30px auto;
  position: relative;
  border-radius: 6px 6px 8px 8px;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  overflow: hidden;
  direction: ltr;
  text-align: left;
  outline: 1px #db3927 solid;
  outline-offset: -1px;
}

.error-overlay {
  font-family: var(--inconsolata);
  width: 100%;
  background: white;
  overflow: hidden;
  border-radius: 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
}

.error-container {
  align-self: stretch;
  background: white;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
}

.error-content {
  align-self: stretch;
  padding: 12px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: flex;
  max-height: 90vh;
  overflow: auto;
}

.error-header {
  align-self: stretch;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  display: flex;
}

.error-title-row {
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
}

.error-icon-wrapper {
  padding-top: 2px;
  padding-bottom: 2px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  display: flex;
}

.error-title pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
}

.error-icon {
  width: 16px;
  height: 16px;
  position: relative;
  overflow: hidden;
}

.error-details {
  align-self: stretch;
  background: #f6f6f6;
  border-radius: 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
}

.error-details-content {
  align-self: stretch;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  display: flex;
}

.error-file-path {
  align-self: stretch;
  color: #2d53b1;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  cursor: pointer;
}

.error-file-path:hover {
  text-decoration: underline;
}

.error-message {
  align-self: stretch;
  color: black;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
}

.error-stack {
  align-self: stretch;
  padding: 8px 12px;
  overflow: hidden;
  border-radius: 8px;
  outline: 1px #cbcbcb solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: inline-flex;
}

.error-stack-content {
  flex: 1 1 0;
  align-self: stretch;
  color: #545454;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  word-wrap: break-word;
}

.standard-button{
  height: 24px;
  display: inline-flex;
  padding: var(--scale-scale200, 6px);
  justify-content: center;
  align-items: center;
  gap: var(--scale-scale300, 8px);
  border-radius: var(--radius-button-radius, 6px);
  border: 1px solid var(--gray-gray300, #CBCBCB);
  background: var(--neutral-Background, #FFF);
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);
}
.standard-button:hover{
  border: 1px solid var(--gray-gray300, #CBCBCB);
  background: var(--gray-gray50, #F6F6F6);
}
.standard-button:active:not(:disabled){
  border: 1px solid var(--gray-gray200, #E2E2E2);
  background: var(--gray-gray50, #F6F6F6);
  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;
}

.error-fix-button {
  display: inline-flex;
  height: 24px;
  padding: 4px 8px 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: var(--radius-button-radius, 6px);
  border: 1px solid #C99EFF;
  background: #FFF;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  margin-left: auto;
}

.error-fix-button:hover {
  border: 1px solid #E786B2;
  background: #FBF5F8;
}

.error-fix-button:active:not(:disabled){
  transform: translateY(1px);
  border: 1px solid #FBDBE9;
  background: #FBF5F8;
  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;
}

.error-fix-icon {
  width: 16px;
  height: 16px;
  position: relative;
  overflow: hidden;
}

.error-fix-icon-gradient {
  width: 12.94px;
  height: 13.34px;
  left: 1.45px;
  top: 1.6px;
  position: absolute;
  background: radial-gradient(ellipse 71.93% 69.94% at 0.36% 47.95%, #a259ff 1%, #ff597d 100%);
}

.error-fix-text {
  color: #9b2e84;
  font-size: 14px;
  font-family: var(--inconsolata);
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
}

.message {
  white-space: pre-wrap;
}

.error-title pre {
  margin: 0;
  white-space: pre-wrap;
  flex: 1 1 0;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #b13325;
  font-size: 14px;
  font-family: var(--inconsolata);
  font-weight: 700;
  line-height: 20px;
  word-wrap: break-word;
}

.error-content-text {
  flex: 1 1 0;
  align-self: stretch;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  font-family: var(--inconsolata);
}

.error-trace-id-content-box {
  width: 100%;
  box-sizing: border-box;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 6px;
  outline: 1px var(--gray-alpha-alpha300, rgba(0, 0, 0, 0.20)) solid;
  outline-offset: -1px;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
  cursor: pointer;
}

.error-trace-id-content-box:hover {
  background-color: var(--gray-alpha-alpha100, rgb(241, 241, 241));
}

.error-trace-id-content-box:active:not(:disabled) > * {
  transform: translateY(1px);
}

.error-trace-id-content {
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  display: flex;
}

.error-stack-trace-content-box {
  background: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03));
  padding: 12px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: inline-flex;
}

.error-stack-trace-content {
  flex: 1 1 0;
  align-self: stretch;
  color: var(--gray-gray600, #545454);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-family: var(--inconsolata);
}
`;
const Style = (overlayStyle)=>{
    const style = [];
    switch(overlayStyle.style){
        case "backendError":
        case "rr7Frontend":
            style.push(`
body {
  background: #515151;
}`);
            break;
        case "viteFrontend":
            style.push(`
:host {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  --inconsolata: Gadget-Inconsolata-Private, sans-serif;
      background: #515151;
}`);
            break;
    }
    return InconsolataFont + style.join("\n") + baseStyle;
};
const getErrorMessage = (overlayStyle)=>{
    let errorMessage = "";
    switch(overlayStyle.style){
        case "backendError":
            {
                errorMessage = `${overlayStyle.errorMessage}\n\nTrace ID: ${overlayStyle.traceId}`;
                break;
            }
        case "rr7Frontend":
            {
                errorMessage = `${overlayStyle.stackTrace}`;
                break;
            }
        default:
            {
                errorMessage = ``;
                break;
            }
    }
    return errorMessage.replaceAll("`", "\\`");
};
const checkIfInGadgetIFrame = ()=>{
    return new Promise((resolve)=>{
        const handleMessage = (event)=>{
            if (event.data?.type === "gadget:pong") {
                resolve(true);
                window.removeEventListener("message", handleMessage);
            }
        };
        window.addEventListener("message", handleMessage);
        window.parent.postMessage({
            type: "gadget:ping"
        }, "*");
        setTimeout(()=>{
            resolve(false);
            window.removeEventListener("message", handleMessage);
        }, 100);
    });
};
const overlayTemplate = (overlay)=>{
    const aiFixButton = /*html*/ `
    <button class="error-fix-button">
      <img src="${FixIconUrl}" alt="Fix icon" width="16" height="16" />
      <div class="error-fix-text">Fix</div>
    </button>`;
    const getErrorTitleText = (overlayStyle)=>{
        switch(overlayStyle.style){
            case "backendError":
                return "Unexpected server-side error";
            case "viteFrontend":
                return "Vite hot reload error";
            case "rr7Frontend":
                return "React router server-side rendering error";
            default:
                return "Unexpected error";
        }
    };
    const maybeGetTraceIdLinkComponent = (overlayStyle)=>{
        if (overlayStyle.style !== "backendError") {
            return "";
        }
        return /* html */ `
      <div class="error-trace-id-content-box">
        <div class="error-trace-id-content">
            <div style="color: var(--gray-alpha-alpha600, rgba(0, 0, 0, 0.67)); font-size: 14px; font-weight: 500; line-height: 20px; word-wrap: break-word">traceID: ${overlayStyle.traceId}</div>
        </div>
        <img src="${ChevronRightIconUrl}" alt="Chevron right icon" width="16" height="16" />
      </div>
      ${maybeGetErrorMessageComponent(overlayStyle)}`;
    };
    const maybeGetErrorMessageComponent = (overlayStyle)=>{
        if (!("errorMessage" in overlayStyle && overlayStyle.errorMessage)) {
            return "";
        }
        return /* html */ `
      <div class="error-stack-trace-content-box">
        <div class="error-content-text">${overlayStyle.errorMessage}</div>
        ${aiFixButton}
      </div>`;
    };
    const maybeGetErrorDetailsContentComponent = (overlayStyle)=>{
        if (overlayStyle.style !== "viteFrontend") {
            return "";
        }
        return /* html */ `
      <div class="error-stack-trace-content-box">
        <div class="error-details-content">
          <div id="error-message-file" class="error-content-text"></div>
          <div id="error-message" class="error-content-text"></div>
        </div>
        ${aiFixButton}
      </div>
      `;
    };
    const copyButton = (textToCopy)=>{
        // TODO - Add this to the stack trace when we can reliably know that we have the permission to copy from the browser available
        return /* html */ `
      <button class="standard-button" onclick="navigator.clipboard.writeText(\`${textToCopy.replace(/'/g, "\\'")}\`)">
        <img src="${CopyIconUrl}" alt="Copy icon" width="16" height="16" />
      </button>`;
    };
    const maybeGetStackTraceComponent = (overlayStyle)=>{
        if (overlayStyle.style !== "rr7Frontend") {
            return "";
        }
        return /* html */ `
      <div class="error-stack-trace-content-box">
        <div class="error-stack-trace-content">${overlayStyle.stackTrace}</div>
        ${aiFixButton}
      </div>`;
    };
    return {
        html: /* html */ `
<style>${Style(overlay)}</style>

<div class="window">
  <div class="error-overlay">
    <div class="error-container">
      <div class="error-content">
        <div class="error-header">
          <div class="error-title-row">
            <div class="error-icon-wrapper">
              <div class="error-icon">
              <img src="${ErrorIconUrl}" alt="Error icon" width="16" height="16" />
              </div>
            </div>
            <div class="error-title">
              <pre id="plugin-message">${getErrorTitleText(overlay)}</pre>
            </div>
          </div>
        </div>

        ${maybeGetTraceIdLinkComponent(overlay)}
        ${maybeGetErrorDetailsContentComponent(overlay)}
        ${maybeGetStackTraceComponent(overlay)}


      </div>
    </div>
  </div>
</div>`,
        javascript: /* js */ `
    const checkIfInGadgetIFrame = () => {
      return new Promise((resolve) => {
        const handleMessage = (event) => {
          if (event.data?.type === "gadget:pong") {
            resolve(true);
            window.removeEventListener("message", handleMessage);
          }
        };

        window.addEventListener("message", handleMessage);

        window.parent.postMessage({ type: "gadget:ping" }, "*");

        setTimeout(() => {
          resolve(false);
          window.removeEventListener("message", handleMessage);
        }, 100);
      });
    };

    window?.parent?.postMessage({
      type: "gadget:error-overlay-shown",
      overlay: ${JSON.stringify(overlay)},
    }, "*");

    ${overlay.style !== "viteFrontend" ? `
  console.debug("[Gadget-Error-Overlay] Rendering error overlay");

  const errorMessage = \`${getErrorMessage(overlay)}\`;

  const fixButton = document.querySelector(".error-fix-button");
  if (fixButton) {
    console.debug("[Gadget-Error-Overlay] Fix button found attaching event listener");
    const prompt = "Fix the following error:\\n\\n" + errorMessage;

    fixButton.addEventListener("click", () => {

      // Use the check
      checkIfInGadgetIFrame().then((isInGadgetIFrame) => {
        if (isInGadgetIFrame) {
          console.debug("[Gadget-Error-Overlay] Opening error from iframe");
          window.parent.postMessage({ type: "gadget:prompt", prompt }, "*");
        } else {
          console.debug("[Gadget-Error-Overlay] Opening error in new tab");
          fetch(window.location.origin + "/api/zprompt", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ prompt })
          })
            .then(response => response.json())
            .then(payload => {
              window.open(
                window.location.origin + "/edit?promptId=" + encodeURIComponent(payload.id),
                window.self === window.top ? "_top" : "_blank"
              );
            })
            .catch(error => {
              console.error("[Gadget-Error-Overlay] Error sending prompt:", error);
            });
        }
      }).catch((err) => {
        console.error("[Gadget-Error-Overlay] Error firing fix button event", err);
      });
    });
  } else {
    console.error("[Gadget-Error-Overlay] Fix button not found");
  }

  ${overlay.style === "backendError" ? /* html */ `
  const traceIdButton = document.querySelector(".error-trace-id-content-box");
  if (traceIdButton) {
    traceIdButton.addEventListener("click", () => {
      checkIfInGadgetIFrame().then((isInGadgetIFrame) => {
        if (isInGadgetIFrame) {
          console.debug("[Gadget-Error-Overlay] Sending open logs message from iframe");
          window.parent.postMessage({ type: "gadget:openLogs", traceId: "${overlay.traceId}" }, "*");
        } else {
          console.debug("[Gadget-Error-Overlay] Opening trace ID log link");
          window.open(\`${overlay.traceIdLogLink}\`, window.self === window.top ? "_top" : "_blank"); // open in top if in iframe, otherwise open in new tab
        }
      }).catch((err) => {
        console.error("[Gadget-Error-Overlay] Error opening trace ID log link", err);
      });
    });
  } else {
    console.error("[Gadget-Error-Overlay] Trace ID button not found");
  }
  ` : ""}` : ""}

    `
    };
};
// Make HTMLElement available in non-browser environments
const { HTMLElement: overlay_HTMLElement = class {
} } = globalThis;
class ErrorOverlay extends overlay_HTMLElement {
    root;
    constructor(err){
        super();
        this.root = this.attachShadow({
            mode: "open"
        });
        this.root.innerHTML = overlayTemplate({
            style: "viteFrontend"
        }).html;
        this.dir = "ltr";
        const errorLine = err.loc?.line;
        const errorColumn = err.loc?.column;
        const [file] = (err.loc?.file || err.id || "unknown").split(`?`);
        let fileText;
        if (err.loc) {
            fileText = `${file}:${errorLine}:${errorColumn}`;
        } else if (err.id) {
            fileText = file;
        } else {
            fileText = "unknown";
        }
        let fileLink = null;
        const gadgetFolderMatch = file.match(/\/(web|api)\/(.+)/);
        if (gadgetFolderMatch) {
            const filePathForLink = gadgetFolderMatch ? `${gadgetFolderMatch[1]}/${gadgetFolderMatch[2]}` : file;
            const locationQueryParam = errorLine !== undefined && errorColumn !== undefined ? `?startLineNumber=${errorLine}&startColumn=${errorColumn}&force=1` : "";
            if (window.self !== window.top) {
                const filePathButton = this.root.querySelector(".error-file-path");
                if (filePathButton) {
                    filePathButton.addEventListener("click", ()=>{
                        checkIfInGadgetIFrame().then((isInGadgetIFrame)=>{
                            if (isInGadgetIFrame) {
                                window.parent.postMessage({
                                    type: "gadget:openFile",
                                    filePath: filePathForLink
                                }, "*");
                            } else {
                                window.open(`${window.location.origin}/edit/${currentEnvironment}/files/${filePathForLink}${locationQueryParam}`, window.self === window.top ? "_top" : "_blank");
                            }
                        }).catch((err)=>{
                            console.error("[Gadget-Error-Overlay] Error opening file", err);
                        });
                    });
                }
            } else {
                fileLink = this.createLink(`${fileText}`, `${window.location.origin}/edit/${currentEnvironment}/files/${filePathForLink}${locationQueryParam}`);
            }
        }
        const errorMessage = err.message.trim();
        this.text("#error-message", errorMessage);
        this.text("#error-message-file", fileLink?.innerHTML ?? fileText, true);
        const fixButton = this.root.querySelector(".error-fix-button");
        if (fixButton) {
            fixButton.addEventListener("click", ()=>{
                checkIfInGadgetIFrame().then((isInGadgetIFrame)=>{
                    if (isInGadgetIFrame) {
                        window.parent.postMessage({
                            type: "gadget:prompt",
                            prompt: err.message
                        }, "*");
                    } else {
                        fetch(window.location.origin + "/api/zprompt", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                prompt: `Fix the following error:\n\n${err.message}`
                            })
                        }).then((response)=>response.json()).then((payload)=>{
                            window.open(`${window.location.origin}/edit?promptId=${payload.id}`, window.self === window.top ? "_top" : "_blank");
                        }).catch((error)=>{
                            console.error("[Gadget-Error-Overlay] Error sending prompt:", error);
                        });
                    }
                }).catch((err)=>{
                    console.error("[Gadget-Error-Overlay] Error firing fix button event", err);
                });
            });
        } else {
            console.error("fix button not found");
        }
    }
    text(selector, text, html = false) {
        if (!text) {
            return;
        }
        const el = this.root.querySelector(selector);
        if (!el) {
            return;
        }
        if (html) {
            // Automatically detect links
            text = text.split(" ").map((v)=>{
                if (!v.startsWith("https://")) return v;
                if (v.endsWith(".")) return `<a target="_blank" href="${v.slice(0, -1)}">${v.slice(0, -1)}</a>.`;
                return `<a target="_blank" href="${v}">${v}</a>`;
            }).join(" ");
            el.innerHTML = text.trim();
        } else {
            el.textContent = text.trim();
        }
    }
    createLink(text, href) {
        const linkContainer = document.createElement("div");
        const linkElement = href ? document.createElement("a") : document.createElement("button");
        linkElement.innerHTML = text;
        if (href && linkElement instanceof HTMLAnchorElement) {
            linkElement.href = href;
            linkElement.target = "_blank";
        }
        linkContainer.appendChild(linkElement);
        linkContainer.className = "link";
        return linkContainer;
    }
    close() {
        this.parentNode?.removeChild(this);
    }
}
function getOverlayCode(environment) {
    return `
    const baseStyle = \`${baseStyle}\`;
    const ChevronRightIconUrl = "${ChevronRightIconUrl}";
    const ErrorIconUrl = "${ErrorIconUrl}";
    const FixIconUrl = "${FixIconUrl}";
    const InconsolataFont = \`${InconsolataFont}\`;
    const getErrorMessage = ${getErrorMessage};
    const Style = ${Style};
		const overlayTemplate = ${overlayTemplate};
    const currentEnvironment = "${environment}";
    const checkIfInGadgetIFrame = ${checkIfInGadgetIFrame};
		${ErrorOverlay.toString()}
	`;
}
function patchOverlay(code, environment) {
    let result = code.replace("class ErrorOverlay", getOverlayCode(environment) + "\nclass ViteErrorOverlay");
    result = result.replace('_define_property()._(this, "root", void 0);', "");
    return result;
}

;// ../../node_modules/.pnpm/nanoid@3.3.4/node_modules/nanoid/index.browser.js

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')


;// ./public/assets/bg-bigcommerce-notification.svg
const bg_bigcommerce_notification_namespaceObject = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"237\" height=\"129\" viewBox=\"0 0 237 129\" fill=\"none\">\n<g clip-path=\"url(#clip0_432_10011)\">\n<mask id=\"mask0_432_10011\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"-74\" width=\"299\" height=\"299\">\n<path d=\"M299 -74H0V225H299V-74Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_432_10011)\">\n<g opacity=\"0.6\">\n<path d=\"M149.5 213.864C232.067 213.864 299 146.931 299 64.364C299 -18.2026 232.067 -85.136 149.5 -85.136C66.9334 -85.136 0 -18.2026 0 64.364C0 146.931 66.9334 213.864 149.5 213.864Z\" fill=\"white\"/>\n<path d=\"M149.5 213.667C231.958 213.667 298.803 146.822 298.803 64.364C298.803 -18.0936 231.958 -84.9387 149.5 -84.9387C67.0424 -84.9387 0.197266 -18.0936 0.197266 64.364C0.197266 146.822 67.0424 213.667 149.5 213.667Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.4\" stroke-width=\"0.709379\"/>\n<g filter=\"url(#filter0_d_432_10011)\">\n<path d=\"M149.5 192.138C220.069 192.138 277.276 134.931 277.276 64.362C277.276 -6.20674 220.069 -63.4141 149.5 -63.4141C78.9309 -63.4141 21.7236 -6.20674 21.7236 64.362C21.7236 134.931 78.9309 192.138 149.5 192.138Z\" fill=\"white\"/>\n<path d=\"M149.5 191.941C219.96 191.941 277.079 134.822 277.079 64.362C277.079 -6.09784 219.96 -63.2168 149.5 -63.2168C79.0399 -63.2168 21.9209 -6.09784 21.9209 64.362C21.9209 134.822 79.0399 191.941 149.5 191.941Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.51\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter1_d_432_10011)\">\n<path d=\"M149.498 169.229C207.415 169.229 254.366 122.278 254.366 64.3617C254.366 6.44525 207.415 -40.5054 149.498 -40.5054C91.5815 -40.5054 44.6309 6.44525 44.6309 64.3617C44.6309 122.278 91.5815 169.229 149.498 169.229Z\" fill=\"white\"/>\n<path d=\"M149.498 169.032C207.306 169.032 254.168 122.169 254.168 64.3617C254.168 6.55415 207.306 -40.3081 149.498 -40.3081C91.6904 -40.3081 44.8281 6.55415 44.8281 64.3617C44.8281 122.169 91.6904 169.032 149.498 169.032Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.6\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter2_d_432_10011)\">\n<path d=\"M149.5 145.408C194.259 145.408 230.543 109.124 230.543 64.3657C230.543 19.6073 194.259 -16.6765 149.5 -16.6765C104.742 -16.6765 68.458 19.6073 68.458 64.3657C68.458 109.124 104.742 145.408 149.5 145.408Z\" fill=\"white\"/>\n<path d=\"M149.5 145.21C194.149 145.21 230.345 109.014 230.345 64.3652C230.345 19.716 194.149 -16.4792 149.5 -16.4792C104.851 -16.4792 68.6553 19.716 68.6553 64.3652C68.6553 109.014 104.851 145.21 149.5 145.21Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.8\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter3_d_432_10011)\">\n<path d=\"M149.501 121.054C180.809 121.054 206.19 95.6731 206.19 64.3647C206.19 33.0563 180.809 7.67578 149.501 7.67578C118.192 7.67578 92.8115 33.0563 92.8115 64.3647C92.8115 95.6731 118.192 121.054 149.501 121.054Z\" fill=\"white\"/>\n<path d=\"M149.5 120.856C180.699 120.856 205.992 95.5641 205.992 64.3647C205.992 33.1652 180.699 7.87305 149.5 7.87305C118.3 7.87305 93.0088 33.1652 93.0088 64.3647C93.0088 95.5641 118.3 120.856 149.5 120.856Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.9\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter4_d_432_10011)\">\n<path d=\"M149.499 96.1586C167.059 96.1586 181.294 81.9238 181.294 64.3641C181.294 46.8045 167.059 32.5696 149.499 32.5696C131.939 32.5696 117.705 46.8045 117.705 64.3641C117.705 81.9238 131.939 96.1586 149.499 96.1586Z\" fill=\"#FDFDFD\"/>\n<path d=\"M149.499 95.9609C166.949 95.9609 181.096 81.8144 181.096 64.3639C181.096 46.9133 166.949 32.7668 149.499 32.7668C132.048 32.7668 117.902 46.9133 117.902 64.3639C117.902 81.8144 132.048 95.9609 149.499 95.9609Z\" stroke=\"#DDDDDD\" stroke-width=\"0.709379\"/>\n</g>\n</g>\n<path d=\"M150.335 66.755H154.596C155.808 66.755 156.576 66.0886 156.576 65.0181C156.576 64.0083 155.808 63.2812 154.596 63.2812H150.335C150.193 63.2812 150.072 63.4024 150.072 63.5236V66.5127C150.092 66.6541 150.193 66.755 150.335 66.755Z\" fill=\"#34313F\"/>\n<path d=\"M150.335 73.6426H154.738C156.091 73.6426 156.899 72.956 156.899 71.7442C156.899 70.694 156.131 69.8457 154.738 69.8457H150.335C150.193 69.8457 150.072 69.9669 150.072 70.0881V73.3801C150.092 73.5416 150.193 73.6426 150.335 73.6426Z\" fill=\"#34313F\"/>\n<path d=\"M166.762 46.9058L153.577 60.0484H155.732C159.092 60.0484 161.078 62.1613 161.078 64.4645C161.078 66.2816 159.852 67.6128 158.542 68.2044C158.331 68.2889 158.331 68.5847 158.563 68.6693C160.085 69.2609 161.162 70.8456 161.162 72.705C161.162 75.3251 159.409 77.4169 156.007 77.4169H146.667C146.519 77.4169 146.393 77.2902 146.393 77.1634V67.2113L131.919 81.6217C131.729 81.8119 131.856 82.15 132.13 82.15H166.931C167.057 82.15 167.163 82.0443 167.163 81.9175V47.0959C167.227 46.8635 166.931 46.7367 166.762 46.9058Z\" fill=\"#34313F\"/>\n</g>\n</g>\n<defs>\n<filter id=\"filter0_d_432_10011\" x=\"18.7289\" y=\"-66.4091\" width=\"261.542\" height=\"261.542\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"1.41876\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_432_10011\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_432_10011\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_432_10011\" x=\"40.2174\" y=\"-44.9191\" width=\"218.561\" height=\"218.562\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"2.12814\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_432_10011\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_432_10011\" result=\"shape\"/>\n</filter>\n<filter id=\"filter2_d_432_10011\" x=\"62.6257\" y=\"-22.509\" width=\"173.749\" height=\"173.749\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"2.83752\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_432_10011\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_432_10011\" result=\"shape\"/>\n</filter>\n<filter id=\"filter3_d_432_10011\" x=\"85.5605\" y=\"0.42451\" width=\"127.881\" height=\"127.88\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"3.5469\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_432_10011\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_432_10011\" result=\"shape\"/>\n</filter>\n<filter id=\"filter4_d_432_10011\" x=\"108.326\" y=\"23.1902\" width=\"82.3472\" height=\"82.3474\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"4.61096\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_432_10011\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_432_10011\" result=\"shape\"/>\n</filter>\n<clipPath id=\"clip0_432_10011\">\n<rect width=\"237\" height=\"129\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n";
;// ./public/assets/bg-shop-notification.svg
const bg_shop_notification_namespaceObject = "<svg width=\"237\" height=\"129\" viewBox=\"0 0 237 129\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1010_3065)\">\n<g opacity=\"0.6\">\n<path d=\"M149.5 213.864C232.067 213.864 299 146.931 299 64.364C299 -18.2026 232.067 -85.136 149.5 -85.136C66.9334 -85.136 0 -18.2026 0 64.364C0 146.931 66.9334 213.864 149.5 213.864Z\" fill=\"white\"/>\n<path d=\"M149.5 213.667C231.958 213.667 298.803 146.822 298.803 64.364C298.803 -18.0936 231.958 -84.9387 149.5 -84.9387C67.0424 -84.9387 0.197266 -18.0936 0.197266 64.364C0.197266 146.822 67.0424 213.667 149.5 213.667Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.4\" stroke-width=\"0.709379\"/>\n<g filter=\"url(#filter0_d_1010_3065)\">\n<path d=\"M149.5 192.138C220.069 192.138 277.276 134.931 277.276 64.362C277.276 -6.20678 220.069 -63.4141 149.5 -63.4141C78.9312 -63.4141 21.7239 -6.20678 21.7239 64.362C21.7239 134.931 78.9312 192.138 149.5 192.138Z\" fill=\"white\"/>\n<path d=\"M149.5 191.941C219.96 191.941 277.079 134.822 277.079 64.362C277.079 -6.09784 219.96 -63.2168 149.5 -63.2168C79.0401 -63.2168 21.9211 -6.09784 21.9211 64.362C21.9211 134.822 79.0401 191.941 149.5 191.941Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.51\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter1_d_1010_3065)\">\n<path d=\"M149.498 169.229C207.415 169.229 254.366 122.278 254.366 64.3617C254.366 6.44522 207.415 -40.5054 149.498 -40.5054C91.5819 -40.5054 44.6313 6.44522 44.6313 64.3617C44.6313 122.278 91.5819 169.229 149.498 169.229Z\" fill=\"white\"/>\n<path d=\"M149.498 169.032C207.306 169.032 254.168 122.169 254.168 64.3617C254.168 6.55416 207.306 -40.3081 149.498 -40.3081C91.6909 -40.3081 44.8286 6.55416 44.8286 64.3617C44.8286 122.169 91.6909 169.032 149.498 169.032Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.6\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter2_d_1010_3065)\">\n<path d=\"M149.5 145.408C194.259 145.408 230.543 109.124 230.543 64.3657C230.543 19.6073 194.259 -16.6765 149.5 -16.6765C104.742 -16.6765 68.4583 19.6073 68.4583 64.3657C68.4583 109.124 104.742 145.408 149.5 145.408Z\" fill=\"white\"/>\n<path d=\"M149.5 145.21C194.149 145.21 230.345 109.014 230.345 64.3652C230.345 19.7161 194.149 -16.4792 149.5 -16.4792C104.851 -16.4792 68.6555 19.7161 68.6555 64.3652C68.6555 109.014 104.851 145.21 149.5 145.21Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.8\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter3_d_1010_3065)\">\n<path d=\"M149.501 121.054C180.809 121.054 206.19 95.6731 206.19 64.3647C206.19 33.0563 180.809 7.67578 149.501 7.67578C118.192 7.67578 92.812 33.0563 92.812 64.3647C92.812 95.6731 118.192 121.054 149.501 121.054Z\" fill=\"white\"/>\n<path d=\"M149.501 120.856C180.7 120.856 205.993 95.5641 205.993 64.3647C205.993 33.1652 180.7 7.87305 149.501 7.87305C118.301 7.87305 93.0093 33.1652 93.0093 64.3647C93.0093 95.5641 118.301 120.856 149.501 120.856Z\" stroke=\"#DDDDDD\" stroke-opacity=\"0.9\" stroke-width=\"0.709379\"/>\n</g>\n<g filter=\"url(#filter4_d_1010_3065)\">\n<path d=\"M149.499 96.1586C167.059 96.1586 181.294 81.9238 181.294 64.3641C181.294 46.8045 167.059 32.5696 149.499 32.5696C131.939 32.5696 117.705 46.8045 117.705 64.3641C117.705 81.9238 131.939 96.1586 149.499 96.1586Z\" fill=\"#FDFDFD\"/>\n<path d=\"M149.499 95.9609C166.949 95.9609 181.096 81.8144 181.096 64.3639C181.096 46.9133 166.949 32.7668 149.499 32.7668C132.048 32.7668 117.902 46.9133 117.902 64.3639C117.902 81.8144 132.048 95.9609 149.499 95.9609Z\" stroke=\"#DDDDDD\" stroke-width=\"0.709379\"/>\n</g>\n</g>\n<mask id=\"mask0_1010_3065\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"133\" y=\"46\" width=\"33\" height=\"37\">\n<path d=\"M165.574 46.0854H133.428V82.6348H165.574V46.0854Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_1010_3065)\">\n<path d=\"M161.582 53.1036C161.553 52.9275 161.406 52.8103 161.259 52.8103C161.112 52.8103 158.529 52.7513 158.529 52.7513C158.529 52.7513 156.356 50.6376 156.151 50.4324C155.946 50.2268 155.505 50.2854 155.358 50.3444C155.358 50.3444 154.947 50.4615 154.272 50.6671C154.155 50.2854 153.978 49.845 153.744 49.3756C152.98 47.9075 151.835 47.1148 150.485 47.1148C150.397 47.1148 150.309 47.1148 150.191 47.1443C150.162 47.0857 150.103 47.0562 150.074 46.9977C149.487 46.3517 148.724 46.058 147.814 46.0875C146.052 46.146 144.291 47.4085 142.882 49.6689C141.883 51.2541 141.12 53.2507 140.885 54.8065C138.86 55.423 137.451 55.8633 137.421 55.8928C136.394 56.2156 136.364 56.2451 136.247 57.2139C136.159 57.9475 133.458 78.6441 133.458 78.6441L155.887 82.5192L165.604 80.1123C165.574 80.0828 161.611 53.2798 161.582 53.1036ZM153.156 51.0194C152.628 51.1661 152.041 51.3717 151.424 51.5478C151.424 50.6671 151.307 49.4046 150.896 48.3478C152.217 48.612 152.863 50.1092 153.156 51.0194ZM150.221 51.9296C149.047 52.2819 147.755 52.6928 146.463 53.0746C146.815 51.6945 147.52 50.3149 148.342 49.4046C148.665 49.0819 149.105 48.7001 149.604 48.4654C150.133 49.4927 150.25 50.9314 150.221 51.9296ZM147.843 47.2619C148.254 47.2619 148.606 47.35 148.9 47.5261C148.43 47.7903 147.96 48.1426 147.52 48.612C146.404 49.8159 145.553 51.6945 145.201 53.4854C144.144 53.8082 143.087 54.1314 142.118 54.4247C142.735 51.6064 145.113 47.35 147.843 47.2619Z\" fill=\"#95BF47\"/>\n<path d=\"M161.26 52.8092C161.113 52.8092 158.529 52.7502 158.529 52.7502C158.529 52.7502 156.357 50.6365 156.151 50.4313C156.063 50.3432 155.975 50.3137 155.858 50.2842V82.489L165.575 80.0816C165.575 80.0816 161.612 53.2786 161.583 53.0734C161.553 52.9263 161.407 52.8092 161.26 52.8092Z\" fill=\"#5E8E3E\"/>\n<path d=\"M150.455 57.8004L149.34 62.0278C149.34 62.0278 148.077 61.4408 146.58 61.5579C144.378 61.705 144.378 63.0846 144.378 63.4369C144.496 65.3159 149.457 65.7268 149.751 70.1598C149.956 73.6531 147.901 76.031 144.936 76.2072C141.354 76.4419 139.388 74.3282 139.388 74.3282L140.151 71.0991C140.151 71.0991 142.118 72.5963 143.703 72.4787C144.731 72.4202 145.112 71.5689 145.083 70.9815C144.936 68.5155 140.885 68.6626 140.621 64.6113C140.415 61.2057 142.646 57.7418 147.578 57.4481C149.486 57.3015 150.455 57.8004 150.455 57.8004Z\" fill=\"white\"/>\n</g>\n</g>\n<defs>\n<filter id=\"filter0_d_1010_3065\" x=\"18.7289\" y=\"-66.409\" width=\"261.542\" height=\"261.542\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"1.41876\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1010_3065\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1010_3065\" result=\"shape\"/>\n</filter>\n<filter id=\"filter1_d_1010_3065\" x=\"40.2176\" y=\"-44.9191\" width=\"218.562\" height=\"218.562\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"2.12814\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1010_3065\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1010_3065\" result=\"shape\"/>\n</filter>\n<filter id=\"filter2_d_1010_3065\" x=\"62.6257\" y=\"-22.509\" width=\"173.749\" height=\"173.749\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"2.83752\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1010_3065\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1010_3065\" result=\"shape\"/>\n</filter>\n<filter id=\"filter3_d_1010_3065\" x=\"85.5607\" y=\"0.424517\" width=\"127.88\" height=\"127.88\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"3.5469\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1010_3065\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1010_3065\" result=\"shape\"/>\n</filter>\n<filter id=\"filter4_d_1010_3065\" x=\"108.325\" y=\"23.1902\" width=\"82.3474\" height=\"82.3474\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"4.61096\"/>\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1010_3065\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1010_3065\" result=\"shape\"/>\n</filter>\n<clipPath id=\"clip0_1010_3065\">\n<rect width=\"299\" height=\"299\" fill=\"white\" transform=\"translate(0 -74)\"/>\n</clipPath>\n</defs>\n</svg>\n";
;// ./src/components/dev-harness/devHarness.css
const devHarness_namespaceObject = "* {\n  box-sizing: border-box;\n  margin: 0;\n}\n\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n.dev-harness {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 999;\n  font-family: \"Gadget-Inconsolata-Private\", sans-serif;\n  font-weight: 500;\n  letter-spacing: 0;\n  font-size: 14px;\n}\n\n.popper-container {\n  width: 100%;\n  height: 32px;\n  font-family: \"Gadget-Inconsolata-Private\", sans-serif;\n}\n\n.footer-content {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: auto;\n  margin: 6px 6px;\n  transition: bottom 0.3s;\n  height: 32px;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid var(--gray-alpha-alpha200, rgba(0, 0, 0, 0.11));\n  background: rgba(255, 255, 255, 0.91);\n  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.04);\n  backdrop-filter: blur(3px);\n}\n\n.footer-content.footer-hidden {\n  bottom: -38px;\n}\n\n.environment-container {\n  display: flex;\n  flex: 1;\n  padding-left: 90px;\n  justify-content: center;\n}\n\n.environment-box {\n  background-color: #a2b9d736;\n  padding: 0 4px;\n}\n\n.environment-name {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.notification-container {\n  position: relative;\n  justify-content: right;\n  right: 4px;\n  gap: 8px;\n}\n\n.notification-message-container {\n  width: 100%;\n  height: 100%;\n  padding-top: 3.5px;\n  padding-bottom: 3.5px;\n  padding-left: 4px;\n  padding-right: 4px;\n  background: white;\n  border-radius: 6px;\n  outline: 1px var(--red-red500, #b13325) solid;\n  outline-offset: -1px;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.slow-load-toast-toggle {\n  outline: 1px solid var(--cyan-cyan500, #3a9bd1);\n}\n.slow-load-toast-toggle:disabled + .notification-message-container {\n  background: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03));\n  outline: 0px;\n  cursor: default;\n}\n.error-toast-toggle:disabled + .notification-message-container {\n  background: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03));\n  outline: 0px;\n  cursor: default;\n}\n\n.ai-assistant-button-container {\n  width: 100%;\n  height: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  display: inline-flex;\n}\n\n.ai-assistant-button {\n  padding: 3px;\n  background: #f6edf0;\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  display: flex;\n  cursor: pointer;\n}\n\n.ai-assistant-toggle {\n  display: none;\n}\n\n.ai-assistant-toggle:checked ~ .ai-assistant-label .ai-assistant-button {\n  background: #f6edf0;\n  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,\n    0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;\n}\n\n.ai-assistant-button:active {\n  background: #f6edf0;\n  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,\n    0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;\n}\n\n.ai-assistant-toggle:not(:checked) + .ai-assistant-container {\n  opacity: 0;\n  visibility: collapse;\n  pointer-events: none;\n}\n\n.notification-text {\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.notification-number {\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  color: var(--red-red500, #b13325);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  word-wrap: break-word;\n  user-select: none;\n}\n\n.error-toast-toggle:disabled + .notification-message-container .notification-number {\n  color: var(--gray-gray400, #afafaf);\n}\n\n.relative-wrapper {\n  position: relative;\n}\n\n.toast-container {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  right: -2px;\n  bottom: 31px;\n  width: 515px;\n  gap: 8px;\n  opacity: 1;\n  transition: opacity 0.3s, visibility 0.3s;\n}\n\n.slow-load-toast-toggle:checked + .notification-message-container:not(.disabled) {\n  background: var(--Secondary-cyan50, #eff8ff);\n\n  /* button/shadow-button-inset */\n  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,\n    0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;\n}\n.error-toast-toggle:checked + .notification-message-container:not(.disabled) {\n  background: var(--Secondary-red50, #fbeceb);\n\n  /* button/shadow-button-inset */\n  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,\n    0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;\n}\n\n.slow-load-toast-toggle:not(:checked) + .notification-message-container:not(.disabled) {\n  background: var(--Neutral-White, #fff);\n}\n.error-toast-toggle:not(:checked) + .notification-message-container:not(.disabled) {\n  background: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03));\n}\n\n.slow-load-toast-toggle:checked + .toast-container {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n.error-toast-toggle:checked + .toast-container {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.slow-load-toast-toggle:not(:checked) + .toast-container {\n  opacity: 0;\n  visibility: collapse;\n  pointer-events: none;\n}\n.error-toast-toggle:not(:checked) + .toast-container {\n  opacity: 0;\n  visibility: collapse;\n  pointer-events: none;\n}\n\n.footer-hidden .toast-container,\n.toast-hidden,\n.assistant-hidden {\n  opacity: 0;\n  visibility: collapse;\n  pointer-events: none;\n}\n\n.toast {\n  border: 1px solid;\n  font-size: 14px;\n  overflow: hidden;\n  box-shadow: 0px 8px 16px -4px #0000003d;\n  position: relative;\n  border-radius: 8px;\n  gap: 12px;\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n}\n\n.toast-header {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.toast-title {\n  font-weight: 700;\n}\n\n.toast-body {\n  font-weight: 400;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.warning .toast-body,\n.error .toast-body {\n  position: relative;\n  padding-left: 24px;\n}\n\na:-webkit-any-link {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.toast-links {\n  border: 1px solid #cbcbcb;\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);\n  padding-left: 12px;\n  padding-right: 12px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  background: var(--neutral-white, white);\n  border-radius: 6px;\n  outline: 1px var(--gray-gray300, #cbcbcb) solid;\n  outline-offset: -1px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  display: flex;\n  font-feature-settings: \"liga\" off, \"clig\" off;\n\n  /* Body */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  text-decoration: none;\n  cursor: pointer;\n  color: #000;\n}\n\n.toast-links:hover {\n  border: 1px solid #afafaf;\n  background: #f6f6f6;\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);\n}\n\n.toast-links:active {\n  transform: translateY(1px);\n  border: 1px solid #e2e2e2;\n  background: #f6f6f6;\n  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,\n    0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;\n}\n\n.toast-link {\n  gap: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.toast-title {\n  flex: 1 1 0;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  word-wrap: break-word;\n}\n\n.toast.error .toast-title {\n  color: var(--red-red500, #b13325);\n}\n\n.toast-fix-error-button {\n  gap: 4px;\n  border-radius: 6px;\n  border: 1px solid #ecb9d0;\n  background: #fff;\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);\n  height: 24px;\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  word-wrap: normal;\n}\n\n.toast-fix-error-button:hover {\n  cursor: pointer;\n  border: 1px solid #e786b2;\n  background: #fbf5f8;\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);\n}\n\n.toast-fix-error-button:active {\n  transform: translateY(1px);\n  border: 1px solid #fbdbe9;\n  background: #fbf5f8;\n  box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,\n    0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;\n}\n\n.toast.warning {\n  background-color: #ffffff;\n  border-color: #dc892a;\n}\n\n.toast.error {\n  background-color: #ffffff;\n  border-color: #b13325;\n}\n\n.toast.slowLoad {\n  background-color: #ffffff;\n  border: 1px solid var(--gray-alpha-alpha300, rgba(0, 0, 0, 0.2));\n}\n\n.info a {\n  gap: 8px;\n}\n\n.toast.info {\n  border-color: #cbcbcb;\n  color: #333333;\n}\n\n.info .link-text a {\n  font-weight: 500;\n  color: #2d53b1;\n}\n\n.button:hover {\n  cursor: pointer;\n  background-color: #00000012;\n}\n\n.popper-button {\n  position: absolute;\n  top: -2px;\n  left: 10px;\n  border: none;\n  padding: 4px;\n  background-color: #ffffff;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  z-index: 1;\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n\n.popper-button:active {\n  box-shadow: 0px 2px 2px 0px #00000029 inset, 1px 0px 1px 0px #00000014 inset, -1px 0px 1px 0px #00000014 inset;\n}\n\n.popper-button.hidden {\n  opacity: 0;\n}\n\n.popper-button.hidden:hover {\n  opacity: 1;\n}\n\n.popper-button.no-pointer {\n  pointer-events: none;\n}\n\n.dismiss-button {\n  position: absolute;\n  padding: 4px;\n  border-radius: 6px;\n  top: -3px;\n  right: -3px;\n  display: flex;\n  border: none;\n  background-color: transparent;\n}\n\n.dismiss-button:active {\n  background: #0000001c;\n}\n\n.cancel-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.chevron-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.15s;\n}\n\n.chevron-icon-up {\n  box-shadow: 0px 8px 16px -4px #0000003d;\n  transform: rotate(0deg);\n}\n\n.rotate {\n  transform: rotate(180deg);\n}\n\n.down-left-arrow-icon {\n  width: 16px;\n  height: 15px;\n}\n\n.error-icon {\n  width: 16px;\n  height: 16px;\n  float: left;\n  color: var(--red-red500, #b13325);\n}\n\n.slow-load-icon {\n  display: flex;\n  align-items: center;\n  color: var(--cyan-cyan500, #3a9bd1);\n}\n.slow-load-toast-toggle:disabled ~ .notification-message-container .slow-load-icon {\n  display: none;\n}\n.error-toast-toggle:disabled ~ .notification-message-container .error-icon {\n  color: var(--gray-gray400, #afafaf);\n}\n\n.slowLoad-icon {\n  width: 16px;\n  height: 16px;\n  float: left;\n}\n\n.info-icon {\n  display: none;\n}\n\n.box {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  height: 20px;\n  border-radius: 4px;\n}\n\n.action-item-box {\n  display: flex;\n  padding: var(--scale-scale300, 8px);\n  align-items: center;\n  align-self: stretch;\n  cursor: pointer;\n  border-radius: var(--radius-radius300, 8px);\n  border: 1px solid var(--gray-alpha-alpha300, rgba(0, 0, 0, 0.2));\n}\n\n.action-item-box input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.action-item-box label {\n  padding-left: 8px;\n  color: #000000;\n  cursor: pointer;\n}\n\n.widget-button {\n  font-family: \"Gadget-Inconsolata-Private\", sans-serif;\n}\n\n.widget-button.secondary {\n  cursor: pointer;\n  color: #000000;\n  border: none;\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16), 0 0 0 1px #cbcbcb inset;\n  background-color: #fff;\n  border-radius: 6px;\n  padding: 6px 12px;\n}\n\n.widget-button.secondary:hover:not(:disabled) {\n  background-color: #f6f6f6;\n}\n\n.widget-button:disabled {\n  background-color: rgba(0, 0, 0, 0.03);\n  box-shadow: none;\n  color: #afafaf;\n  cursor: not-allowed;\n}\n\n.ai-assistant-container {\n  position: absolute;\n  right: -2px;\n  bottom: 31px;\n  width: 515px;\n  background: var(--neutral-white, white);\n  box-shadow: 0px 8px 16px -4px rgba(0, 0, 0, 0.24);\n  overflow: hidden;\n  border-radius: 8px;\n  outline: 2px var(--misc-focus, #4242fc) solid;\n  outline-offset: -2px;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 16px;\n  display: inline-flex;\n  transition: opacity 0.3s, visibility 0.3s;\n  z-index: 1000;\n}\n\n.ai-assistant-inner-container {\n  align-self: stretch;\n  height: 116px;\n  padding: 6px;\n  position: relative;\n  background: var(--misc-input-alpha, rgba(0, 0, 0, 0.01));\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08) inset;\n  border-radius: 6px;\n  outline: 2px var(--misc-focus, #4242fc) solid;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 8px;\n  display: flex;\n}\n\n.ai-assistant-textarea {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  color: #000;\n  font-size: 14px;\n  font-family: Helvetica;\n  font-weight: 400;\n  line-height: 20px;\n  resize: none;\n  padding: 4px;\n  outline: none;\n}\n\n.submit-button-container {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-left: 8px;\n  padding-right: 4px;\n  left: 434px;\n  top: 82px;\n  position: absolute;\n  background: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03));\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  display: inline-flex;\n}\n\n.error-stack-trace-content-box {\n  background: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03));\n  max-height: 300px;\n  padding: 12px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  height: 100%;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 12px;\n  display: inline-flex;\n  overflow: \"hidden\";\n}\n\n.error-stack-trace-content {\n  flex: 1 1 0;\n  align-self: stretch;\n  color: var(--gray-gray600, #545454);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  font-family: var(--inconsolata);\n  overflow: hidden;\n}\n";
;// ./src/components/dev-harness/devHarnessUtils.ts
var DevHarnessState = /*#__PURE__*/ function(DevHarnessState) {
    DevHarnessState["Closed"] = "Closed";
    DevHarnessState["ErrorsOpen"] = "ErrorsOpen";
    DevHarnessState["SpeedNoticeOpen"] = "SpeedNoticeOpen";
    return DevHarnessState;
}({});
const debugLogs = "production" !== "production";
const debug = (...args)=>{
    if (debugLogs) {
        console.debug("[gadget dev harness]", ...args);
    }
};
const DevHarnessStorageKey = "gadget-dev-harness";
const getDevHarnessStorage = ()=>{
    const storage = window?.localStorage?.getItem(DevHarnessStorageKey);
    return storage ? JSON.parse(storage) : {};
};
const updateDevHarnessStorage = (updates)=>{
    const storage = getDevHarnessStorage();
    window?.localStorage?.setItem(DevHarnessStorageKey, JSON.stringify({
        ...storage,
        ...updates
    }));
};
const makeOnDismiss = (config)=>{
    return async ()=>{
        if (!config) {
            return;
        }
        if (config.storageUpdate) {
            updateDevHarnessStorage(config.storageUpdate);
        }
        if (config.beacon) {
            navigator?.sendBeacon(config.beacon.url, config.beacon.data);
        }
        if (config.callback) {
            await config.callback();
        }
    };
};
const GadgetPrivateInconsolataFont = `
/*
* This font (Gadget-Inconsolata-Private) is injected only in development to ensure proper font rendering
* in Gadget's dev harness UI. The font is namespaced to avoid conflicts with your application's fonts
* and is not included in your production build.
*/

/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyxq15IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
    U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyx615IDhunJ_o.woff2) format("woff2");
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
    U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Gadget-Inconsolata-Private";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inconsolata/v32/QlddNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLyya15IDhunA.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
`;
const getAiFixErrorButton = (fix)=>{
    let onclick;
    if (fix.type == "fix-prompt") {
        onclick = `sendErrorPrompt(${JSON.stringify(fix.prompt)})`;
    } else if (fix.type == "fix-link") {
        onclick = `window.open(${JSON.stringify(fix.linkHref)}, "_top")`;
    } else {
        throw new Error(`Unknown fix action type: ${fix.type}`);
    }
    const aiFixErrorButton = /* html */ `
    <gadget-sparkle-button size="small" onclick="${onclick.replaceAll('"', "&quot;")}">
      Fix
    </gadget-sparkle-button>`;
    return aiFixErrorButton;
};
const cursorKey = `${DevHarnessStorageKey}:event-cursor`;
const getCurrentHarnessEventCursor = ()=>{
    let storedValue = null;
    try {
        storedValue = localStorage.getItem(cursorKey);
    } catch (_error) {
    // localStorage not available in incognito mode in Shopify iframes -- suppress error
    }
    // parse the stored value as a redis stream key, and if it isn't from too long ago, return it
    if (storedValue) {
        const [timestamp, id] = storedValue.split("-");
        if (timestamp) {
            const timeAgo = new Date().getTime() - parseInt(timestamp);
            if (timeAgo < 30 * 1000) {
                return storedValue;
            }
        }
    }
    // if the stored value is not a valid redis stream key, or is too old, return null
    return null;
};
const setCurrentHarnessEventCursor = (cursor)=>{
    try {
        localStorage.setItem(cursorKey, cursor);
    } catch (_error) {
    // localStorage not available in incognito mode in Shopify iframes -- suppress error
    }
};

;// ./src/components/dev-harness/SparkleButton.ts

class SparkleButton extends HTMLElement {
    shadow;
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
    }
    static get observedAttributes() {
        return [
            "size"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "size") {
            this.render();
        }
    }
    render() {
        const size = this.getAttribute("size");
        const verticalPadding = size === "small" ? "2px" : "6px";
        const styles = `
      .sparkle-button {
        gap: 4px;
        border-radius: 6px;
        border: 1px solid #ecb9d0;
        background: #fff;
        box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);
        height: 24px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: ${verticalPadding};
        padding-bottom: ${verticalPadding};
        border-radius: 6px;
        justify-content: center;
        align-items: center;
        display: flex;
        word-wrap: normal;
        cursor: pointer;
      }

      .sparkle-button:hover {
        border: 1px solid #e786b2;
        background: #fbf5f8;
        box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16);
      }

      .sparkle-button:active {
        transform: translateY(1px);
        border: 1px solid #fbdbe9;
        background: #fbf5f8;
        box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset,
          0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset;
      }

      .sparkle-icon {
        width: 16px;
        height: 16px;
        position: relative;
        overflow: hidden;
      }

      .button-text {
        color: #9B2E84;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        user-select: none;
      }
    `;
        this.shadow.innerHTML = `
      <style>${styles}</style>
      <div class="sparkle-button">
        <div class="sparkle-icon">${SparkleIcon_namespaceObject}</div>
        <div class="button-text">
          <slot></slot>
        </div>
      </div>
    `;
    }
}

;// ./src/lib/gadgetIframeNavigation.ts
const GadgetNavigateEvent = "gadget:navigate";
const GadgetNavigatedEvent = "gadget:navigated";
const GadgetNavigateParentFrameEvent = "gadget:outernavigate";
const GadgetForwardMessageEvent = "gadget:forwardMessage";
const GadgetForwardKeyPressEvent = "gadget:forwardKeyPress";
const GadgetPromptMessageEvent = "gadget:prompt";
const GadgetHMRConnectionCheckRequestEvent = "gadget:hmrConnectionCheckRequest";
const GadgetHMRConnectionCheckResponseEvent = "gadget:hmrConnectionCheckResponse";
const GadgetErrorOverlayShownEvent = "gadget:error-overlay-shown";
function isGadgetNavigatePostMessageCommand(message) {
    return message && typeof message === "object" && message.type === GadgetNavigateEvent;
}
function navigateGadgetParentFrame(destination) {
    if (typeof window !== "undefined" && window.parent) {
        window.parent.postMessage({
            type: GadgetNavigateParentFrameEvent,
            destination
        }, "*");
    }
}
const mountGadgetIframeNavigation = (getConfig)=>{
    window.navigateGadgetParentFrame = navigateGadgetParentFrame;
    // set up a history index for the outer editor to track the current history index
    console.debug("[gadget iframe] setting up history index");
    window.history.replaceState({
        gadgetIdx: 0,
        gadgetHistoryLength: 0,
        ...window.history.state ?? {}
    }, "");
    let gadgetHistoryLength = window.history.state.gadgetHistoryLength;
    console.debug("[gadget iframe] current gadgetHistoryLength", gadgetHistoryLength);
    const sendNavigationState = ()=>{
        const eventData = {
            type: GadgetNavigatedEvent,
            url: window.location.href,
            canGoBack: window.history.state.gadgetIdx > 0,
            canGoForward: window.history.state.gadgetIdx < window.history.state.gadgetHistoryLength
        };
        console.debug("[gadget iframe] sending navigation state", {
            eventData,
            gadgetIdx: window.history.state.gadgetIdx,
            gadgetHistoryLength: window.history.state.gadgetHistoryLength
        });
        window.parent.postMessage(eventData, "*");
    };
    // Send initial navigation state
    sendNavigationState();
    const originalPushState = window.history.pushState;
    window.history.pushState = function(...args) {
        gadgetHistoryLength++;
        if (args[0]) {
            args[0].gadgetIdx = gadgetHistoryLength;
            args[0].gadgetHistoryLength = gadgetHistoryLength;
        } else {
            args[0] = {
                gadgetIdx: gadgetHistoryLength,
                gadgetHistoryLength: gadgetHistoryLength
            };
        }
        console.debug("[gadget iframe] pushstate event", args);
        originalPushState.apply(this, args);
        sendNavigationState();
    };
    const handleNavigationEvent = (event1)=>{
        if (!event1.data || typeof event1.data !== "object") return;
        if (!isGadgetNavigatePostMessageCommand(event1.data)) return;
        console.debug("[gadget iframe] navigation event", event1);
        switch(event1.data.action){
            case "back":
                window.history.back();
                break;
            case "forward":
                window.history.forward();
                break;
            case "refresh":
                window.location.reload();
                break;
            case "navigate":
                window.location.href = event1.data.path;
                break;
            case "pushState":
                window.history.pushState(event1.data.state, "", event1.data.path);
                break;
        }
    };
    window.addEventListener("message", handleNavigationEvent);
    const handlePopState = ()=>{
        console.debug("[gadget iframe] popstate event", event);
        window.history.replaceState({
            ...window.history.state ?? {},
            gadgetHistoryLength: gadgetHistoryLength
        }, "");
        sendNavigationState();
    };
    window.addEventListener("popstate", handlePopState);
    // Hijack links to the app that open in a new tab when we're in embedded preview and propagate to the parent to navigate
    const handleClick = (event1)=>{
        const link = event1.target?.closest("a");
        const targetUrl = link ? new URL(link.href) : null;
        const config = getConfig();
        console.debug("[gadget iframe] handleClick", {
            config,
            targetUrl
        });
        // Only hijack if the link is to the app
        if (!config || targetUrl?.hostname !== window.location.hostname || !targetUrl?.pathname.includes(`/edit/`)) return;
        // Don't hijack if we're within the Shopify admin iframe
        const shopify = window.shopify;
        if (shopify && !shopify.isGadget) return;
        event1.preventDefault();
        event1.stopPropagation();
        const redirectHost = targetUrl.hostname.replace(`--${config.environmentName}`, "");
        let redirectPath;
        if (targetUrl.pathname.startsWith(`/edit/${config.environmentName}`)) {
            redirectPath = targetUrl.pathname;
        } else if (targetUrl.pathname.startsWith(`/edit`)) {
            redirectPath = `/edit/${config.environmentName}${targetUrl.pathname.replace(`/edit`, "")}`;
        } else {
            redirectPath = targetUrl.pathname;
        }
        let url = `${targetUrl.protocol}//${redirectHost}${redirectPath}`;
        if (targetUrl.search) {
            url += `?${targetUrl.search}`;
        }
        console.debug("[gadget iframe] navigating is outer frame", {
            url
        });
        window.parent.postMessage({
            type: "gadget:outernavigate",
            destination: url
        }, "*");
    };
    window.addEventListener("click", handleClick);
    const handleKeyPress = (event1)=>{
        // Super special case, because chrome's shortcut for print is meta+p, and we want to use that to open the command modal
        if (event1.key === "p" && event1.metaKey) {
            event1.preventDefault();
        }
        window.parent.postMessage({
            type: GadgetForwardKeyPressEvent,
            keyEventType: event1.type,
            key: event1.key,
            shiftKey: event1.shiftKey,
            metaKey: event1.metaKey
        }, "*");
    };
    // disable print because it conflicts with the editor's command palette (meta+p)
    window.print = ()=>{
        console.warn("print is disabled in the editor's previewer");
    };
    // Register the key event listeners so that they're triggered after every other listener
    setTimeout(()=>{
        window.addEventListener("keydown", handleKeyPress);
        window.addEventListener("keyup", handleKeyPress);
    }, 0);
    return ()=>{
        window.removeEventListener("message", handleNavigationEvent);
        window.removeEventListener("popstate", handlePopState);
        window.removeEventListener("click", handleClick);
        window.removeEventListener("keydown", handleKeyPress);
        window.removeEventListener("keyup", handleKeyPress);
        window.navigateGadgetParentFrame = undefined;
        window.history.pushState = originalPushState;
    };
};

;// ./src/devHarness.ts

















debug("loading gadget dev harness");
const ShadowRootId = "gadget-dev-harness";
const SlowLoadThreshold = 10000;
const inIFrame = typeof window !== "undefined" && window.self !== window.top;
function sendErrorPrompt(errorMessage) {
    debug("sending fix error post message", {
        errorMessage
    });
    if (devHarness?.isInGadgetIFrame) {
        window.parent.postMessage({
            type: GadgetPromptMessageEvent,
            prompt: errorMessage
        }, "*");
    } else {
        fetch(window.location.origin + "/api/zprompt", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                prompt: errorMessage
            })
        }).then((response)=>response.json()).then((payload)=>{
            window.open(window.location.origin + "/edit?promptId=" + encodeURIComponent(payload.id), "_top");
        }).catch((error)=>{
            console.error("[Gadget-Error-Overlay] Error sending prompt:", error);
        });
    }
}
/**
 * Proxy object for the Vite HMR connection. Note that this can be undefined if the Vite HMR client is not available in the Vite frontend.
 */ const maybeGetViteHMRConnectionObject = ()=>{
    if (typeof window !== "undefined" && window.__gadget_vite_hmr_connection) {
        return window.__gadget_vite_hmr_connection;
    }
    return undefined;
};
const isViteHMRConnectionReady = ()=>{
    const hmrObject = maybeGetViteHMRConnectionObject();
    try {
        if (hmrObject?.hmrClient?.messenger?.connection?.isReady()) {
            return true;
        }
        return false;
    } catch (error) {
        debug("error checking if the vite hmr connection is ready", error);
        return false;
    }
};
class GadgetDevHarness extends HTMLElement {
    root;
    footerVisible = false;
    toasterVisible = DevHarnessState.Closed;
    messages = [];
    environmentSlug = "development";
    appName = "my-shopify-app";
    editorAssistantFlagEnabled = false;
    shouldAddHtml = true;
    isInGadgetIFrame = false;
    static async createGadgetDevHarness() {
        const devHarness = new GadgetDevHarness();
        devHarness.isInGadgetIFrame = await checkIfInGadgetIFrame();
        if (!devHarness.isInGadgetIFrame) {
            devHarness.nonGadgetRoutePreviewSetup();
        }
        return devHarness;
    }
    constructor(){
        super();
        this.root = this.attachShadow({
            mode: "open"
        });
        if (typeof window !== "undefined" && window.gadgetConfig) {
            this.environmentSlug = window.gadgetConfig.env?.GADGET_ENV;
            this.appName = window.gadgetConfig.env?.GADGET_APP;
            this.editorAssistantFlagEnabled = window.gadgetConfig.env?.GADGET_FLAG_ASSISTANT_ENABLED === "true";
        } else {
            if (typeof process !== "undefined") {
                if (process.env.GADGET_ENV) {
                    this.environmentSlug = process.env.GADGET_ENV;
                }
                if (process.env.GADGET_APP) {
                    this.appName = process.env.GADGET_APP;
                }
                if (process.env.GADGET_FLAG_ASSISTANT_ENABLED) {
                    this.editorAssistantFlagEnabled = process.env.GADGET_FLAG_ASSISTANT_ENABLED === "true";
                }
            } else {
                this.shouldAddHtml = false;
            }
        }
        const isIFramed = window.self !== window.top;
        const isInShopify = !!window.shopify;
        const isInGadgetShopifyPreviewer = window.shopify?.isGadget ?? false;
        const renderEditorAssistant = this.editorAssistantFlagEnabled && (isInShopify && !isInGadgetShopifyPreviewer || !isIFramed);
        debug("devharness constructed", {
            editorAssistantEnabled: this.editorAssistantFlagEnabled,
            config: window.gadgetConfig,
            origin: window.origin,
            location: window.location,
            isIFramed,
            isInShopify,
            isInGadgetShopifyPreviewer,
            renderEditorAssistant
        });
    }
    nonGadgetRoutePreviewSetup() {
        const isIFramed = window.self !== window.top;
        const isInShopify = !!window.shopify;
        const isInGadgetShopifyPreviewer = window.shopify?.isGadget ?? false;
        const renderEditorAssistant = this.editorAssistantFlagEnabled && (isInShopify && !isInGadgetShopifyPreviewer || !isIFramed);
        const errorMessages = this.messages.filter(([_, message])=>message.type === "error");
        this.root.innerHTML = !this.shouldAddHtml ? "" : /* html */ `
      <style>
        ${devHarness_namespaceObject}
      </style>
      <div class="dev-harness">
        <div class="relative-wrapper">
          <div class="popper-container" id="popper-div">
            <button class="button popper-button" id="popper-button">
              <div class="chevron-icon chevron" id="chevron-icon-div">${ChevronUpIcon_namespaceObject}</div>
            </button>
          </div>
          <div class="footer-content footer-hidden" id="footer-content-div">
            <div class="environment-container">
              <div class="box environment-box">
                <div class="down-left-arrow-icon">${DownLeftArrowIcon_namespaceObject}</div>
                <div class="environment-name">${this.environmentSlug}</div>
              </div>
            </div>
            <div class="box notification-container">
              <input style="display: none;" type="checkbox" id="slow-load-toast-toggle" class="slow-load-toast-toggle" disabled>
              <label for="slow-load-toast-toggle" class="notification-message-container slow-load-toast-toggle">
                <div class="slow-load-icon">${SpeedometerIcon_namespaceObject}</div>
              </label>
              <input style="display: none;" type="checkbox" id="error-toast-toggle" class="error-toast-toggle" disabled>
              <label for="error-toast-toggle" class="notification-message-container">
                <div class="notification-number-icon">
                  <div class="error-icon">${ErrorCircleIcon_namespaceObject}</div>
                </div>
                <div class="notification-number">${errorMessages.length}</div>
              </label>
              <div class="toast-container" id="toast-container-div"></div>
              ${renderEditorAssistant ? /*html*/ `<div style="width: 2px; height: 12px; border-left: 1px solid rgba(0, 0, 0, 0.2)"></div>` : ""}

              ${renderEditorAssistant ? /*html*/ `<div class="ai-assistant-button-container">
                <input type="checkbox" id="ai-assistant-toggle" class="ai-assistant-toggle">
                <div class="ai-assistant-container" id="ai-assistant-container">
                  <div class="ai-assistant-inner-container">
                      <textarea
                          placeholder="Ask anything..."
                          class="ai-assistant-textarea"
                          id="ai-assistant-textarea"
                      ></textarea>
                      <div style="cursor: pointer;" class="submit-button-container" id="ai-assistant-submit-button">
                          <div style="color: var(--gray-alpha-alpha600, rgba(0, 0, 0, 0.67)); font-size: 14px; font-family: Helvetica; font-weight: 400; line-height: 20px; word-wrap: break-word">Submit</div>
                          <div style="justify-content: flex-start; align-items: center; gap: 2px; display: flex">
                              <div style="width: 16px; height: 16px; background: var(--gray-alpha-alpha100, rgba(0, 0, 0, 0.07)); box-shadow: 0px -0.800000011920929px 0px rgba(0, 0, 0, 0.14) inset; border-radius: 4px; justify-content: center; align-items: center; display: flex">
                                    ${ReturnKeyCommandIcon_namespaceObject}
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
                  <label for="ai-assistant-toggle" class="ai-assistant-label">
                    <div class="ai-assistant-button" id="ai-assistant-button">
                      <div style="width: 16px; height: 16px; position: relative; overflow: hidden">${SparkleIcon_namespaceObject}</div>
                    </div>
                  </label>
              </div>` : ""}
            </div>
          </div>
        </div>
      </div>
    `;
        const popperButton = this.root.querySelector("#popper-button");
        const assistantTextarea = this.root.querySelector("#ai-assistant-textarea");
        const assistantToggle = this.root.querySelector("#ai-assistant-toggle");
        const assistantSubmitButton = this.root.querySelector("#ai-assistant-submit-button");
        if (assistantToggle) {
            window.addEventListener("keydown", (event)=>{
                if (event instanceof KeyboardEvent && event.key === "Escape") {
                    this.changeAssistantVisibility(false);
                }
            });
            window.addEventListener("click", (event)=>{
                const isClickInDevHarness = event.target && "closest" in event.target && event.target?.closest("gadget-dev-harness") !== null;
                if (!isClickInDevHarness) {
                    this.changeAssistantVisibility(false);
                    updateDevHarnessStorage({
                        dismissedAssistant: true
                    });
                }
            });
            assistantToggle.addEventListener("click", (event)=>{
                const checkbox = event.target;
                this.refreshToasts(DevHarnessState.Closed);
                if (!checkbox.checked) {
                    updateDevHarnessStorage({
                        dismissedAssistant: true
                    });
                }
            });
        }
        if (assistantTextarea) {
            const handleSubmitAssistantPrompt = ()=>{
                const textArea = assistantTextarea;
                if (textArea.value.trim() === "") return;
                this.changeAssistantVisibility(false);
                window.open(window.location.origin + `/edit/${this.environmentSlug}/preview?prompt=` + encodeURIComponent(textArea.value), "_top");
                textArea.value = "";
            };
            assistantTextarea.addEventListener("keydown", (event)=>{
                if (event instanceof KeyboardEvent && event.key === "Enter" && !event.shiftKey) {
                    event.preventDefault();
                    handleSubmitAssistantPrompt();
                }
            });
            if (assistantSubmitButton) {
                assistantSubmitButton.addEventListener("click", ()=>{
                    handleSubmitAssistantPrompt();
                });
            }
        }
        if (popperButton) {
            popperButton.addEventListener("click", ()=>{
                this.changeAssistantVisibility(false);
                this.changeFooterVisibility(!this.footerVisible);
                if (!this.footerVisible) {
                    popperButton.classList.add("no-pointer");
                    setTimeout(()=>{
                        if (popperButton.matches(":hover")) {
                            popperButton.classList.remove("no-pointer");
                        } else {
                            popperButton.classList.remove("no-pointer");
                        }
                    }, 300);
                }
            });
        }
        if (window.pendingGadgetDevHarnessMessages) {
            for (const message of window.pendingGadgetDevHarnessMessages){
                this.addMessage(message);
            }
            window.pendingGadgetDevHarnessMessages = [];
        }
        if (this.messages.filter(([_, message])=>message.type !== "slowLoad").length === 0 && !getDevHarnessStorage().dismissedAssistant) {
            this.changeFooterVisibility(true);
        }
        const slowLoadLabel = this.root.querySelector('label[for="slow-load-toast-toggle"]');
        if (slowLoadLabel) {
            slowLoadLabel.addEventListener("click", ()=>{
                const slowLoadToggle = this.root.querySelector("#slow-load-toast-toggle");
                if (slowLoadToggle && slowLoadToggle.disabled) {
                    return;
                }
                if (this.toasterVisible === DevHarnessState.SpeedNoticeOpen) {
                    this.refreshToasts(DevHarnessState.Closed); // If currently showing slow load messages, close
                } else {
                    this.refreshToasts(DevHarnessState.SpeedNoticeOpen);
                }
            });
        }
        const errorLabel = this.root.querySelector('label[for="error-toast-toggle"]');
        if (errorLabel) {
            errorLabel.addEventListener("click", ()=>{
                const errorToggle = this.root.querySelector("#error-toast-toggle");
                if (errorToggle && errorToggle.disabled) {
                    return;
                }
                if (this.toasterVisible === DevHarnessState.ErrorsOpen) {
                    this.refreshToasts(DevHarnessState.Closed); // If currently showing error messages, close
                } else {
                    // Otherwise, show error messages
                    this.refreshToasts(DevHarnessState.ErrorsOpen);
                }
            });
        }
    }
    get assistantVisible() {
        const assistant = this.root.querySelector("#ai-assistant-container");
        const toggle = this.root.querySelector("#ai-assistant-toggle");
        if (assistant && toggle) {
            return toggle.checked;
        }
        return false;
    }
    addMessage(message) {
        const key = `${message.type}-${nanoid()}`;
        if (this.messages.filter(([k, _])=>k.startsWith(message.type)).length >= message.maxMessages) {
            const firstMatchingType = this.messages.find(([k, _])=>k.startsWith(message.type));
            this.messages = this.messages.filter(([k, _])=>k !== firstMatchingType[0]);
        }
        const dismissMessage = async ()=>{
            this.messages = this.messages.filter(([k, _])=>k !== key);
            if (message.onDismissConfig) {
                await makeOnDismiss(message.onDismissConfig)();
            }
            this.refreshToasts();
        };
        this.messages.push([
            key,
            {
                ...message,
                onDismissConfig: {
                    callback: dismissMessage
                }
            }
        ]);
        this.changeFooterVisibility(true);
        if (this.isInGadgetIFrame) {
            const messageToForward = {
                ...message
            };
            delete messageToForward.onDismissConfig?.callback; // Omit the callback because it cannot be serialized in a postMessage
            window.parent.postMessage({
                type: GadgetForwardMessageEvent,
                message: messageToForward
            }, "*");
        } else {
            if (message.type === "slowLoad" && this.toasterVisible === DevHarnessState.Closed) {
                this.refreshToasts(DevHarnessState.SpeedNoticeOpen);
            } else {
                this.refreshToasts(DevHarnessState.ErrorsOpen);
            }
        }
    }
    refreshToasts(newVisibility) {
        const toaster = this.root.querySelector("#toast-container-div");
        const errorToastToggle = this.root.querySelector("#error-toast-toggle");
        const slowLoadToastToggle = this.root.querySelector("#slow-load-toast-toggle");
        if (!toaster || !errorToastToggle || !slowLoadToastToggle) return;
        toaster.replaceChildren();
        const slowLoadMessages = this.messages.filter(([_, message])=>message.type === "slowLoad");
        const errorMessages = this.messages.filter(([_, message])=>message.type === "error");
        this.toasterVisible = newVisibility ?? (errorMessages.length > 0 ? DevHarnessState.ErrorsOpen : slowLoadMessages.length > 0 ? DevHarnessState.SpeedNoticeOpen : DevHarnessState.Closed);
        const visibleMessages = this.toasterVisible === DevHarnessState.SpeedNoticeOpen ? slowLoadMessages : this.toasterVisible === DevHarnessState.ErrorsOpen ? errorMessages : [];
        // Update error count
        const errorLabel = this.root.querySelector('label[for="error-toast-toggle"]');
        if (errorLabel) {
            const errorCount = errorLabel.querySelector(".notification-number");
            if (errorCount) {
                errorCount.textContent = String(errorMessages.length);
            }
        }
        if (newVisibility !== DevHarnessState.Closed) {
            // auto close assistant to get show the toast messages
            this.changeAssistantVisibility(false);
        }
        requestAnimationFrame(()=>{
            // Update toggle states
            if (this.messages.length > 0) {
                switch(this.toasterVisible){
                    case DevHarnessState.ErrorsOpen:
                        errorToastToggle.checked = true;
                        slowLoadToastToggle.checked = false;
                        break;
                    case DevHarnessState.SpeedNoticeOpen:
                        errorToastToggle.checked = false;
                        slowLoadToastToggle.checked = true;
                        break;
                    default:
                        errorToastToggle.checked = false;
                        slowLoadToastToggle.checked = false;
                        break;
                }
                errorToastToggle.disabled = errorMessages.length === 0;
                slowLoadToastToggle.disabled = slowLoadMessages.length === 0;
            } else {
                errorToastToggle.checked = false;
                errorToastToggle.disabled = true;
                slowLoadToastToggle.checked = false;
                slowLoadToastToggle.disabled = true;
            }
        });
        // Render visible messages
        for (const [key, message] of visibleMessages){
            let icon = undefined;
            if (message.type == "warning") {
            // icon = WarningTriangleIcon;
            // Unused for now.
            } else if (message.type == "error") {
                icon = ErrorCircleIcon_namespaceObject;
            } else if (message.type == "slowLoad") {
                icon = SpeedometerIcon_namespaceObject;
            }
            const toast = document.createElement("div");
            toast.classList.add("toast", `${message.type}`);
            toast.dataset["testid"] = `dev-harness-toast-${message.type}`;
            if (message.style) {
                for (const [key, value] of Object.entries(message.style)){
                    toast.style[key] = value;
                }
            }
            const links = [];
            for (const link of message.links){
                if (inIFrame && window.navigateGadgetParentFrame) {
                    // if we're iframed into the editor, push the navigation to the outer editor to fulfill
                    links.push(`<a class="toast-link" onclick='event.preventDefault(); navigateGadgetParentFrame(${JSON.stringify(link.href)});'>${link.linkText}${OpenInNewTabIcon_namespaceObject}</a>`);
                } else {
                    links.push(`<a class="toast-link" href="${link.href}" target="_blank" rel="noopener">${link.linkText}${OpenInNewTabIcon_namespaceObject}</a>`);
                }
            }
            const aiFixErrorButton = this.editorAssistantFlagEnabled && message.fixAction ? getAiFixErrorButton(message.fixAction) : "";
            toast.innerHTML += /*html*/ `
        <div style="align-self: stretch; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 10px; display: flex;">
            <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
                <div style="padding-top: 2px; padding-bottom: 2px; justify-content: flex-start; align-items: center; gap: 10px; display: flex">
                ${icon ? `<div class="${message.type}-icon">${icon}</div>` : ""}
                </div>
                <div class="toast-title">
                  ${message.title}
                </div>
            </div>
            <button id="${key}-dismiss-button" class="button dismiss-button">
                <div class="cancel-icon">${ActionCloseIcon_namespaceObject}</div>
            </div>
        </div>
        <div style="align-self: stretch">
          ${message.stack ? /*html*/ `
              <div class="error-stack-trace-content-box">
                <div class="error-stack-trace-content">${message.stack}</div>
                ${aiFixErrorButton}
              </div>
            ` : ""}

          ${message.body ? /*html*/ `
              <div style="background-color: var(--gray-alpha-alpha50, rgba(0, 0, 0, 0.03)); align-self: stretch; padding: 12px; border-radius: 8px; flex-direction: row; display: flex; gap: 16px; ${message.stack ? "margin-top: 8px;" : ""}">
                <span style="color: black; font-size: 14px; font-weight: 500; line-height: 20px; word-break: break-word; margin-right: auto">
                  ${message.body}
                </span>
                ${aiFixErrorButton}
              </div>
            ` : ""}

          ${message.actions ? `
            <form action="javascript:void(0);" id="${key}-dev-harness-action-form">
            ${message.actions?.map((action)=>`
                <div class="action-item-box">
                  <input type="${action.input.type}" id="${key}-${action.input.uniqueId}" name="${action.input.name}" value="${action.input.defaultValue}" ${action.input.required ? "required" : ""}>
                  <label for="${key}-${action.input.uniqueId}">${action.text}</label>
                </div>`).join("")}
              <button type="submit" style="margin-top: 12px;" id="${key}-dev-harness-action-button" class="widget-button secondary">Confirm</button>
            </form>
            ` : ""}
        </div>
        ${message.links.length ? /* html */ `
        <div style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 12px; display: flex">
          <div style="justify-content: center; align-items: center; gap: 12px; display: inline-flex">
            ${message.links.length > 0 ? links.map((link)=>`<div class="toast-links">${link}</div>`) : ""}
          </div>
        </div>
        ` : ""}
      `;
            toaster.appendChild(toast);
            const dismissButton = this.root.querySelector(`#${key}-dismiss-button`);
            const actionButton = this.root.querySelector(`#${key}-dev-harness-action-button`);
            const actionForm = this.root.querySelector(`#${key}-dev-harness-action-form`);
            const formInputs = actionForm?.querySelectorAll("input");
            // Disable the action submit button until the form is valid
            const checkFormValidity = ()=>{
                if (actionButton && formInputs) {
                    const allInputsValid = Array.from(formInputs).every((input)=>input.checkValidity());
                    actionButton.disabled = !allInputsValid;
                }
            };
            // Validate the form when the user starts typing
            formInputs?.forEach((input)=>{
                input.addEventListener("input", checkFormValidity);
            });
            // Initial check
            checkFormValidity();
            if (dismissButton) {
                dismissButton.addEventListener("click", ()=>{
                    const maybePromise = message.onDismissConfig?.callback?.();
                    if (maybePromise) {
                        maybePromise.catch((error)=>debug({
                                error,
                                key
                            }, `onDismiss error`));
                    }
                });
            }
            if (actionButton && actionForm) {
                actionButton.addEventListener("click", ()=>{
                    actionButton.disabled = true;
                    const formData = new FormData(actionForm);
                    const payload = {};
                    for (const [key, value] of formData.entries()){
                        if (typeof value === "string") {
                            payload[key] = JSON.parse(decodeURI(value));
                        } else {
                            payload[key] = value;
                        }
                    }
                    debug("executing action", {
                        payload
                    });
                    // Run the action by loading the editor page to make sure the person who pressed the button has the permissions to modify the app
                    window.location.href = `/edit/api/dev-harness-action/execute?payload=${encodeURIComponent(JSON.stringify(payload))}&from=${encodeURIComponent(window.location.href)}`;
                });
            }
        }
    }
    changeAssistantVisibility(newVisibility) {
        const assistant = this.root.querySelector("#ai-assistant-container");
        const toggle = this.root.querySelector("#ai-assistant-toggle");
        if (toggle?.checked === newVisibility) return;
        if (assistant && toggle) {
            requestAnimationFrame(()=>{
                toggle.checked = newVisibility;
            });
        }
    }
    changeFooterVisibility(newVisibility) {
        if (this.footerVisible == newVisibility) return;
        const footer = this.root.querySelector("#footer-content-div");
        const popperButton = this.root.querySelector("#popper-button");
        const chevron = this.root.querySelector("#chevron-icon-div");
        const toaster = this.root.querySelector("#toast-container-div");
        this.footerVisible = newVisibility;
        requestAnimationFrame(()=>{
            if (footer && popperButton && chevron && toaster) {
                if (this.footerVisible) {
                    footer.classList.remove("footer-hidden");
                    popperButton.classList.remove("chevron-icon-up", "hidden");
                    chevron.classList.add("rotate");
                } else {
                    footer.classList.add("footer-hidden");
                    popperButton.classList.add("chevron-icon-up");
                    chevron.classList.remove("rotate");
                }
            }
        });
    }
}
const { customElements } = globalThis;
if (customElements && !customElements.get(ShadowRootId)) {
    customElements.define(ShadowRootId, GadgetDevHarness);
    customElements.define("gadget-sparkle-button", SparkleButton);
}
let devHarness = null;
let devHarnessPromise = null;
const appendDevHarness = async ()=>{
    if (devHarness) return;
    if (document?.head) {
        const styleElement = document.createElement("style");
        styleElement.textContent = GadgetPrivateInconsolataFont;
        document.head.appendChild(styleElement);
    }
    if (document?.body) {
        devHarness = await GadgetDevHarness.createGadgetDevHarness();
        document.body.appendChild(devHarness);
    }
};
const getDevHarness = async ()=>{
    if (devHarness) {
        return devHarness;
    }
    if (!devHarnessPromise) {
        devHarnessPromise = (async ()=>{
            await new Promise((resolve)=>setTimeout(resolve, 100));
            await appendDevHarness();
            return devHarness;
        })();
    }
    return await devHarnessPromise;
};
if (typeof window != "undefined" && window.self?.addEventListener) {
    window.sendErrorPrompt = sendErrorPrompt;
    void getDevHarness();
    window.addEventListener("error", (event)=>{
        if (event.error?.message?.includes("Could not find a client in the context of Provider")) {
            fetch("/api/error-report", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    url: window.location.href,
                    error: event.error?.message,
                    stack: event.error?.stack
                })
            }).catch(()=>{
            // ignore, but here to avoid an uncaught promise rejection
            });
        }
    });
    const showSlowLoadMessageTimeout = setTimeout(()=>{
        void (async ()=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const storage = getDevHarnessStorage();
            if (storage.slowLoadMessageDismissed) return;
            const slowMessage = {
                type: "slowLoad",
                id: nanoid(),
                maxMessages: 1,
                title: "Slow load in development environment",
                body: "Load times may be slow in this environment. Expect faster speeds for your production app.",
                links: [
                    {
                        href: "https://docs.gadget.dev/guides/frontend#frontend-troubleshooting",
                        linkText: "Learn more"
                    }
                ],
                onDismissConfig: {
                    storageUpdate: {
                        slowLoadMessageDismissed: true
                    },
                    beacon: {
                        url: "/api/dev-harness/track",
                        data: JSON.stringify({
                            event: "Slow Load Message Dismissed"
                        })
                    }
                }
            };
            devHarness.addMessage(slowMessage);
            navigator?.sendBeacon("/api/dev-harness/track", JSON.stringify({
                event: "Slow Load Message Shown"
            }));
        })();
    }, SlowLoadThreshold);
    const onLoad = ()=>{
        clearTimeout(showSlowLoadMessageTimeout);
        void getDevHarness();
    };
    if (document.readyState === "complete" || document.readyState === "interactive") {
        onLoad();
    } else {
        document.addEventListener("DOMContentLoaded", onLoad);
    }
    window.addEventListener("message", (event)=>{
        if (event.data?.type === GadgetHMRConnectionCheckRequestEvent) {
            window.parent.postMessage({
                type: GadgetHMRConnectionCheckResponseEvent,
                message: {
                    isViteHMRConnectionReady: isViteHMRConnectionReady()
                }
            }, "*");
        }
    });
    window.addEventListener("error", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const errorMessage = typeof event.error === "string" ? event.error : event.error?.message ?? String(event.error);
            if (!shouldShowDeveloperError(errorMessage)) return;
            const message = {
                id: nanoid(),
                title: event.message,
                stack: event.error?.stack,
                type: "error",
                maxMessages: 1,
                fixAction: {
                    type: "fix-prompt",
                    prompt: `Can you fix the following error?\n\n${errorMessage}\n\n${event.error?.stack}`
                },
                links: []
            };
            devHarness.addMessage(message);
        })(event);
    });
    window.addEventListener("unhandledrejection", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const errorMessage = event.reason?.message || String(event.reason);
            if (!shouldShowDeveloperError(errorMessage)) return;
            const message = {
                id: nanoid(),
                title: `Unhandled promise rejection: ${errorMessage}`,
                stack: event.reason?.stack,
                type: "error",
                maxMessages: 1,
                fixAction: {
                    type: "fix-prompt",
                    prompt: `Can you fix the following error?\n\n${errorMessage}\n\n${event.reason?.stack}`
                },
                links: []
            };
            devHarness.addMessage(message);
        })(event);
    });
    window.addEventListener("gadget:devharness:stubbedActionError", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const eventDetail = event.detail;
            debug("received stubbed action message", {
                eventDetail
            });
            let title;
            switch(eventDetail.reason){
                case "MissingApiTrigger":
                    title = "Missing API trigger";
                    break;
                default:
                    throw new Error(`Unknown stubbed action reason: ${eventDetail.reason}`);
            }
            const { modelApiIdentifier, actionApiIdentifier, dataPath } = eventDetail.action;
            const namespace = dataPath.split(".").slice(0, modelApiIdentifier ? -2 : -1);
            const stubbedActionMessage = {
                id: nanoid(),
                type: "error",
                maxMessages: 1,
                title,
                actions: [
                    {
                        text: `Add an API trigger to \`${modelApiIdentifier ? "models/" : ""}${dataPath.replaceAll(".", "/")}\``,
                        input: {
                            uniqueId: `add-api-trigger-${dataPath}`,
                            required: true,
                            type: "checkbox",
                            name: "addApiTrigger",
                            defaultValue: encodeURI(JSON.stringify({
                                model: modelApiIdentifier,
                                action: actionApiIdentifier,
                                namespace
                            }))
                        }
                    }
                ],
                links: []
            };
            devHarness.addMessage(stubbedActionMessage);
        })(event);
    });
    window.addEventListener("gadget:devharness:graphqlresult", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const eventDetail = event.detail;
            let errorMessage;
            if (eventDetail.data == null || eventDetail.data == undefined) {
                errorMessage = eventDetail?.error?.message;
            } else {
                const operation = eventDetail?.operation?.context?.operationName;
                errorMessage = eventDetail?.data[operation]?.errors?.[0]?.message ?? eventDetail?.error?.message;
            }
            if (errorMessage && errorMessage.includes("GGT_PERMISSION_DENIED")) {
                errorMessage = errorMessage.replace(/^\[GraphQL]\s*/, "");
                const urlMatch = errorMessage.match(/. To learn more: (https?:\/\/[^\s]+)./);
                const url = urlMatch ? urlMatch[1] : null;
                errorMessage = errorMessage.replace(/. To learn more: (https?:\/\/[^\s]+)./, "");
                errorMessage = errorMessage.replace(/GGT_PERMISSION_DENIED:+\s+/, "");
                const formattedErrorMessage = errorMessage.replaceAll(/`([^`]+)`/g, "<strong>$1</strong>");
                const graphqlMessage = {
                    id: nanoid(),
                    type: "error",
                    maxMessages: 3,
                    title: "GGT_PERMISSION_DENIED",
                    fixAction: {
                        type: "fix-prompt",
                        prompt: `Can you fix the following error?\n\n${errorMessage}`
                    },
                    body: formattedErrorMessage + ".",
                    links: [
                        {
                            href: url ?? "https://docs.gadget.dev/guides/access-control",
                            linkText: "Learn more"
                        }
                    ]
                };
                devHarness.addMessage(graphqlMessage);
                navigator?.sendBeacon("/api/dev-harness/track", JSON.stringify({
                    event: "GraphQL Error Message Shown"
                }));
            }
        })(event);
    });
    window.addEventListener("gadget:devharness:rsab.shopifyManagedInstallation.missingScopes", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const missingScopes = event.detail?.missingScopes;
            if (missingScopes && missingScopes.length > 0) {
                const scopesMessage = {
                    id: nanoid(),
                    type: "error",
                    maxMessages: 1,
                    title: "Missing scopes",
                    body: "The following API scopes in your Shopify connection settings are missing from shopify.app.toml: " + "- " + missingScopes.join("\n- "),
                    fixAction: {
                        type: "fix-prompt",
                        prompt: `I am missing the following shopify scopes in my toml configuration:\n\n${missingScopes.join("\n")}\n\n Help me fix this.`
                    },
                    links: [
                        {
                            href: "https://docs.gadget.dev/guides/plugins/shopify/oauth#shopify-managed-installation-for-gadget-apps",
                            linkText: "Learn more"
                        }
                    ]
                };
                devHarness.addMessage(scopesMessage);
            }
        })(event);
    });
    window.addEventListener("gadget:devharness:requiresShopifyOnboarding", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const storage = getDevHarnessStorage();
            if (storage.missingShopifyOnboardingDismissed) return;
            const host = event.detail?.host;
            const onboardingMessage = {
                id: nanoid(),
                type: "info",
                maxMessages: 1,
                title: "Access your frontend through Shopify",
                body: "This app is set up to be embedded within the Shopify admin.",
                links: [
                    {
                        href: `https://${devHarness.appName}.${host}/edit/${devHarness.environmentSlug}/connections/shopify`,
                        linkText: "Connect to Shopify"
                    }
                ],
                style: {
                    backgroundImage: `url('data:image/svg+xml;base64,${btoa(bg_shop_notification_namespaceObject)}')`,
                    backgroundColor: "#fff",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right"
                },
                onDismissConfig: {
                    storageUpdate: {
                        missingShopifyOnboardingDismissed: true
                    }
                }
            };
            devHarness.addMessage(onboardingMessage);
        })(event);
    });
    window.addEventListener("gadget:devharness:requiresBigCommerceOnboarding", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const storage = getDevHarnessStorage();
            if (storage.missingBigCommerceOnboardingDismissed) return;
            const host = event.detail?.host;
            const onboardingMessage = {
                id: nanoid(),
                type: "info",
                maxMessages: 1,
                title: "Access your frontend through BigCommerce",
                body: "<div>This app is set up to be embedded within the BigCommerce <br> control panel.<div>",
                links: [
                    {
                        href: `https://${devHarness.appName}.${host}/edit/${devHarness.environmentSlug}/connections/bigcommerce`,
                        linkText: "Connect to BigCommerce"
                    }
                ],
                style: {
                    backgroundImage: `url('data:image/svg+xml;base64,${btoa(bg_bigcommerce_notification_namespaceObject)}')`,
                    backgroundColor: "#fff",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right"
                },
                onDismissConfig: {
                    storageUpdate: {
                        missingBigCommerceOnboardingDismissed: true
                    }
                }
            };
            devHarness.addMessage(onboardingMessage);
        })(event);
    });
    window.addEventListener("gadget:viteError", (event)=>{
        void (async (event)=>{
            const devHarness = await getDevHarness();
            if (!devHarness) return;
            const storage = getDevHarnessStorage();
            if (storage.missingShopifyOnboardingDismissed) return;
            const eventData = event.detail;
            const message = eventData?.message ?? "Unknown vite error.";
            if (!shouldShowDeveloperError(message)) return;
            const links = [];
            if (eventData?.linksDomain) {
                links.push({
                    href: `${eventData.linksDomain}restart/${eventData.environmentId}`,
                    linkText: "Restart app"
                });
            }
            const viteErrorMessage = {
                id: nanoid(),
                type: "error",
                maxMessages: 1,
                title: "Vite error",
                body: `${message} Please refresh the page, or if the error persists restart your app.`,
                links
            };
            devHarness.addMessage(viteErrorMessage);
        })(event);
    });
    // subscribe to server side pushed events via the app's GraphQL API
    const url = new URL(window.location.href);
    url.pathname = "/api/graphql";
    url.search = "";
    const connection = new GadgetConnection({
        endpoint: url.toString()
    });
    const harnessVariables = {
        cursor: getCurrentHarnessEventCursor()
    };
    connection.currentClient.subscription("subscription HarnessEvents($cursor: String) { gadgetMetaHarnessEvents(cursor: $cursor) { id event } }", harnessVariables)// eslint-disable-next-line @typescript-eslint/no-misused-promises
    .subscribe(async (result)=>{
        if (result.data) {
            const { id, event } = result.data.gadgetMetaHarnessEvents;
            // update variables in place to ensure re-subscriptions start from the latest cursor
            harnessVariables.cursor = id;
            setCurrentHarnessEventCursor(id);
            switch(event.type){
                case "test":
                    {
                        break;
                    }
                case "error":
                    {
                        const devHarness = await getDevHarness();
                        if (!devHarness) return;
                        const message = {
                            id,
                            type: "error",
                            title: event.title,
                            body: event.body,
                            maxMessages: event.maxMessages ?? 1,
                            links: event.links ?? [],
                            fixAction: event.fixAction
                        };
                        devHarness.addMessage(message);
                        break;
                    }
                default:
                    {
                        debug("unknown server event type", event);
                        break;
                    }
            }
        }
    });
}
const shouldShowDeveloperError = (message)=>{
    if (message.includes("Hydration failed because the initial UI does not match what was rendered on the server.") || message.includes("Switched to client rendering")) {
        // hide react hydration errors -- too many browser extensions or other issues cause them and we dont want users distracted by them when its not really their fault
        return false;
    }
    return true;
};

/******/ })()
;